const Lb = 50, zb = "bnk_", Fb = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    label: "front photo",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    label: "3/4 front left",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    label: "left side photo",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    label: "3/4 left rear side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    label: "rear hatch closed",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    label: "3/4 right rear doors closed",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    label: "right side doors closed",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    label: "turntable external (18m)",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    label: "3/4 front right doors",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    label: "3/4 right front doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    label: "front door 1 open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    label: "right side doors open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    label: "front door 2 open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    label: "front door 3 open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    label: "3/4 right rear doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    label: "luggage rack photo",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    label: "internal frame rust check",
    group: "exteriors",
    description: "A photo showing the internal frame of the vehicle to check for potential rust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    label: "under carpet photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    label: "rear hatch open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    label: "air conditioning compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    label: "preheater webasto photo",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "fire extinguishing system",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    label: "platform open photo",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    label: "platform code photo",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    label: "vehicle plate photo",
    group: "exteriors",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    label: "seat plate photo",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    label: "driver microphone accessories photo",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    label: "driver's seat photo",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    label: "steering wheel photo",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    label: "dashboard lights on",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    label: "buttons panels on",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    label: "radio accessories photo",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    label: "onboard devices 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    label: "onboard devices 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    label: "command unit indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    label: "hostess seat photo",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    label: "hostes microphone accessories photo",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    label: "door mechanism photo",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    label: "interior reverse seats driver height",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    label: "reverse view middle aisle",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    label: "forward view all seats last row height",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    label: "overhead compartments photo",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    label: "toilette accessories photo",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    label: "forward view middle aisle",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    label: "turntable internal (18m)",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    label: "roof hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    label: "roof hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    label: "roof hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    label: "disabled area photo",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    label: "folding seat photo",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    label: "single seat detail",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    label: "mesh detail photo",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    label: "table detail photo",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    label: "usb charging detail",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    label: "armrest detail photo",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    label: "footrest detail photo",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    label: "monitor detail photo",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    label: "power outlets detail",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    label: "coffee machine accessories",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    label: "seat brackets photo",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    label: "camera accessories photo",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    label: "spare wheel",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    label: "front left tire measurements",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    label: "rear left tire photo",
    group: "tire-sizes",
    description: "A photo showing the rear left tire of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    label: "tread condition front tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    label: "tread condition front tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    label: "tread condition second axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    label: "tread condition second axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    label: "tread condition third axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    label: "tread condition third axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    label: "front undercarriage from front",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    label: "front axle right side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    label: "front discs right",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    label: "front brake calipers right",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    label: "front shock absorbers right",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    label: "front air springs right",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    label: "front axle central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    label: "front axle left side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    label: "front discs left",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    label: "front brake calipers left",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    label: "front shock absorbers left",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    label: "front air springs left",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    label: "central undercarriage photo",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    label: "axle 2 discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    label: "axle 2 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "axle 2 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    label: "axel 2 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    label: "axel 2 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    label: "axle 2 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    label: "axle 2 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    label: "axle 2 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    label: "axel 2 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    label: "axel 2 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    label: "axle 3 central",
    group: "undercarriage",
    description: "A photo of the central part of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    label: "axle 3 right side",
    group: "undercarriage",
    description: "A photo of the right side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    label: "axel 3  discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    label: "axel 3 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    label: "axel 3 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    label: "axle 3 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    label: "axel 3 shock absorbers 2 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    label: "axle 3 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    label: "axle 3 left side",
    group: "undercarriage",
    description: "A photo of the left side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    label: "axel 3 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    label: "axel 3 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    label: "axel 3 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    label: "axel 3 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    label: "axle 3 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    label: "axle 3 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    label: "differential photo",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    label: "gearbox photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    label: "gearbox plate photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    label: "driveshaft photo",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    label: "engine without protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    label: "exhaust photo",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    label: "bellows turntable (18m)",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    label: "chassis VIN photo",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    label: "onboard devices 3",
    group: "technical-data",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  }
}, Ob = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, ig = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], ag = [
  {
    name: "Abruzzo",
    code: "IT-65",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], sg = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], ug = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], lg = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czechia",
      it: "Cechia",
      es: "Chequia",
      de: "Tschechien",
      pl: "Czechy",
      fr: "Tchéquie",
      nl: "Tsjechië",
      pt: "Chéquia",
      cs: "Česko",
      ro: "Cehia",
      ru: "Чехия"
    },
    rootIddCode: "+420",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    blocMemberships: ["EU"],
    regions: ig,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    blocMemberships: ["EU"],
    regions: ug,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    blocMemberships: ["EU"],
    regions: ag,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    blocMemberships: ["EU"],
    regions: sg,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263"
  }
}, Nu = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function Gb(r) {
  if (dg(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return r;
}
function dg(r) {
  return typeof r == "string" && Nu.includes(r);
}
const yu = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function cg(r) {
  return typeof r == "string" && Object.values(yu).includes(r);
}
function Zb(r) {
  if (cg(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return r;
}
function Db(r) {
  return yu[r];
}
const Ub = 10 * 1024 * 1024, $b = "pdf", Kb = Object.fromEntries(
  Object.entries(lg).map(([r, t]) => [
    r,
    ("regions" in t ? t.regions : []).flatMap(
      (i) => ("provinces" in i ? i.provinces : []).map((s) => s)
    )
  ])
);
function T(r, t, i) {
  function s(C, w) {
    var N;
    Object.defineProperty(C, "_zod", {
      value: C._zod ?? {},
      enumerable: !1
    }), (N = C._zod).traits ?? (N.traits = /* @__PURE__ */ new Set()), C._zod.traits.add(r), t(C, w);
    for (const Z in _.prototype)
      Z in C || Object.defineProperty(C, Z, { value: _.prototype[Z].bind(C) });
    C._zod.constr = _, C._zod.def = w;
  }
  const d = i?.Parent ?? Object;
  class h extends d {
  }
  Object.defineProperty(h, "name", { value: r });
  function _(C) {
    var w;
    const N = i?.Parent ? new h() : this;
    s(N, C), (w = N._zod).deferred ?? (w.deferred = []);
    for (const Z of N._zod.deferred)
      Z();
    return N;
  }
  return Object.defineProperty(_, "init", { value: s }), Object.defineProperty(_, Symbol.hasInstance, {
    value: (C) => i?.Parent && C instanceof i.Parent ? !0 : C?._zod?.traits?.has(r)
  }), Object.defineProperty(_, "name", { value: r }), _;
}
class ir extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class ku extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Bu = {};
function Fn(r) {
  return Bu;
}
function pg(r) {
  const t = Object.values(r).filter((s) => typeof s == "number");
  return Object.entries(r).filter(([s, d]) => t.indexOf(+s) === -1).map(([s, d]) => d);
}
function hi(r, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ii(r) {
  return {
    get value() {
      {
        const t = r();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function bi(r) {
  return r == null;
}
function Si(r) {
  const t = r.startsWith("^") ? 1 : 0, i = r.endsWith("$") ? r.length - 1 : r.length;
  return r.slice(t, i);
}
function fg(r, t) {
  const i = (r.toString().split(".")[1] || "").length, s = t.toString();
  let d = (s.split(".")[1] || "").length;
  if (d === 0 && /\d?e-\d?/.test(s)) {
    const w = s.match(/\d?e-(\d?)/);
    w?.[1] && (d = Number.parseInt(w[1]));
  }
  const h = i > d ? i : d, _ = Number.parseInt(r.toFixed(h).replace(".", "")), C = Number.parseInt(t.toFixed(h).replace(".", ""));
  return _ % C / 10 ** h;
}
const iu = /* @__PURE__ */ Symbol("evaluating");
function V(r, t, i) {
  let s;
  Object.defineProperty(r, t, {
    get() {
      if (s !== iu)
        return s === void 0 && (s = iu, s = i()), s;
    },
    set(d) {
      Object.defineProperty(r, t, {
        value: d
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Gn(r, t, i) {
  Object.defineProperty(r, t, {
    value: i,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Zn(...r) {
  const t = {};
  for (const i of r) {
    const s = Object.getOwnPropertyDescriptors(i);
    Object.assign(t, s);
  }
  return Object.defineProperties({}, t);
}
function au(r) {
  return JSON.stringify(r);
}
const Pu = "captureStackTrace" in Error ? Error.captureStackTrace : (...r) => {
};
function zt(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r);
}
const hg = Ii(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const r = Function;
    return new r(""), !0;
  } catch {
    return !1;
  }
});
function Rr(r) {
  if (zt(r) === !1)
    return !1;
  const t = r.constructor;
  if (t === void 0)
    return !0;
  const i = t.prototype;
  return !(zt(i) === !1 || Object.prototype.hasOwnProperty.call(i, "isPrototypeOf") === !1);
}
function Ru(r) {
  return Rr(r) ? { ...r } : Array.isArray(r) ? [...r] : r;
}
const _g = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function ar(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Mn(r, t, i) {
  const s = new r._zod.constr(t ?? r._zod.def);
  return (!t || i?.parent) && (s._zod.parent = r), s;
}
function y(r) {
  const t = r;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function mg(r) {
  return Object.keys(r).filter((t) => r[t]._zod.optin === "optional" && r[t]._zod.optout === "optional");
}
const gg = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function vg(r, t) {
  const i = r._zod.def, s = Zn(r._zod.def, {
    get shape() {
      const d = {};
      for (const h in t) {
        if (!(h in i.shape))
          throw new Error(`Unrecognized key: "${h}"`);
        t[h] && (d[h] = i.shape[h]);
      }
      return Gn(this, "shape", d), d;
    },
    checks: []
  });
  return Mn(r, s);
}
function Ig(r, t) {
  const i = r._zod.def, s = Zn(r._zod.def, {
    get shape() {
      const d = { ...r._zod.def.shape };
      for (const h in t) {
        if (!(h in i.shape))
          throw new Error(`Unrecognized key: "${h}"`);
        t[h] && delete d[h];
      }
      return Gn(this, "shape", d), d;
    },
    checks: []
  });
  return Mn(r, s);
}
function bg(r, t) {
  if (!Rr(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const i = r._zod.def.checks;
  if (i && i.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const d = Zn(r._zod.def, {
    get shape() {
      const h = { ...r._zod.def.shape, ...t };
      return Gn(this, "shape", h), h;
    },
    checks: []
  });
  return Mn(r, d);
}
function Sg(r, t) {
  if (!Rr(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const i = {
    ...r._zod.def,
    get shape() {
      const s = { ...r._zod.def.shape, ...t };
      return Gn(this, "shape", s), s;
    },
    checks: r._zod.def.checks
  };
  return Mn(r, i);
}
function Tg(r, t) {
  const i = Zn(r._zod.def, {
    get shape() {
      const s = { ...r._zod.def.shape, ...t._zod.def.shape };
      return Gn(this, "shape", s), s;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Mn(r, i);
}
function Ag(r, t, i) {
  const s = Zn(t._zod.def, {
    get shape() {
      const d = t._zod.def.shape, h = { ...d };
      if (i)
        for (const _ in i) {
          if (!(_ in d))
            throw new Error(`Unrecognized key: "${_}"`);
          i[_] && (h[_] = r ? new r({
            type: "optional",
            innerType: d[_]
          }) : d[_]);
        }
      else
        for (const _ in d)
          h[_] = r ? new r({
            type: "optional",
            innerType: d[_]
          }) : d[_];
      return Gn(this, "shape", h), h;
    },
    checks: []
  });
  return Mn(t, s);
}
function Cg(r, t, i) {
  const s = Zn(t._zod.def, {
    get shape() {
      const d = t._zod.def.shape, h = { ...d };
      if (i)
        for (const _ in i) {
          if (!(_ in h))
            throw new Error(`Unrecognized key: "${_}"`);
          i[_] && (h[_] = new r({
            type: "nonoptional",
            innerType: d[_]
          }));
        }
      else
        for (const _ in d)
          h[_] = new r({
            type: "nonoptional",
            innerType: d[_]
          });
      return Gn(this, "shape", h), h;
    },
    checks: []
  });
  return Mn(t, s);
}
function tr(r, t = 0) {
  if (r.aborted === !0)
    return !0;
  for (let i = t; i < r.issues.length; i++)
    if (r.issues[i]?.continue !== !0)
      return !0;
  return !1;
}
function Lu(r, t) {
  return t.map((i) => {
    var s;
    return (s = i).path ?? (s.path = []), i.path.unshift(r), i;
  });
}
function kt(r) {
  return typeof r == "string" ? r : r?.message;
}
function On(r, t, i) {
  const s = { ...r, path: r.path ?? [] };
  if (!r.message) {
    const d = kt(r.inst?._zod.def?.error?.(r)) ?? kt(t?.error?.(r)) ?? kt(i.customError?.(r)) ?? kt(i.localeError?.(r)) ?? "Invalid input";
    s.message = d;
  }
  return delete s.inst, delete s.continue, t?.reportInput || delete s.input, s;
}
function Ti(r) {
  return Array.isArray(r) ? "array" : typeof r == "string" ? "string" : "unknown";
}
function Lr(...r) {
  const [t, i, s] = r;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: i,
    inst: s
  } : { ...t };
}
const zu = (r, t) => {
  r.name = "$ZodError", Object.defineProperty(r, "_zod", {
    value: r._zod,
    enumerable: !1
  }), Object.defineProperty(r, "issues", {
    value: t,
    enumerable: !1
  }), r.message = JSON.stringify(t, hi, 2), Object.defineProperty(r, "toString", {
    value: () => r.message,
    enumerable: !1
  });
}, Fu = T("$ZodError", zu), Ou = T("$ZodError", zu, { Parent: Error });
function xg(r, t = (i) => i.message) {
  const i = {}, s = [];
  for (const d of r.issues)
    d.path.length > 0 ? (i[d.path[0]] = i[d.path[0]] || [], i[d.path[0]].push(t(d))) : s.push(t(d));
  return { formErrors: s, fieldErrors: i };
}
function Mg(r, t = (i) => i.message) {
  const i = { _errors: [] }, s = (d) => {
    for (const h of d.issues)
      if (h.code === "invalid_union" && h.errors.length)
        h.errors.map((_) => s({ issues: _ }));
      else if (h.code === "invalid_key")
        s({ issues: h.issues });
      else if (h.code === "invalid_element")
        s({ issues: h.issues });
      else if (h.path.length === 0)
        i._errors.push(t(h));
      else {
        let _ = i, C = 0;
        for (; C < h.path.length; ) {
          const w = h.path[C];
          C === h.path.length - 1 ? (_[w] = _[w] || { _errors: [] }, _[w]._errors.push(t(h))) : _[w] = _[w] || { _errors: [] }, _ = _[w], C++;
        }
      }
  };
  return s(r), i;
}
const Ai = (r) => (t, i, s, d) => {
  const h = s ? Object.assign(s, { async: !1 }) : { async: !1 }, _ = t._zod.run({ value: i, issues: [] }, h);
  if (_ instanceof Promise)
    throw new ir();
  if (_.issues.length) {
    const C = new (d?.Err ?? r)(_.issues.map((w) => On(w, h, Fn())));
    throw Pu(C, d?.callee), C;
  }
  return _.value;
}, Ci = (r) => async (t, i, s, d) => {
  const h = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let _ = t._zod.run({ value: i, issues: [] }, h);
  if (_ instanceof Promise && (_ = await _), _.issues.length) {
    const C = new (d?.Err ?? r)(_.issues.map((w) => On(w, h, Fn())));
    throw Pu(C, d?.callee), C;
  }
  return _.value;
}, Gt = (r) => (t, i, s) => {
  const d = s ? { ...s, async: !1 } : { async: !1 }, h = t._zod.run({ value: i, issues: [] }, d);
  if (h instanceof Promise)
    throw new ir();
  return h.issues.length ? {
    success: !1,
    error: new (r ?? Fu)(h.issues.map((_) => On(_, d, Fn())))
  } : { success: !0, data: h.value };
}, wg = /* @__PURE__ */ Gt(Ou), Zt = (r) => async (t, i, s) => {
  const d = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let h = t._zod.run({ value: i, issues: [] }, d);
  return h instanceof Promise && (h = await h), h.issues.length ? {
    success: !1,
    error: new r(h.issues.map((_) => On(_, d, Fn())))
  } : { success: !0, data: h.value };
}, Eg = /* @__PURE__ */ Zt(Ou), Ng = (r) => (t, i, s) => {
  const d = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Ai(r)(t, i, d);
}, yg = (r) => (t, i, s) => Ai(r)(t, i, s), kg = (r) => async (t, i, s) => {
  const d = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Ci(r)(t, i, d);
}, Bg = (r) => async (t, i, s) => Ci(r)(t, i, s), Pg = (r) => (t, i, s) => {
  const d = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Gt(r)(t, i, d);
}, Rg = (r) => (t, i, s) => Gt(r)(t, i, s), Lg = (r) => async (t, i, s) => {
  const d = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Zt(r)(t, i, d);
}, zg = (r) => async (t, i, s) => Zt(r)(t, i, s), Fg = /^[cC][^\s-]{8,}$/, Og = /^[0-9a-z]+$/, Gg = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Zg = /^[0-9a-vA-V]{20}$/, Dg = /^[A-Za-z0-9]{27}$/, Ug = /^[a-zA-Z0-9_-]{21}$/, $g = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Kg = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, su = (r) => r ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${r}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Hg = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Wg = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function qg() {
  return new RegExp(Wg, "u");
}
const Vg = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Jg = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, jg = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Yg = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Xg = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Gu = /^[A-Za-z0-9_-]*$/, Qg = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, ev = /^\+(?:[0-9]){6,14}[0-9]$/, Zu = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", nv = /* @__PURE__ */ new RegExp(`^${Zu}$`);
function Du(r) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof r.precision == "number" ? r.precision === -1 ? `${t}` : r.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${r.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function rv(r) {
  return new RegExp(`^${Du(r)}$`);
}
function tv(r) {
  const t = Du({ precision: r.precision }), i = ["Z"];
  r.local && i.push(""), r.offset && i.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const s = `${t}(?:${i.join("|")})`;
  return new RegExp(`^${Zu}T(?:${s})$`);
}
const ov = (r) => {
  const t = r ? `[\\s\\S]{${r?.minimum ?? 0},${r?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, iv = /^-?\d+$/, av = /^-?\d+(?:\.\d+)?/, sv = /^[^A-Z]*$/, uv = /^[^a-z]*$/, Ee = /* @__PURE__ */ T("$ZodCheck", (r, t) => {
  var i;
  r._zod ?? (r._zod = {}), r._zod.def = t, (i = r._zod).onattach ?? (i.onattach = []);
}), Uu = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, $u = /* @__PURE__ */ T("$ZodCheckLessThan", (r, t) => {
  Ee.init(r, t);
  const i = Uu[typeof t.value];
  r._zod.onattach.push((s) => {
    const d = s._zod.bag, h = (t.inclusive ? d.maximum : d.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < h && (t.inclusive ? d.maximum = t.value : d.exclusiveMaximum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value <= t.value : s.value < t.value) || s.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), Ku = /* @__PURE__ */ T("$ZodCheckGreaterThan", (r, t) => {
  Ee.init(r, t);
  const i = Uu[typeof t.value];
  r._zod.onattach.push((s) => {
    const d = s._zod.bag, h = (t.inclusive ? d.minimum : d.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > h && (t.inclusive ? d.minimum = t.value : d.exclusiveMinimum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value >= t.value : s.value > t.value) || s.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), lv = /* @__PURE__ */ T("$ZodCheckMultipleOf", (r, t) => {
  Ee.init(r, t), r._zod.onattach.push((i) => {
    var s;
    (s = i._zod.bag).multipleOf ?? (s.multipleOf = t.value);
  }), r._zod.check = (i) => {
    if (typeof i.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof i.value == "bigint" ? i.value % t.value === BigInt(0) : fg(i.value, t.value) === 0) || i.issues.push({
      origin: typeof i.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: i.value,
      inst: r,
      continue: !t.abort
    });
  };
}), dv = /* @__PURE__ */ T("$ZodCheckNumberFormat", (r, t) => {
  Ee.init(r, t), t.format = t.format || "float64";
  const i = t.format?.includes("int"), s = i ? "int" : "number", [d, h] = gg[t.format];
  r._zod.onattach.push((_) => {
    const C = _._zod.bag;
    C.format = t.format, C.minimum = d, C.maximum = h, i && (C.pattern = iv);
  }), r._zod.check = (_) => {
    const C = _.value;
    if (i) {
      if (!Number.isInteger(C)) {
        _.issues.push({
          expected: s,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: C,
          inst: r
        });
        return;
      }
      if (!Number.isSafeInteger(C)) {
        C > 0 ? _.issues.push({
          input: C,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          continue: !t.abort
        }) : _.issues.push({
          input: C,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          continue: !t.abort
        });
        return;
      }
    }
    C < d && _.issues.push({
      origin: "number",
      input: C,
      code: "too_small",
      minimum: d,
      inclusive: !0,
      inst: r,
      continue: !t.abort
    }), C > h && _.issues.push({
      origin: "number",
      input: C,
      code: "too_big",
      maximum: h,
      inst: r
    });
  };
}), cv = /* @__PURE__ */ T("$ZodCheckMaxLength", (r, t) => {
  var i;
  Ee.init(r, t), (i = r._zod.def).when ?? (i.when = (s) => {
    const d = s.value;
    return !bi(d) && d.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const d = s._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < d && (s._zod.bag.maximum = t.maximum);
  }), r._zod.check = (s) => {
    const d = s.value;
    if (d.length <= t.maximum)
      return;
    const _ = Ti(d);
    s.issues.push({
      origin: _,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: d,
      inst: r,
      continue: !t.abort
    });
  };
}), pv = /* @__PURE__ */ T("$ZodCheckMinLength", (r, t) => {
  var i;
  Ee.init(r, t), (i = r._zod.def).when ?? (i.when = (s) => {
    const d = s.value;
    return !bi(d) && d.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const d = s._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > d && (s._zod.bag.minimum = t.minimum);
  }), r._zod.check = (s) => {
    const d = s.value;
    if (d.length >= t.minimum)
      return;
    const _ = Ti(d);
    s.issues.push({
      origin: _,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: d,
      inst: r,
      continue: !t.abort
    });
  };
}), fv = /* @__PURE__ */ T("$ZodCheckLengthEquals", (r, t) => {
  var i;
  Ee.init(r, t), (i = r._zod.def).when ?? (i.when = (s) => {
    const d = s.value;
    return !bi(d) && d.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const d = s._zod.bag;
    d.minimum = t.length, d.maximum = t.length, d.length = t.length;
  }), r._zod.check = (s) => {
    const d = s.value, h = d.length;
    if (h === t.length)
      return;
    const _ = Ti(d), C = h > t.length;
    s.issues.push({
      origin: _,
      ...C ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Dt = /* @__PURE__ */ T("$ZodCheckStringFormat", (r, t) => {
  var i, s;
  Ee.init(r, t), r._zod.onattach.push((d) => {
    const h = d._zod.bag;
    h.format = t.format, t.pattern && (h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(t.pattern));
  }), t.pattern ? (i = r._zod).check ?? (i.check = (d) => {
    t.pattern.lastIndex = 0, !t.pattern.test(d.value) && d.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: d.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: r,
      continue: !t.abort
    });
  }) : (s = r._zod).check ?? (s.check = () => {
  });
}), hv = /* @__PURE__ */ T("$ZodCheckRegex", (r, t) => {
  Dt.init(r, t), r._zod.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: i.value,
      pattern: t.pattern.toString(),
      inst: r,
      continue: !t.abort
    });
  };
}), _v = /* @__PURE__ */ T("$ZodCheckLowerCase", (r, t) => {
  t.pattern ?? (t.pattern = sv), Dt.init(r, t);
}), mv = /* @__PURE__ */ T("$ZodCheckUpperCase", (r, t) => {
  t.pattern ?? (t.pattern = uv), Dt.init(r, t);
}), gv = /* @__PURE__ */ T("$ZodCheckIncludes", (r, t) => {
  Ee.init(r, t);
  const i = ar(t.includes), s = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${i}` : i);
  t.pattern = s, r._zod.onattach.push((d) => {
    const h = d._zod.bag;
    h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(s);
  }), r._zod.check = (d) => {
    d.value.includes(t.includes, t.position) || d.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: d.value,
      inst: r,
      continue: !t.abort
    });
  };
}), vv = /* @__PURE__ */ T("$ZodCheckStartsWith", (r, t) => {
  Ee.init(r, t);
  const i = new RegExp(`^${ar(t.prefix)}.*`);
  t.pattern ?? (t.pattern = i), r._zod.onattach.push((s) => {
    const d = s._zod.bag;
    d.patterns ?? (d.patterns = /* @__PURE__ */ new Set()), d.patterns.add(i);
  }), r._zod.check = (s) => {
    s.value.startsWith(t.prefix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Iv = /* @__PURE__ */ T("$ZodCheckEndsWith", (r, t) => {
  Ee.init(r, t);
  const i = new RegExp(`.*${ar(t.suffix)}$`);
  t.pattern ?? (t.pattern = i), r._zod.onattach.push((s) => {
    const d = s._zod.bag;
    d.patterns ?? (d.patterns = /* @__PURE__ */ new Set()), d.patterns.add(i);
  }), r._zod.check = (s) => {
    s.value.endsWith(t.suffix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), bv = /* @__PURE__ */ T("$ZodCheckOverwrite", (r, t) => {
  Ee.init(r, t), r._zod.check = (i) => {
    i.value = t.tx(i.value);
  };
});
class Sv {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const s = t.split(`
`).filter((_) => _), d = Math.min(...s.map((_) => _.length - _.trimStart().length)), h = s.map((_) => _.slice(d)).map((_) => " ".repeat(this.indent * 2) + _);
    for (const _ of h)
      this.content.push(_);
  }
  compile() {
    const t = Function, i = this?.args, d = [...(this?.content ?? [""]).map((h) => `  ${h}`)];
    return new t(...i, d.join(`
`));
  }
}
const Tv = {
  major: 4,
  minor: 1,
  patch: 12
}, ae = /* @__PURE__ */ T("$ZodType", (r, t) => {
  var i;
  r ?? (r = {}), r._zod.def = t, r._zod.bag = r._zod.bag || {}, r._zod.version = Tv;
  const s = [...r._zod.def.checks ?? []];
  r._zod.traits.has("$ZodCheck") && s.unshift(r);
  for (const d of s)
    for (const h of d._zod.onattach)
      h(r);
  if (s.length === 0)
    (i = r._zod).deferred ?? (i.deferred = []), r._zod.deferred?.push(() => {
      r._zod.run = r._zod.parse;
    });
  else {
    const d = (_, C, w) => {
      let N = tr(_), Z;
      for (const X of C) {
        if (X._zod.def.when) {
          if (!X._zod.def.when(_))
            continue;
        } else if (N)
          continue;
        const J = _.issues.length, j = X._zod.check(_);
        if (j instanceof Promise && w?.async === !1)
          throw new ir();
        if (Z || j instanceof Promise)
          Z = (Z ?? Promise.resolve()).then(async () => {
            await j, _.issues.length !== J && (N || (N = tr(_, J)));
          });
        else {
          if (_.issues.length === J)
            continue;
          N || (N = tr(_, J));
        }
      }
      return Z ? Z.then(() => _) : _;
    }, h = (_, C, w) => {
      if (tr(_))
        return _.aborted = !0, _;
      const N = d(C, s, w);
      if (N instanceof Promise) {
        if (w.async === !1)
          throw new ir();
        return N.then((Z) => r._zod.parse(Z, w));
      }
      return r._zod.parse(N, w);
    };
    r._zod.run = (_, C) => {
      if (C.skipChecks)
        return r._zod.parse(_, C);
      if (C.direction === "backward") {
        const N = r._zod.parse({ value: _.value, issues: [] }, { ...C, skipChecks: !0 });
        return N instanceof Promise ? N.then((Z) => h(Z, _, C)) : h(N, _, C);
      }
      const w = r._zod.parse(_, C);
      if (w instanceof Promise) {
        if (C.async === !1)
          throw new ir();
        return w.then((N) => d(N, s, C));
      }
      return d(w, s, C);
    };
  }
  r["~standard"] = {
    validate: (d) => {
      try {
        const h = wg(r, d);
        return h.success ? { value: h.data } : { issues: h.error?.issues };
      } catch {
        return Eg(r, d).then((_) => _.success ? { value: _.data } : { issues: _.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), xi = /* @__PURE__ */ T("$ZodString", (r, t) => {
  ae.init(r, t), r._zod.pattern = [...r?._zod.bag?.patterns ?? []].pop() ?? ov(r._zod.bag), r._zod.parse = (i, s) => {
    if (t.coerce)
      try {
        i.value = String(i.value);
      } catch {
      }
    return typeof i.value == "string" || i.issues.push({
      expected: "string",
      code: "invalid_type",
      input: i.value,
      inst: r
    }), i;
  };
}), ee = /* @__PURE__ */ T("$ZodStringFormat", (r, t) => {
  Dt.init(r, t), xi.init(r, t);
}), Av = /* @__PURE__ */ T("$ZodGUID", (r, t) => {
  t.pattern ?? (t.pattern = Kg), ee.init(r, t);
}), Cv = /* @__PURE__ */ T("$ZodUUID", (r, t) => {
  if (t.version) {
    const s = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (s === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = su(s));
  } else
    t.pattern ?? (t.pattern = su());
  ee.init(r, t);
}), xv = /* @__PURE__ */ T("$ZodEmail", (r, t) => {
  t.pattern ?? (t.pattern = Hg), ee.init(r, t);
}), Mv = /* @__PURE__ */ T("$ZodURL", (r, t) => {
  ee.init(r, t), r._zod.check = (i) => {
    try {
      const s = i.value.trim(), d = new URL(s);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(d.hostname) || i.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Qg.source,
        input: i.value,
        inst: r,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(d.protocol.endsWith(":") ? d.protocol.slice(0, -1) : d.protocol) || i.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: i.value,
        inst: r,
        continue: !t.abort
      })), t.normalize ? i.value = d.href : i.value = s;
      return;
    } catch {
      i.issues.push({
        code: "invalid_format",
        format: "url",
        input: i.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), wv = /* @__PURE__ */ T("$ZodEmoji", (r, t) => {
  t.pattern ?? (t.pattern = qg()), ee.init(r, t);
}), Ev = /* @__PURE__ */ T("$ZodNanoID", (r, t) => {
  t.pattern ?? (t.pattern = Ug), ee.init(r, t);
}), Nv = /* @__PURE__ */ T("$ZodCUID", (r, t) => {
  t.pattern ?? (t.pattern = Fg), ee.init(r, t);
}), yv = /* @__PURE__ */ T("$ZodCUID2", (r, t) => {
  t.pattern ?? (t.pattern = Og), ee.init(r, t);
}), kv = /* @__PURE__ */ T("$ZodULID", (r, t) => {
  t.pattern ?? (t.pattern = Gg), ee.init(r, t);
}), Bv = /* @__PURE__ */ T("$ZodXID", (r, t) => {
  t.pattern ?? (t.pattern = Zg), ee.init(r, t);
}), Pv = /* @__PURE__ */ T("$ZodKSUID", (r, t) => {
  t.pattern ?? (t.pattern = Dg), ee.init(r, t);
}), Rv = /* @__PURE__ */ T("$ZodISODateTime", (r, t) => {
  t.pattern ?? (t.pattern = tv(t)), ee.init(r, t);
}), Lv = /* @__PURE__ */ T("$ZodISODate", (r, t) => {
  t.pattern ?? (t.pattern = nv), ee.init(r, t);
}), zv = /* @__PURE__ */ T("$ZodISOTime", (r, t) => {
  t.pattern ?? (t.pattern = rv(t)), ee.init(r, t);
}), Fv = /* @__PURE__ */ T("$ZodISODuration", (r, t) => {
  t.pattern ?? (t.pattern = $g), ee.init(r, t);
}), Ov = /* @__PURE__ */ T("$ZodIPv4", (r, t) => {
  t.pattern ?? (t.pattern = Vg), ee.init(r, t), r._zod.onattach.push((i) => {
    const s = i._zod.bag;
    s.format = "ipv4";
  });
}), Gv = /* @__PURE__ */ T("$ZodIPv6", (r, t) => {
  t.pattern ?? (t.pattern = Jg), ee.init(r, t), r._zod.onattach.push((i) => {
    const s = i._zod.bag;
    s.format = "ipv6";
  }), r._zod.check = (i) => {
    try {
      new URL(`http://[${i.value}]`);
    } catch {
      i.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: i.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), Zv = /* @__PURE__ */ T("$ZodCIDRv4", (r, t) => {
  t.pattern ?? (t.pattern = jg), ee.init(r, t);
}), Dv = /* @__PURE__ */ T("$ZodCIDRv6", (r, t) => {
  t.pattern ?? (t.pattern = Yg), ee.init(r, t), r._zod.check = (i) => {
    const s = i.value.split("/");
    try {
      if (s.length !== 2)
        throw new Error();
      const [d, h] = s;
      if (!h)
        throw new Error();
      const _ = Number(h);
      if (`${_}` !== h)
        throw new Error();
      if (_ < 0 || _ > 128)
        throw new Error();
      new URL(`http://[${d}]`);
    } catch {
      i.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: i.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
});
function Hu(r) {
  if (r === "")
    return !0;
  if (r.length % 4 !== 0)
    return !1;
  try {
    return atob(r), !0;
  } catch {
    return !1;
  }
}
const Uv = /* @__PURE__ */ T("$ZodBase64", (r, t) => {
  t.pattern ?? (t.pattern = Xg), ee.init(r, t), r._zod.onattach.push((i) => {
    i._zod.bag.contentEncoding = "base64";
  }), r._zod.check = (i) => {
    Hu(i.value) || i.issues.push({
      code: "invalid_format",
      format: "base64",
      input: i.value,
      inst: r,
      continue: !t.abort
    });
  };
});
function $v(r) {
  if (!Gu.test(r))
    return !1;
  const t = r.replace(/[-_]/g, (s) => s === "-" ? "+" : "/"), i = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Hu(i);
}
const Kv = /* @__PURE__ */ T("$ZodBase64URL", (r, t) => {
  t.pattern ?? (t.pattern = Gu), ee.init(r, t), r._zod.onattach.push((i) => {
    i._zod.bag.contentEncoding = "base64url";
  }), r._zod.check = (i) => {
    $v(i.value) || i.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: i.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Hv = /* @__PURE__ */ T("$ZodE164", (r, t) => {
  t.pattern ?? (t.pattern = ev), ee.init(r, t);
});
function Wv(r, t = null) {
  try {
    const i = r.split(".");
    if (i.length !== 3)
      return !1;
    const [s] = i;
    if (!s)
      return !1;
    const d = JSON.parse(atob(s));
    return !("typ" in d && d?.typ !== "JWT" || !d.alg || t && (!("alg" in d) || d.alg !== t));
  } catch {
    return !1;
  }
}
const qv = /* @__PURE__ */ T("$ZodJWT", (r, t) => {
  ee.init(r, t), r._zod.check = (i) => {
    Wv(i.value, t.alg) || i.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: i.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Wu = /* @__PURE__ */ T("$ZodNumber", (r, t) => {
  ae.init(r, t), r._zod.pattern = r._zod.bag.pattern ?? av, r._zod.parse = (i, s) => {
    if (t.coerce)
      try {
        i.value = Number(i.value);
      } catch {
      }
    const d = i.value;
    if (typeof d == "number" && !Number.isNaN(d) && Number.isFinite(d))
      return i;
    const h = typeof d == "number" ? Number.isNaN(d) ? "NaN" : Number.isFinite(d) ? void 0 : "Infinity" : void 0;
    return i.issues.push({
      expected: "number",
      code: "invalid_type",
      input: d,
      inst: r,
      ...h ? { received: h } : {}
    }), i;
  };
}), Vv = /* @__PURE__ */ T("$ZodNumber", (r, t) => {
  dv.init(r, t), Wu.init(r, t);
}), Jv = /* @__PURE__ */ T("$ZodUnknown", (r, t) => {
  ae.init(r, t), r._zod.parse = (i) => i;
}), jv = /* @__PURE__ */ T("$ZodNever", (r, t) => {
  ae.init(r, t), r._zod.parse = (i, s) => (i.issues.push({
    expected: "never",
    code: "invalid_type",
    input: i.value,
    inst: r
  }), i);
});
function uu(r, t, i) {
  r.issues.length && t.issues.push(...Lu(i, r.issues)), t.value[i] = r.value;
}
const Yv = /* @__PURE__ */ T("$ZodArray", (r, t) => {
  ae.init(r, t), r._zod.parse = (i, s) => {
    const d = i.value;
    if (!Array.isArray(d))
      return i.issues.push({
        expected: "array",
        code: "invalid_type",
        input: d,
        inst: r
      }), i;
    i.value = Array(d.length);
    const h = [];
    for (let _ = 0; _ < d.length; _++) {
      const C = d[_], w = t.element._zod.run({
        value: C,
        issues: []
      }, s);
      w instanceof Promise ? h.push(w.then((N) => uu(N, i, _))) : uu(w, i, _);
    }
    return h.length ? Promise.all(h).then(() => i) : i;
  };
});
function Ft(r, t, i, s) {
  r.issues.length && t.issues.push(...Lu(i, r.issues)), r.value === void 0 ? i in s && (t.value[i] = void 0) : t.value[i] = r.value;
}
function qu(r) {
  const t = Object.keys(r.shape);
  for (const s of t)
    if (!r.shape?.[s]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const i = mg(r.shape);
  return {
    ...r,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(i)
  };
}
function Vu(r, t, i, s, d, h) {
  const _ = [], C = d.keySet, w = d.catchall._zod, N = w.def.type;
  for (const Z of Object.keys(t)) {
    if (C.has(Z))
      continue;
    if (N === "never") {
      _.push(Z);
      continue;
    }
    const X = w.run({ value: t[Z], issues: [] }, s);
    X instanceof Promise ? r.push(X.then((J) => Ft(J, i, Z, t))) : Ft(X, i, Z, t);
  }
  return _.length && i.issues.push({
    code: "unrecognized_keys",
    keys: _,
    input: t,
    inst: h
  }), r.length ? Promise.all(r).then(() => i) : i;
}
const Xv = /* @__PURE__ */ T("$ZodObject", (r, t) => {
  if (ae.init(r, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const C = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const w = { ...C };
        return Object.defineProperty(t, "shape", {
          value: w
        }), w;
      }
    });
  }
  const s = Ii(() => qu(t));
  V(r._zod, "propValues", () => {
    const C = t.shape, w = {};
    for (const N in C) {
      const Z = C[N]._zod;
      if (Z.values) {
        w[N] ?? (w[N] = /* @__PURE__ */ new Set());
        for (const X of Z.values)
          w[N].add(X);
      }
    }
    return w;
  });
  const d = zt, h = t.catchall;
  let _;
  r._zod.parse = (C, w) => {
    _ ?? (_ = s.value);
    const N = C.value;
    if (!d(N))
      return C.issues.push({
        expected: "object",
        code: "invalid_type",
        input: N,
        inst: r
      }), C;
    C.value = {};
    const Z = [], X = _.shape;
    for (const J of _.keys) {
      const se = X[J]._zod.run({ value: N[J], issues: [] }, w);
      se instanceof Promise ? Z.push(se.then((hn) => Ft(hn, C, J, N))) : Ft(se, C, J, N);
    }
    return h ? Vu(Z, N, C, w, s.value, r) : Z.length ? Promise.all(Z).then(() => C) : C;
  };
}), Qv = /* @__PURE__ */ T("$ZodObjectJIT", (r, t) => {
  Xv.init(r, t);
  const i = r._zod.parse, s = Ii(() => qu(t)), d = (J) => {
    const j = new Sv(["shape", "payload", "ctx"]), se = s.value, hn = (le) => {
      const _e = au(le);
      return `shape[${_e}]._zod.run({ value: input[${_e}], issues: [] }, ctx)`;
    };
    j.write("const input = payload.value;");
    const Te = /* @__PURE__ */ Object.create(null);
    let _n = 0;
    for (const le of se.keys)
      Te[le] = `key_${_n++}`;
    j.write("const newResult = {};");
    for (const le of se.keys) {
      const _e = Te[le], ve = au(le);
      j.write(`const ${_e} = ${hn(le)};`), j.write(`
        if (${_e}.issues.length) {
          payload.issues = payload.issues.concat(${_e}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${ve}, ...iss.path] : [${ve}]
          })));
        }
        
        
        if (${_e}.value === undefined) {
          if (${ve} in input) {
            newResult[${ve}] = undefined;
          }
        } else {
          newResult[${ve}] = ${_e}.value;
        }
        
      `);
    }
    j.write("payload.value = newResult;"), j.write("return payload;");
    const Fr = j.compile();
    return (le, _e) => Fr(J, le, _e);
  };
  let h;
  const _ = zt, C = !Bu.jitless, N = C && hg.value, Z = t.catchall;
  let X;
  r._zod.parse = (J, j) => {
    X ?? (X = s.value);
    const se = J.value;
    return _(se) ? C && N && j?.async === !1 && j.jitless !== !0 ? (h || (h = d(t.shape)), J = h(J, j), Z ? Vu([], se, J, j, X, r) : J) : i(J, j) : (J.issues.push({
      expected: "object",
      code: "invalid_type",
      input: se,
      inst: r
    }), J);
  };
});
function lu(r, t, i, s) {
  for (const h of r)
    if (h.issues.length === 0)
      return t.value = h.value, t;
  const d = r.filter((h) => !tr(h));
  return d.length === 1 ? (t.value = d[0].value, d[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: i,
    errors: r.map((h) => h.issues.map((_) => On(_, s, Fn())))
  }), t);
}
const eI = /* @__PURE__ */ T("$ZodUnion", (r, t) => {
  ae.init(r, t), V(r._zod, "optin", () => t.options.some((d) => d._zod.optin === "optional") ? "optional" : void 0), V(r._zod, "optout", () => t.options.some((d) => d._zod.optout === "optional") ? "optional" : void 0), V(r._zod, "values", () => {
    if (t.options.every((d) => d._zod.values))
      return new Set(t.options.flatMap((d) => Array.from(d._zod.values)));
  }), V(r._zod, "pattern", () => {
    if (t.options.every((d) => d._zod.pattern)) {
      const d = t.options.map((h) => h._zod.pattern);
      return new RegExp(`^(${d.map((h) => Si(h.source)).join("|")})$`);
    }
  });
  const i = t.options.length === 1, s = t.options[0]._zod.run;
  r._zod.parse = (d, h) => {
    if (i)
      return s(d, h);
    let _ = !1;
    const C = [];
    for (const w of t.options) {
      const N = w._zod.run({
        value: d.value,
        issues: []
      }, h);
      if (N instanceof Promise)
        C.push(N), _ = !0;
      else {
        if (N.issues.length === 0)
          return N;
        C.push(N);
      }
    }
    return _ ? Promise.all(C).then((w) => lu(w, d, r, h)) : lu(C, d, r, h);
  };
}), nI = /* @__PURE__ */ T("$ZodIntersection", (r, t) => {
  ae.init(r, t), r._zod.parse = (i, s) => {
    const d = i.value, h = t.left._zod.run({ value: d, issues: [] }, s), _ = t.right._zod.run({ value: d, issues: [] }, s);
    return h instanceof Promise || _ instanceof Promise ? Promise.all([h, _]).then(([w, N]) => du(i, w, N)) : du(i, h, _);
  };
});
function _i(r, t) {
  if (r === t)
    return { valid: !0, data: r };
  if (r instanceof Date && t instanceof Date && +r == +t)
    return { valid: !0, data: r };
  if (Rr(r) && Rr(t)) {
    const i = Object.keys(t), s = Object.keys(r).filter((h) => i.indexOf(h) !== -1), d = { ...r, ...t };
    for (const h of s) {
      const _ = _i(r[h], t[h]);
      if (!_.valid)
        return {
          valid: !1,
          mergeErrorPath: [h, ..._.mergeErrorPath]
        };
      d[h] = _.data;
    }
    return { valid: !0, data: d };
  }
  if (Array.isArray(r) && Array.isArray(t)) {
    if (r.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const i = [];
    for (let s = 0; s < r.length; s++) {
      const d = r[s], h = t[s], _ = _i(d, h);
      if (!_.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ..._.mergeErrorPath]
        };
      i.push(_.data);
    }
    return { valid: !0, data: i };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function du(r, t, i) {
  if (t.issues.length && r.issues.push(...t.issues), i.issues.length && r.issues.push(...i.issues), tr(r))
    return r;
  const s = _i(t.value, i.value);
  if (!s.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(s.mergeErrorPath)}`);
  return r.value = s.data, r;
}
const rI = /* @__PURE__ */ T("$ZodEnum", (r, t) => {
  ae.init(r, t);
  const i = pg(t.entries), s = new Set(i);
  r._zod.values = s, r._zod.pattern = new RegExp(`^(${i.filter((d) => _g.has(typeof d)).map((d) => typeof d == "string" ? ar(d) : d.toString()).join("|")})$`), r._zod.parse = (d, h) => {
    const _ = d.value;
    return s.has(_) || d.issues.push({
      code: "invalid_value",
      values: i,
      input: _,
      inst: r
    }), d;
  };
}), tI = /* @__PURE__ */ T("$ZodLiteral", (r, t) => {
  if (ae.init(r, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  r._zod.values = new Set(t.values), r._zod.pattern = new RegExp(`^(${t.values.map((i) => typeof i == "string" ? ar(i) : i ? ar(i.toString()) : String(i)).join("|")})$`), r._zod.parse = (i, s) => {
    const d = i.value;
    return r._zod.values.has(d) || i.issues.push({
      code: "invalid_value",
      values: t.values,
      input: d,
      inst: r
    }), i;
  };
}), oI = /* @__PURE__ */ T("$ZodTransform", (r, t) => {
  ae.init(r, t), r._zod.parse = (i, s) => {
    if (s.direction === "backward")
      throw new ku(r.constructor.name);
    const d = t.transform(i.value, i);
    if (s.async)
      return (d instanceof Promise ? d : Promise.resolve(d)).then((_) => (i.value = _, i));
    if (d instanceof Promise)
      throw new ir();
    return i.value = d, i;
  };
});
function cu(r, t) {
  return r.issues.length && t === void 0 ? { issues: [], value: void 0 } : r;
}
const iI = /* @__PURE__ */ T("$ZodOptional", (r, t) => {
  ae.init(r, t), r._zod.optin = "optional", r._zod.optout = "optional", V(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), V(r._zod, "pattern", () => {
    const i = t.innerType._zod.pattern;
    return i ? new RegExp(`^(${Si(i.source)})?$`) : void 0;
  }), r._zod.parse = (i, s) => {
    if (t.innerType._zod.optin === "optional") {
      const d = t.innerType._zod.run(i, s);
      return d instanceof Promise ? d.then((h) => cu(h, i.value)) : cu(d, i.value);
    }
    return i.value === void 0 ? i : t.innerType._zod.run(i, s);
  };
}), aI = /* @__PURE__ */ T("$ZodNullable", (r, t) => {
  ae.init(r, t), V(r._zod, "optin", () => t.innerType._zod.optin), V(r._zod, "optout", () => t.innerType._zod.optout), V(r._zod, "pattern", () => {
    const i = t.innerType._zod.pattern;
    return i ? new RegExp(`^(${Si(i.source)}|null)$`) : void 0;
  }), V(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), r._zod.parse = (i, s) => i.value === null ? i : t.innerType._zod.run(i, s);
}), sI = /* @__PURE__ */ T("$ZodDefault", (r, t) => {
  ae.init(r, t), r._zod.optin = "optional", V(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (i, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(i, s);
    if (i.value === void 0)
      return i.value = t.defaultValue, i;
    const d = t.innerType._zod.run(i, s);
    return d instanceof Promise ? d.then((h) => pu(h, t)) : pu(d, t);
  };
});
function pu(r, t) {
  return r.value === void 0 && (r.value = t.defaultValue), r;
}
const uI = /* @__PURE__ */ T("$ZodPrefault", (r, t) => {
  ae.init(r, t), r._zod.optin = "optional", V(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (i, s) => (s.direction === "backward" || i.value === void 0 && (i.value = t.defaultValue), t.innerType._zod.run(i, s));
}), lI = /* @__PURE__ */ T("$ZodNonOptional", (r, t) => {
  ae.init(r, t), V(r._zod, "values", () => {
    const i = t.innerType._zod.values;
    return i ? new Set([...i].filter((s) => s !== void 0)) : void 0;
  }), r._zod.parse = (i, s) => {
    const d = t.innerType._zod.run(i, s);
    return d instanceof Promise ? d.then((h) => fu(h, r)) : fu(d, r);
  };
});
function fu(r, t) {
  return !r.issues.length && r.value === void 0 && r.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: r.value,
    inst: t
  }), r;
}
const dI = /* @__PURE__ */ T("$ZodCatch", (r, t) => {
  ae.init(r, t), V(r._zod, "optin", () => t.innerType._zod.optin), V(r._zod, "optout", () => t.innerType._zod.optout), V(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (i, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(i, s);
    const d = t.innerType._zod.run(i, s);
    return d instanceof Promise ? d.then((h) => (i.value = h.value, h.issues.length && (i.value = t.catchValue({
      ...i,
      error: {
        issues: h.issues.map((_) => On(_, s, Fn()))
      },
      input: i.value
    }), i.issues = []), i)) : (i.value = d.value, d.issues.length && (i.value = t.catchValue({
      ...i,
      error: {
        issues: d.issues.map((h) => On(h, s, Fn()))
      },
      input: i.value
    }), i.issues = []), i);
  };
}), cI = /* @__PURE__ */ T("$ZodPipe", (r, t) => {
  ae.init(r, t), V(r._zod, "values", () => t.in._zod.values), V(r._zod, "optin", () => t.in._zod.optin), V(r._zod, "optout", () => t.out._zod.optout), V(r._zod, "propValues", () => t.in._zod.propValues), r._zod.parse = (i, s) => {
    if (s.direction === "backward") {
      const h = t.out._zod.run(i, s);
      return h instanceof Promise ? h.then((_) => Bt(_, t.in, s)) : Bt(h, t.in, s);
    }
    const d = t.in._zod.run(i, s);
    return d instanceof Promise ? d.then((h) => Bt(h, t.out, s)) : Bt(d, t.out, s);
  };
});
function Bt(r, t, i) {
  return r.issues.length ? (r.aborted = !0, r) : t._zod.run({ value: r.value, issues: r.issues }, i);
}
const pI = /* @__PURE__ */ T("$ZodReadonly", (r, t) => {
  ae.init(r, t), V(r._zod, "propValues", () => t.innerType._zod.propValues), V(r._zod, "values", () => t.innerType._zod.values), V(r._zod, "optin", () => t.innerType._zod.optin), V(r._zod, "optout", () => t.innerType._zod.optout), r._zod.parse = (i, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(i, s);
    const d = t.innerType._zod.run(i, s);
    return d instanceof Promise ? d.then(hu) : hu(d);
  };
});
function hu(r) {
  return r.value = Object.freeze(r.value), r;
}
const fI = /* @__PURE__ */ T("$ZodCustom", (r, t) => {
  Ee.init(r, t), ae.init(r, t), r._zod.parse = (i, s) => i, r._zod.check = (i) => {
    const s = i.value, d = t.fn(s);
    if (d instanceof Promise)
      return d.then((h) => _u(h, i, s, r));
    _u(d, i, s, r);
  };
});
function _u(r, t, i, s) {
  if (!r) {
    const d = {
      code: "custom",
      input: i,
      inst: s,
      // incorporates params.error into issue reporting
      path: [...s._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !s._zod.def.abort
      // params: inst._zod.def.params,
    };
    s._zod.def.params && (d.params = s._zod.def.params), t.issues.push(Lr(d));
  }
}
class hI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...i) {
    const s = i[0];
    if (this._map.set(t, s), s && typeof s == "object" && "id" in s) {
      if (this._idmap.has(s.id))
        throw new Error(`ID ${s.id} already exists in the registry`);
      this._idmap.set(s.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const i = this._map.get(t);
    return i && typeof i == "object" && "id" in i && this._idmap.delete(i.id), this._map.delete(t), this;
  }
  get(t) {
    const i = t._zod.parent;
    if (i) {
      const s = { ...this.get(i) ?? {} };
      delete s.id;
      const d = { ...s, ...this._map.get(t) };
      return Object.keys(d).length ? d : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function _I() {
  return new hI();
}
const Pt = /* @__PURE__ */ _I();
function mI(r, t) {
  return new r({
    type: "string",
    ...y(t)
  });
}
function gI(r, t) {
  return new r({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function mu(r, t) {
  return new r({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function vI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function II(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...y(t)
  });
}
function bI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...y(t)
  });
}
function SI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...y(t)
  });
}
function TI(r, t) {
  return new r({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function AI(r, t) {
  return new r({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function CI(r, t) {
  return new r({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function xI(r, t) {
  return new r({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function MI(r, t) {
  return new r({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function wI(r, t) {
  return new r({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function EI(r, t) {
  return new r({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function NI(r, t) {
  return new r({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function yI(r, t) {
  return new r({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function kI(r, t) {
  return new r({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function BI(r, t) {
  return new r({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function PI(r, t) {
  return new r({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function RI(r, t) {
  return new r({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function LI(r, t) {
  return new r({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function zI(r, t) {
  return new r({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function FI(r, t) {
  return new r({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...y(t)
  });
}
function OI(r, t) {
  return new r({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...y(t)
  });
}
function GI(r, t) {
  return new r({
    type: "string",
    format: "date",
    check: "string_format",
    ...y(t)
  });
}
function ZI(r, t) {
  return new r({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...y(t)
  });
}
function DI(r, t) {
  return new r({
    type: "string",
    format: "duration",
    check: "string_format",
    ...y(t)
  });
}
function UI(r, t) {
  return new r({
    type: "number",
    checks: [],
    ...y(t)
  });
}
function $I(r, t) {
  return new r({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...y(t)
  });
}
function KI(r) {
  return new r({
    type: "unknown"
  });
}
function HI(r, t) {
  return new r({
    type: "never",
    ...y(t)
  });
}
function gu(r, t) {
  return new $u({
    check: "less_than",
    ...y(t),
    value: r,
    inclusive: !1
  });
}
function pi(r, t) {
  return new $u({
    check: "less_than",
    ...y(t),
    value: r,
    inclusive: !0
  });
}
function vu(r, t) {
  return new Ku({
    check: "greater_than",
    ...y(t),
    value: r,
    inclusive: !1
  });
}
function fi(r, t) {
  return new Ku({
    check: "greater_than",
    ...y(t),
    value: r,
    inclusive: !0
  });
}
function Iu(r, t) {
  return new lv({
    check: "multiple_of",
    ...y(t),
    value: r
  });
}
function Ju(r, t) {
  return new cv({
    check: "max_length",
    ...y(t),
    maximum: r
  });
}
function Ot(r, t) {
  return new pv({
    check: "min_length",
    ...y(t),
    minimum: r
  });
}
function ju(r, t) {
  return new fv({
    check: "length_equals",
    ...y(t),
    length: r
  });
}
function WI(r, t) {
  return new hv({
    check: "string_format",
    format: "regex",
    ...y(t),
    pattern: r
  });
}
function qI(r) {
  return new _v({
    check: "string_format",
    format: "lowercase",
    ...y(r)
  });
}
function VI(r) {
  return new mv({
    check: "string_format",
    format: "uppercase",
    ...y(r)
  });
}
function JI(r, t) {
  return new gv({
    check: "string_format",
    format: "includes",
    ...y(t),
    includes: r
  });
}
function jI(r, t) {
  return new vv({
    check: "string_format",
    format: "starts_with",
    ...y(t),
    prefix: r
  });
}
function YI(r, t) {
  return new Iv({
    check: "string_format",
    format: "ends_with",
    ...y(t),
    suffix: r
  });
}
function zr(r) {
  return new bv({
    check: "overwrite",
    tx: r
  });
}
function XI(r) {
  return zr((t) => t.normalize(r));
}
function QI() {
  return zr((r) => r.trim());
}
function e1() {
  return zr((r) => r.toLowerCase());
}
function n1() {
  return zr((r) => r.toUpperCase());
}
function r1(r, t, i) {
  return new r({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...y(i)
  });
}
function t1(r, t, i) {
  return new r({
    type: "custom",
    check: "custom",
    fn: t,
    ...y(i)
  });
}
function o1(r) {
  const t = i1((i) => (i.addIssue = (s) => {
    if (typeof s == "string")
      i.issues.push(Lr(s, i.value, t._zod.def));
    else {
      const d = s;
      d.fatal && (d.continue = !1), d.code ?? (d.code = "custom"), d.input ?? (d.input = i.value), d.inst ?? (d.inst = t), d.continue ?? (d.continue = !t._zod.def.abort), i.issues.push(Lr(d));
    }
  }, r(i.value, i)));
  return t;
}
function i1(r, t) {
  const i = new Ee({
    check: "custom",
    ...y(t)
  });
  return i._zod.check = r, i;
}
const a1 = /* @__PURE__ */ T("ZodISODateTime", (r, t) => {
  Rv.init(r, t), re.init(r, t);
});
function s1(r) {
  return OI(a1, r);
}
const u1 = /* @__PURE__ */ T("ZodISODate", (r, t) => {
  Lv.init(r, t), re.init(r, t);
});
function l1(r) {
  return GI(u1, r);
}
const d1 = /* @__PURE__ */ T("ZodISOTime", (r, t) => {
  zv.init(r, t), re.init(r, t);
});
function c1(r) {
  return ZI(d1, r);
}
const p1 = /* @__PURE__ */ T("ZodISODuration", (r, t) => {
  Fv.init(r, t), re.init(r, t);
});
function f1(r) {
  return DI(p1, r);
}
const h1 = (r, t) => {
  Fu.init(r, t), r.name = "ZodError", Object.defineProperties(r, {
    format: {
      value: (i) => Mg(r, i)
      // enumerable: false,
    },
    flatten: {
      value: (i) => xg(r, i)
      // enumerable: false,
    },
    addIssue: {
      value: (i) => {
        r.issues.push(i), r.message = JSON.stringify(r.issues, hi, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (i) => {
        r.issues.push(...i), r.message = JSON.stringify(r.issues, hi, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return r.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, $e = T("ZodError", h1, {
  Parent: Error
}), _1 = /* @__PURE__ */ Ai($e), m1 = /* @__PURE__ */ Ci($e), g1 = /* @__PURE__ */ Gt($e), v1 = /* @__PURE__ */ Zt($e), I1 = /* @__PURE__ */ Ng($e), b1 = /* @__PURE__ */ yg($e), S1 = /* @__PURE__ */ kg($e), T1 = /* @__PURE__ */ Bg($e), A1 = /* @__PURE__ */ Pg($e), C1 = /* @__PURE__ */ Rg($e), x1 = /* @__PURE__ */ Lg($e), M1 = /* @__PURE__ */ zg($e), ue = /* @__PURE__ */ T("ZodType", (r, t) => (ae.init(r, t), r.def = t, r.type = t.type, Object.defineProperty(r, "_def", { value: t }), r.check = (...i) => r.clone(Zn(t, {
  checks: [
    ...t.checks ?? [],
    ...i.map((s) => typeof s == "function" ? { _zod: { check: s, def: { check: "custom" }, onattach: [] } } : s)
  ]
})), r.clone = (i, s) => Mn(r, i, s), r.brand = () => r, r.register = ((i, s) => (i.add(r, s), r)), r.parse = (i, s) => _1(r, i, s, { callee: r.parse }), r.safeParse = (i, s) => g1(r, i, s), r.parseAsync = async (i, s) => m1(r, i, s, { callee: r.parseAsync }), r.safeParseAsync = async (i, s) => v1(r, i, s), r.spa = r.safeParseAsync, r.encode = (i, s) => I1(r, i, s), r.decode = (i, s) => b1(r, i, s), r.encodeAsync = async (i, s) => S1(r, i, s), r.decodeAsync = async (i, s) => T1(r, i, s), r.safeEncode = (i, s) => A1(r, i, s), r.safeDecode = (i, s) => C1(r, i, s), r.safeEncodeAsync = async (i, s) => x1(r, i, s), r.safeDecodeAsync = async (i, s) => M1(r, i, s), r.refine = (i, s) => r.check(gb(i, s)), r.superRefine = (i) => r.check(vb(i)), r.overwrite = (i) => r.check(zr(i)), r.optional = () => Cu(r), r.nullable = () => xu(r), r.nullish = () => Cu(xu(r)), r.nonoptional = (i) => db(r, i), r.array = () => j1(r), r.or = (i) => Q1([r, i]), r.and = (i) => nb(r, i), r.transform = (i) => Mu(r, ob(i)), r.default = (i) => sb(r, i), r.prefault = (i) => lb(r, i), r.catch = (i) => pb(r, i), r.pipe = (i) => Mu(r, i), r.readonly = () => _b(r), r.describe = (i) => {
  const s = r.clone();
  return Pt.add(s, { description: i }), s;
}, Object.defineProperty(r, "description", {
  get() {
    return Pt.get(r)?.description;
  },
  configurable: !0
}), r.meta = (...i) => {
  if (i.length === 0)
    return Pt.get(r);
  const s = r.clone();
  return Pt.add(s, i[0]), s;
}, r.isOptional = () => r.safeParse(void 0).success, r.isNullable = () => r.safeParse(null).success, r)), Yu = /* @__PURE__ */ T("_ZodString", (r, t) => {
  xi.init(r, t), ue.init(r, t);
  const i = r._zod.bag;
  r.format = i.format ?? null, r.minLength = i.minimum ?? null, r.maxLength = i.maximum ?? null, r.regex = (...s) => r.check(WI(...s)), r.includes = (...s) => r.check(JI(...s)), r.startsWith = (...s) => r.check(jI(...s)), r.endsWith = (...s) => r.check(YI(...s)), r.min = (...s) => r.check(Ot(...s)), r.max = (...s) => r.check(Ju(...s)), r.length = (...s) => r.check(ju(...s)), r.nonempty = (...s) => r.check(Ot(1, ...s)), r.lowercase = (s) => r.check(qI(s)), r.uppercase = (s) => r.check(VI(s)), r.trim = () => r.check(QI()), r.normalize = (...s) => r.check(XI(...s)), r.toLowerCase = () => r.check(e1()), r.toUpperCase = () => r.check(n1());
}), w1 = /* @__PURE__ */ T("ZodString", (r, t) => {
  xi.init(r, t), Yu.init(r, t), r.email = (i) => r.check(gI(E1, i)), r.url = (i) => r.check(TI(N1, i)), r.jwt = (i) => r.check(FI(K1, i)), r.emoji = (i) => r.check(AI(y1, i)), r.guid = (i) => r.check(mu(bu, i)), r.uuid = (i) => r.check(vI(Rt, i)), r.uuidv4 = (i) => r.check(II(Rt, i)), r.uuidv6 = (i) => r.check(bI(Rt, i)), r.uuidv7 = (i) => r.check(SI(Rt, i)), r.nanoid = (i) => r.check(CI(k1, i)), r.guid = (i) => r.check(mu(bu, i)), r.cuid = (i) => r.check(xI(B1, i)), r.cuid2 = (i) => r.check(MI(P1, i)), r.ulid = (i) => r.check(wI(R1, i)), r.base64 = (i) => r.check(RI(D1, i)), r.base64url = (i) => r.check(LI(U1, i)), r.xid = (i) => r.check(EI(L1, i)), r.ksuid = (i) => r.check(NI(z1, i)), r.ipv4 = (i) => r.check(yI(F1, i)), r.ipv6 = (i) => r.check(kI(O1, i)), r.cidrv4 = (i) => r.check(BI(G1, i)), r.cidrv6 = (i) => r.check(PI(Z1, i)), r.e164 = (i) => r.check(zI($1, i)), r.datetime = (i) => r.check(s1(i)), r.date = (i) => r.check(l1(i)), r.time = (i) => r.check(c1(i)), r.duration = (i) => r.check(f1(i));
});
function we(r) {
  return mI(w1, r);
}
const re = /* @__PURE__ */ T("ZodStringFormat", (r, t) => {
  ee.init(r, t), Yu.init(r, t);
}), E1 = /* @__PURE__ */ T("ZodEmail", (r, t) => {
  xv.init(r, t), re.init(r, t);
}), bu = /* @__PURE__ */ T("ZodGUID", (r, t) => {
  Av.init(r, t), re.init(r, t);
}), Rt = /* @__PURE__ */ T("ZodUUID", (r, t) => {
  Cv.init(r, t), re.init(r, t);
}), N1 = /* @__PURE__ */ T("ZodURL", (r, t) => {
  Mv.init(r, t), re.init(r, t);
}), y1 = /* @__PURE__ */ T("ZodEmoji", (r, t) => {
  wv.init(r, t), re.init(r, t);
}), k1 = /* @__PURE__ */ T("ZodNanoID", (r, t) => {
  Ev.init(r, t), re.init(r, t);
}), B1 = /* @__PURE__ */ T("ZodCUID", (r, t) => {
  Nv.init(r, t), re.init(r, t);
}), P1 = /* @__PURE__ */ T("ZodCUID2", (r, t) => {
  yv.init(r, t), re.init(r, t);
}), R1 = /* @__PURE__ */ T("ZodULID", (r, t) => {
  kv.init(r, t), re.init(r, t);
}), L1 = /* @__PURE__ */ T("ZodXID", (r, t) => {
  Bv.init(r, t), re.init(r, t);
}), z1 = /* @__PURE__ */ T("ZodKSUID", (r, t) => {
  Pv.init(r, t), re.init(r, t);
}), F1 = /* @__PURE__ */ T("ZodIPv4", (r, t) => {
  Ov.init(r, t), re.init(r, t);
}), O1 = /* @__PURE__ */ T("ZodIPv6", (r, t) => {
  Gv.init(r, t), re.init(r, t);
}), G1 = /* @__PURE__ */ T("ZodCIDRv4", (r, t) => {
  Zv.init(r, t), re.init(r, t);
}), Z1 = /* @__PURE__ */ T("ZodCIDRv6", (r, t) => {
  Dv.init(r, t), re.init(r, t);
}), D1 = /* @__PURE__ */ T("ZodBase64", (r, t) => {
  Uv.init(r, t), re.init(r, t);
}), U1 = /* @__PURE__ */ T("ZodBase64URL", (r, t) => {
  Kv.init(r, t), re.init(r, t);
}), $1 = /* @__PURE__ */ T("ZodE164", (r, t) => {
  Hv.init(r, t), re.init(r, t);
}), K1 = /* @__PURE__ */ T("ZodJWT", (r, t) => {
  qv.init(r, t), re.init(r, t);
}), Xu = /* @__PURE__ */ T("ZodNumber", (r, t) => {
  Wu.init(r, t), ue.init(r, t), r.gt = (s, d) => r.check(vu(s, d)), r.gte = (s, d) => r.check(fi(s, d)), r.min = (s, d) => r.check(fi(s, d)), r.lt = (s, d) => r.check(gu(s, d)), r.lte = (s, d) => r.check(pi(s, d)), r.max = (s, d) => r.check(pi(s, d)), r.int = (s) => r.check(Tu(s)), r.safe = (s) => r.check(Tu(s)), r.positive = (s) => r.check(vu(0, s)), r.nonnegative = (s) => r.check(fi(0, s)), r.negative = (s) => r.check(gu(0, s)), r.nonpositive = (s) => r.check(pi(0, s)), r.multipleOf = (s, d) => r.check(Iu(s, d)), r.step = (s, d) => r.check(Iu(s, d)), r.finite = () => r;
  const i = r._zod.bag;
  r.minValue = Math.max(i.minimum ?? Number.NEGATIVE_INFINITY, i.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, r.maxValue = Math.min(i.maximum ?? Number.POSITIVE_INFINITY, i.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, r.isInt = (i.format ?? "").includes("int") || Number.isSafeInteger(i.multipleOf ?? 0.5), r.isFinite = !0, r.format = i.format ?? null;
});
function Su(r) {
  return UI(Xu, r);
}
const H1 = /* @__PURE__ */ T("ZodNumberFormat", (r, t) => {
  Vv.init(r, t), Xu.init(r, t);
});
function Tu(r) {
  return $I(H1, r);
}
const W1 = /* @__PURE__ */ T("ZodUnknown", (r, t) => {
  Jv.init(r, t), ue.init(r, t);
});
function Au() {
  return KI(W1);
}
const q1 = /* @__PURE__ */ T("ZodNever", (r, t) => {
  jv.init(r, t), ue.init(r, t);
});
function V1(r) {
  return HI(q1, r);
}
const J1 = /* @__PURE__ */ T("ZodArray", (r, t) => {
  Yv.init(r, t), ue.init(r, t), r.element = t.element, r.min = (i, s) => r.check(Ot(i, s)), r.nonempty = (i) => r.check(Ot(1, i)), r.max = (i, s) => r.check(Ju(i, s)), r.length = (i, s) => r.check(ju(i, s)), r.unwrap = () => r.element;
});
function j1(r, t) {
  return r1(J1, r, t);
}
const Y1 = /* @__PURE__ */ T("ZodObject", (r, t) => {
  Qv.init(r, t), ue.init(r, t), V(r, "shape", () => t.shape), r.keyof = () => Qu(Object.keys(r._zod.def.shape)), r.catchall = (i) => r.clone({ ...r._zod.def, catchall: i }), r.passthrough = () => r.clone({ ...r._zod.def, catchall: Au() }), r.loose = () => r.clone({ ...r._zod.def, catchall: Au() }), r.strict = () => r.clone({ ...r._zod.def, catchall: V1() }), r.strip = () => r.clone({ ...r._zod.def, catchall: void 0 }), r.extend = (i) => bg(r, i), r.safeExtend = (i) => Sg(r, i), r.merge = (i) => Tg(r, i), r.pick = (i) => vg(r, i), r.omit = (i) => Ig(r, i), r.partial = (...i) => Ag(nl, r, i[0]), r.required = (...i) => Cg(rl, r, i[0]);
});
function Ut(r, t) {
  const i = {
    type: "object",
    shape: r ?? {},
    ...y(t)
  };
  return new Y1(i);
}
const X1 = /* @__PURE__ */ T("ZodUnion", (r, t) => {
  eI.init(r, t), ue.init(r, t), r.options = t.options;
});
function Q1(r, t) {
  return new X1({
    type: "union",
    options: r,
    ...y(t)
  });
}
const eb = /* @__PURE__ */ T("ZodIntersection", (r, t) => {
  nI.init(r, t), ue.init(r, t);
});
function nb(r, t) {
  return new eb({
    type: "intersection",
    left: r,
    right: t
  });
}
const mi = /* @__PURE__ */ T("ZodEnum", (r, t) => {
  rI.init(r, t), ue.init(r, t), r.enum = t.entries, r.options = Object.values(t.entries);
  const i = new Set(Object.keys(t.entries));
  r.extract = (s, d) => {
    const h = {};
    for (const _ of s)
      if (i.has(_))
        h[_] = t.entries[_];
      else
        throw new Error(`Key ${_} not found in enum`);
    return new mi({
      ...t,
      checks: [],
      ...y(d),
      entries: h
    });
  }, r.exclude = (s, d) => {
    const h = { ...t.entries };
    for (const _ of s)
      if (i.has(_))
        delete h[_];
      else
        throw new Error(`Key ${_} not found in enum`);
    return new mi({
      ...t,
      checks: [],
      ...y(d),
      entries: h
    });
  };
});
function Qu(r, t) {
  const i = Array.isArray(r) ? Object.fromEntries(r.map((s) => [s, s])) : r;
  return new mi({
    type: "enum",
    entries: i,
    ...y(t)
  });
}
const rb = /* @__PURE__ */ T("ZodLiteral", (r, t) => {
  tI.init(r, t), ue.init(r, t), r.values = new Set(t.values), Object.defineProperty(r, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function el(r, t) {
  return new rb({
    type: "literal",
    values: Array.isArray(r) ? r : [r],
    ...y(t)
  });
}
const tb = /* @__PURE__ */ T("ZodTransform", (r, t) => {
  oI.init(r, t), ue.init(r, t), r._zod.parse = (i, s) => {
    if (s.direction === "backward")
      throw new ku(r.constructor.name);
    i.addIssue = (h) => {
      if (typeof h == "string")
        i.issues.push(Lr(h, i.value, t));
      else {
        const _ = h;
        _.fatal && (_.continue = !1), _.code ?? (_.code = "custom"), _.input ?? (_.input = i.value), _.inst ?? (_.inst = r), i.issues.push(Lr(_));
      }
    };
    const d = t.transform(i.value, i);
    return d instanceof Promise ? d.then((h) => (i.value = h, i)) : (i.value = d, i);
  };
});
function ob(r) {
  return new tb({
    type: "transform",
    transform: r
  });
}
const nl = /* @__PURE__ */ T("ZodOptional", (r, t) => {
  iI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType;
});
function Cu(r) {
  return new nl({
    type: "optional",
    innerType: r
  });
}
const ib = /* @__PURE__ */ T("ZodNullable", (r, t) => {
  aI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType;
});
function xu(r) {
  return new ib({
    type: "nullable",
    innerType: r
  });
}
const ab = /* @__PURE__ */ T("ZodDefault", (r, t) => {
  sI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType, r.removeDefault = r.unwrap;
});
function sb(r, t) {
  return new ab({
    type: "default",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Ru(t);
    }
  });
}
const ub = /* @__PURE__ */ T("ZodPrefault", (r, t) => {
  uI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType;
});
function lb(r, t) {
  return new ub({
    type: "prefault",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Ru(t);
    }
  });
}
const rl = /* @__PURE__ */ T("ZodNonOptional", (r, t) => {
  lI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType;
});
function db(r, t) {
  return new rl({
    type: "nonoptional",
    innerType: r,
    ...y(t)
  });
}
const cb = /* @__PURE__ */ T("ZodCatch", (r, t) => {
  dI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType, r.removeCatch = r.unwrap;
});
function pb(r, t) {
  return new cb({
    type: "catch",
    innerType: r,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const fb = /* @__PURE__ */ T("ZodPipe", (r, t) => {
  cI.init(r, t), ue.init(r, t), r.in = t.in, r.out = t.out;
});
function Mu(r, t) {
  return new fb({
    type: "pipe",
    in: r,
    out: t
    // ...util.normalizeParams(params),
  });
}
const hb = /* @__PURE__ */ T("ZodReadonly", (r, t) => {
  pI.init(r, t), ue.init(r, t), r.unwrap = () => r._zod.def.innerType;
});
function _b(r) {
  return new hb({
    type: "readonly",
    innerType: r
  });
}
const mb = /* @__PURE__ */ T("ZodCustom", (r, t) => {
  fI.init(r, t), ue.init(r, t);
});
function gb(r, t = {}) {
  return t1(mb, r, t);
}
function vb(r) {
  return o1(r);
}
const Ib = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], bb = Qu(Ib), Hb = (r) => bb.parse(r), Wb = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, Sb = [...Nu, "EU", "EXTRA_EU"];
function Tb(r) {
  return typeof r == "string" && Sb.includes(r);
}
function qb(r) {
  if (Tb(r) !== !0)
    throw new Error(`'${r}' is not a valid tax code origin`);
  return r;
}
const Vb = "backoffice@fleequid.com", Jb = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, Ab = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function jb(r) {
  return Ab[r];
}
const tl = {
  addressNumber: we().optional().nullable(),
  alternate: we().optional().nullable(),
  country: we(),
  countryCode: we(),
  fullAddress: we(),
  latitude: Su(),
  longitude: Su(),
  mapboxId: we(),
  place: we(),
  postcode: we().optional().nullable(),
  region: we(),
  streetName: we().optional().nullable()
}, Yb = Ut(tl), Xb = (r) => Ut(tl, { error: r }), Cb = "AdminUserPasswordResetToken", Qb = Ut({
  type: el(Cb),
  adminUserId: we(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: we()
}), xb = "CustomerUserPasswordResetToken", e0 = Ut({
  type: el(xb),
  userId: we()
}), ol = we().min(5).brand("Tin");
function n0(r) {
  return ol.safeParse(r).success;
}
function Mb(r) {
  const t = ol.safeParse(r);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${r}' as Tin: ${t.error.issues.map(({ message: i }) => i).join(", ")}`);
}
function r0(r) {
  return Mb(r.replace(/[^a-zA-Z0-9]/g, ""));
}
const t0 = (r, ...t) => r ? t.map((i) => typeof i == "function" ? i() : i) : [];
var Lt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Br = { exports: {} };
var wb = Br.exports, wu;
function Eb() {
  return wu || (wu = 1, (function(r, t) {
    (function() {
      var i, s = "4.17.23", d = 200, h = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", _ = "Expected a function", C = "Invalid `variable` option passed into `_.template`", w = "__lodash_hash_undefined__", N = 500, Z = "__lodash_placeholder__", X = 1, J = 2, j = 4, se = 1, hn = 2, Te = 1, _n = 2, Fr = 4, le = 8, _e = 16, ve = 32, ur = 64, rn = 128, lr = 256, $t = 512, ll = 30, dl = "...", cl = 800, pl = 16, wi = 1, fl = 2, hl = 3, wn = 1 / 0, mn = 9007199254740991, _l = 17976931348623157e292, Or = NaN, je = 4294967295, ml = je - 1, gl = je >>> 1, vl = [
        ["ary", rn],
        ["bind", Te],
        ["bindKey", _n],
        ["curry", le],
        ["curryRight", _e],
        ["flip", $t],
        ["partial", ve],
        ["partialRight", ur],
        ["rearg", lr]
      ], Dn = "[object Arguments]", Gr = "[object Array]", Il = "[object AsyncFunction]", dr = "[object Boolean]", cr = "[object Date]", bl = "[object DOMException]", Zr = "[object Error]", Dr = "[object Function]", Ei = "[object GeneratorFunction]", Ke = "[object Map]", pr = "[object Number]", Sl = "[object Null]", tn = "[object Object]", Ni = "[object Promise]", Tl = "[object Proxy]", fr = "[object RegExp]", He = "[object Set]", hr = "[object String]", Ur = "[object Symbol]", Al = "[object Undefined]", _r = "[object WeakMap]", Cl = "[object WeakSet]", mr = "[object ArrayBuffer]", Un = "[object DataView]", Kt = "[object Float32Array]", Ht = "[object Float64Array]", Wt = "[object Int8Array]", qt = "[object Int16Array]", Vt = "[object Int32Array]", Jt = "[object Uint8Array]", jt = "[object Uint8ClampedArray]", Yt = "[object Uint16Array]", Xt = "[object Uint32Array]", xl = /\b__p \+= '';/g, Ml = /\b(__p \+=) '' \+/g, wl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, yi = /&(?:amp|lt|gt|quot|#39);/g, ki = /[&<>"']/g, El = RegExp(yi.source), Nl = RegExp(ki.source), yl = /<%-([\s\S]+?)%>/g, kl = /<%([\s\S]+?)%>/g, Bi = /<%=([\s\S]+?)%>/g, Bl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Pl = /^\w*$/, Rl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Qt = /[\\^$.*+?()[\]{}|]/g, Ll = RegExp(Qt.source), eo = /^\s+/, zl = /\s/, Fl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ol = /\{\n\/\* \[wrapped with (.+)\] \*/, Gl = /,? & /, Zl = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Dl = /[()=,{}\[\]\/\s]/, Ul = /\\(\\)?/g, $l = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Pi = /\w*$/, Kl = /^[-+]0x[0-9a-f]+$/i, Hl = /^0b[01]+$/i, Wl = /^\[object .+?Constructor\]$/, ql = /^0o[0-7]+$/i, Vl = /^(?:0|[1-9]\d*)$/, Jl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $r = /($^)/, jl = /['\n\r\u2028\u2029\\]/g, Kr = "\\ud800-\\udfff", Yl = "\\u0300-\\u036f", Xl = "\\ufe20-\\ufe2f", Ql = "\\u20d0-\\u20ff", Ri = Yl + Xl + Ql, Li = "\\u2700-\\u27bf", zi = "a-z\\xdf-\\xf6\\xf8-\\xff", ed = "\\xac\\xb1\\xd7\\xf7", nd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rd = "\\u2000-\\u206f", td = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Fi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Oi = "\\ufe0e\\ufe0f", Gi = ed + nd + rd + td, no = "['’]", od = "[" + Kr + "]", Zi = "[" + Gi + "]", Hr = "[" + Ri + "]", Di = "\\d+", id = "[" + Li + "]", Ui = "[" + zi + "]", $i = "[^" + Kr + Gi + Di + Li + zi + Fi + "]", ro = "\\ud83c[\\udffb-\\udfff]", ad = "(?:" + Hr + "|" + ro + ")", Ki = "[^" + Kr + "]", to = "(?:\\ud83c[\\udde6-\\uddff]){2}", oo = "[\\ud800-\\udbff][\\udc00-\\udfff]", $n = "[" + Fi + "]", Hi = "\\u200d", Wi = "(?:" + Ui + "|" + $i + ")", sd = "(?:" + $n + "|" + $i + ")", qi = "(?:" + no + "(?:d|ll|m|re|s|t|ve))?", Vi = "(?:" + no + "(?:D|LL|M|RE|S|T|VE))?", Ji = ad + "?", ji = "[" + Oi + "]?", ud = "(?:" + Hi + "(?:" + [Ki, to, oo].join("|") + ")" + ji + Ji + ")*", ld = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", dd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Yi = ji + Ji + ud, cd = "(?:" + [id, to, oo].join("|") + ")" + Yi, pd = "(?:" + [Ki + Hr + "?", Hr, to, oo, od].join("|") + ")", fd = RegExp(no, "g"), hd = RegExp(Hr, "g"), io = RegExp(ro + "(?=" + ro + ")|" + pd + Yi, "g"), _d = RegExp([
        $n + "?" + Ui + "+" + qi + "(?=" + [Zi, $n, "$"].join("|") + ")",
        sd + "+" + Vi + "(?=" + [Zi, $n + Wi, "$"].join("|") + ")",
        $n + "?" + Wi + "+" + qi,
        $n + "+" + Vi,
        dd,
        ld,
        Di,
        cd
      ].join("|"), "g"), md = RegExp("[" + Hi + Kr + Ri + Oi + "]"), gd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, vd = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Id = -1, Y = {};
      Y[Kt] = Y[Ht] = Y[Wt] = Y[qt] = Y[Vt] = Y[Jt] = Y[jt] = Y[Yt] = Y[Xt] = !0, Y[Dn] = Y[Gr] = Y[mr] = Y[dr] = Y[Un] = Y[cr] = Y[Zr] = Y[Dr] = Y[Ke] = Y[pr] = Y[tn] = Y[fr] = Y[He] = Y[hr] = Y[_r] = !1;
      var q = {};
      q[Dn] = q[Gr] = q[mr] = q[Un] = q[dr] = q[cr] = q[Kt] = q[Ht] = q[Wt] = q[qt] = q[Vt] = q[Ke] = q[pr] = q[tn] = q[fr] = q[He] = q[hr] = q[Ur] = q[Jt] = q[jt] = q[Yt] = q[Xt] = !0, q[Zr] = q[Dr] = q[_r] = !1;
      var bd = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Sd = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Td = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Ad = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Cd = parseFloat, xd = parseInt, Xi = typeof Lt == "object" && Lt && Lt.Object === Object && Lt, Md = typeof self == "object" && self && self.Object === Object && self, fe = Xi || Md || Function("return this")(), ao = t && !t.nodeType && t, En = ao && !0 && r && !r.nodeType && r, Qi = En && En.exports === ao, so = Qi && Xi.process, Le = (function() {
        try {
          var m = En && En.require && En.require("util").types;
          return m || so && so.binding && so.binding("util");
        } catch {
        }
      })(), ea = Le && Le.isArrayBuffer, na = Le && Le.isDate, ra = Le && Le.isMap, ta = Le && Le.isRegExp, oa = Le && Le.isSet, ia = Le && Le.isTypedArray;
      function Ne(m, I, v) {
        switch (v.length) {
          case 0:
            return m.call(I);
          case 1:
            return m.call(I, v[0]);
          case 2:
            return m.call(I, v[0], v[1]);
          case 3:
            return m.call(I, v[0], v[1], v[2]);
        }
        return m.apply(I, v);
      }
      function wd(m, I, v, M) {
        for (var R = -1, $ = m == null ? 0 : m.length; ++R < $; ) {
          var de = m[R];
          I(M, de, v(de), m);
        }
        return M;
      }
      function ze(m, I) {
        for (var v = -1, M = m == null ? 0 : m.length; ++v < M && I(m[v], v, m) !== !1; )
          ;
        return m;
      }
      function Ed(m, I) {
        for (var v = m == null ? 0 : m.length; v-- && I(m[v], v, m) !== !1; )
          ;
        return m;
      }
      function aa(m, I) {
        for (var v = -1, M = m == null ? 0 : m.length; ++v < M; )
          if (!I(m[v], v, m))
            return !1;
        return !0;
      }
      function gn(m, I) {
        for (var v = -1, M = m == null ? 0 : m.length, R = 0, $ = []; ++v < M; ) {
          var de = m[v];
          I(de, v, m) && ($[R++] = de);
        }
        return $;
      }
      function Wr(m, I) {
        var v = m == null ? 0 : m.length;
        return !!v && Kn(m, I, 0) > -1;
      }
      function uo(m, I, v) {
        for (var M = -1, R = m == null ? 0 : m.length; ++M < R; )
          if (v(I, m[M]))
            return !0;
        return !1;
      }
      function Q(m, I) {
        for (var v = -1, M = m == null ? 0 : m.length, R = Array(M); ++v < M; )
          R[v] = I(m[v], v, m);
        return R;
      }
      function vn(m, I) {
        for (var v = -1, M = I.length, R = m.length; ++v < M; )
          m[R + v] = I[v];
        return m;
      }
      function lo(m, I, v, M) {
        var R = -1, $ = m == null ? 0 : m.length;
        for (M && $ && (v = m[++R]); ++R < $; )
          v = I(v, m[R], R, m);
        return v;
      }
      function Nd(m, I, v, M) {
        var R = m == null ? 0 : m.length;
        for (M && R && (v = m[--R]); R--; )
          v = I(v, m[R], R, m);
        return v;
      }
      function co(m, I) {
        for (var v = -1, M = m == null ? 0 : m.length; ++v < M; )
          if (I(m[v], v, m))
            return !0;
        return !1;
      }
      var yd = po("length");
      function kd(m) {
        return m.split("");
      }
      function Bd(m) {
        return m.match(Zl) || [];
      }
      function sa(m, I, v) {
        var M;
        return v(m, function(R, $, de) {
          if (I(R, $, de))
            return M = $, !1;
        }), M;
      }
      function qr(m, I, v, M) {
        for (var R = m.length, $ = v + (M ? 1 : -1); M ? $-- : ++$ < R; )
          if (I(m[$], $, m))
            return $;
        return -1;
      }
      function Kn(m, I, v) {
        return I === I ? Kd(m, I, v) : qr(m, ua, v);
      }
      function Pd(m, I, v, M) {
        for (var R = v - 1, $ = m.length; ++R < $; )
          if (M(m[R], I))
            return R;
        return -1;
      }
      function ua(m) {
        return m !== m;
      }
      function la(m, I) {
        var v = m == null ? 0 : m.length;
        return v ? ho(m, I) / v : Or;
      }
      function po(m) {
        return function(I) {
          return I == null ? i : I[m];
        };
      }
      function fo(m) {
        return function(I) {
          return m == null ? i : m[I];
        };
      }
      function da(m, I, v, M, R) {
        return R(m, function($, de, W) {
          v = M ? (M = !1, $) : I(v, $, de, W);
        }), v;
      }
      function Rd(m, I) {
        var v = m.length;
        for (m.sort(I); v--; )
          m[v] = m[v].value;
        return m;
      }
      function ho(m, I) {
        for (var v, M = -1, R = m.length; ++M < R; ) {
          var $ = I(m[M]);
          $ !== i && (v = v === i ? $ : v + $);
        }
        return v;
      }
      function _o(m, I) {
        for (var v = -1, M = Array(m); ++v < m; )
          M[v] = I(v);
        return M;
      }
      function Ld(m, I) {
        return Q(I, function(v) {
          return [v, m[v]];
        });
      }
      function ca(m) {
        return m && m.slice(0, _a(m) + 1).replace(eo, "");
      }
      function ye(m) {
        return function(I) {
          return m(I);
        };
      }
      function mo(m, I) {
        return Q(I, function(v) {
          return m[v];
        });
      }
      function gr(m, I) {
        return m.has(I);
      }
      function pa(m, I) {
        for (var v = -1, M = m.length; ++v < M && Kn(I, m[v], 0) > -1; )
          ;
        return v;
      }
      function fa(m, I) {
        for (var v = m.length; v-- && Kn(I, m[v], 0) > -1; )
          ;
        return v;
      }
      function zd(m, I) {
        for (var v = m.length, M = 0; v--; )
          m[v] === I && ++M;
        return M;
      }
      var Fd = fo(bd), Od = fo(Sd);
      function Gd(m) {
        return "\\" + Ad[m];
      }
      function Zd(m, I) {
        return m == null ? i : m[I];
      }
      function Hn(m) {
        return md.test(m);
      }
      function Dd(m) {
        return gd.test(m);
      }
      function Ud(m) {
        for (var I, v = []; !(I = m.next()).done; )
          v.push(I.value);
        return v;
      }
      function go(m) {
        var I = -1, v = Array(m.size);
        return m.forEach(function(M, R) {
          v[++I] = [R, M];
        }), v;
      }
      function ha(m, I) {
        return function(v) {
          return m(I(v));
        };
      }
      function In(m, I) {
        for (var v = -1, M = m.length, R = 0, $ = []; ++v < M; ) {
          var de = m[v];
          (de === I || de === Z) && (m[v] = Z, $[R++] = v);
        }
        return $;
      }
      function Vr(m) {
        var I = -1, v = Array(m.size);
        return m.forEach(function(M) {
          v[++I] = M;
        }), v;
      }
      function $d(m) {
        var I = -1, v = Array(m.size);
        return m.forEach(function(M) {
          v[++I] = [M, M];
        }), v;
      }
      function Kd(m, I, v) {
        for (var M = v - 1, R = m.length; ++M < R; )
          if (m[M] === I)
            return M;
        return -1;
      }
      function Hd(m, I, v) {
        for (var M = v + 1; M--; )
          if (m[M] === I)
            return M;
        return M;
      }
      function Wn(m) {
        return Hn(m) ? qd(m) : yd(m);
      }
      function We(m) {
        return Hn(m) ? Vd(m) : kd(m);
      }
      function _a(m) {
        for (var I = m.length; I-- && zl.test(m.charAt(I)); )
          ;
        return I;
      }
      var Wd = fo(Td);
      function qd(m) {
        for (var I = io.lastIndex = 0; io.test(m); )
          ++I;
        return I;
      }
      function Vd(m) {
        return m.match(io) || [];
      }
      function Jd(m) {
        return m.match(_d) || [];
      }
      var jd = (function m(I) {
        I = I == null ? fe : qn.defaults(fe.Object(), I, qn.pick(fe, vd));
        var v = I.Array, M = I.Date, R = I.Error, $ = I.Function, de = I.Math, W = I.Object, vo = I.RegExp, Yd = I.String, Fe = I.TypeError, Jr = v.prototype, Xd = $.prototype, Vn = W.prototype, jr = I["__core-js_shared__"], Yr = Xd.toString, K = Vn.hasOwnProperty, Qd = 0, ma = (function() {
          var e = /[^.]+$/.exec(jr && jr.keys && jr.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), Xr = Vn.toString, ec = Yr.call(W), nc = fe._, rc = vo(
          "^" + Yr.call(K).replace(Qt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Qr = Qi ? I.Buffer : i, bn = I.Symbol, et = I.Uint8Array, ga = Qr ? Qr.allocUnsafe : i, nt = ha(W.getPrototypeOf, W), va = W.create, Ia = Vn.propertyIsEnumerable, rt = Jr.splice, ba = bn ? bn.isConcatSpreadable : i, vr = bn ? bn.iterator : i, Nn = bn ? bn.toStringTag : i, tt = (function() {
          try {
            var e = Rn(W, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), tc = I.clearTimeout !== fe.clearTimeout && I.clearTimeout, oc = M && M.now !== fe.Date.now && M.now, ic = I.setTimeout !== fe.setTimeout && I.setTimeout, ot = de.ceil, it = de.floor, Io = W.getOwnPropertySymbols, ac = Qr ? Qr.isBuffer : i, Sa = I.isFinite, sc = Jr.join, uc = ha(W.keys, W), ce = de.max, me = de.min, lc = M.now, dc = I.parseInt, Ta = de.random, cc = Jr.reverse, bo = Rn(I, "DataView"), Ir = Rn(I, "Map"), So = Rn(I, "Promise"), Jn = Rn(I, "Set"), br = Rn(I, "WeakMap"), Sr = Rn(W, "create"), at = br && new br(), jn = {}, pc = Ln(bo), fc = Ln(Ir), hc = Ln(So), _c = Ln(Jn), mc = Ln(br), st = bn ? bn.prototype : i, Tr = st ? st.valueOf : i, Aa = st ? st.toString : i;
        function l(e) {
          if (te(e) && !L(e) && !(e instanceof D)) {
            if (e instanceof Oe)
              return e;
            if (K.call(e, "__wrapped__"))
              return Cs(e);
          }
          return new Oe(e);
        }
        var Yn = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(n) {
            if (!ne(n))
              return {};
            if (va)
              return va(n);
            e.prototype = n;
            var o = new e();
            return e.prototype = i, o;
          };
        })();
        function ut() {
        }
        function Oe(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
        }
        l.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: yl,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: kl,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Bi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: l
          }
        }, l.prototype = ut.prototype, l.prototype.constructor = l, Oe.prototype = Yn(ut.prototype), Oe.prototype.constructor = Oe;
        function D(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = je, this.__views__ = [];
        }
        function gc() {
          var e = new D(this.__wrapped__);
          return e.__actions__ = Ae(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ae(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ae(this.__views__), e;
        }
        function vc() {
          if (this.__filtered__) {
            var e = new D(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Ic() {
          var e = this.__wrapped__.value(), n = this.__dir__, o = L(e), a = n < 0, u = o ? e.length : 0, c = kp(0, u, this.__views__), p = c.start, f = c.end, g = f - p, b = a ? f : p - 1, S = this.__iteratees__, A = S.length, x = 0, E = me(g, this.__takeCount__);
          if (!o || !a && u == g && E == g)
            return qa(e, this.__actions__);
          var B = [];
          e:
            for (; g-- && x < E; ) {
              b += n;
              for (var F = -1, P = e[b]; ++F < A; ) {
                var G = S[F], U = G.iteratee, Pe = G.type, Se = U(P);
                if (Pe == fl)
                  P = Se;
                else if (!Se) {
                  if (Pe == wi)
                    continue e;
                  break e;
                }
              }
              B[x++] = P;
            }
          return B;
        }
        D.prototype = Yn(ut.prototype), D.prototype.constructor = D;
        function yn(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function bc() {
          this.__data__ = Sr ? Sr(null) : {}, this.size = 0;
        }
        function Sc(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function Tc(e) {
          var n = this.__data__;
          if (Sr) {
            var o = n[e];
            return o === w ? i : o;
          }
          return K.call(n, e) ? n[e] : i;
        }
        function Ac(e) {
          var n = this.__data__;
          return Sr ? n[e] !== i : K.call(n, e);
        }
        function Cc(e, n) {
          var o = this.__data__;
          return this.size += this.has(e) ? 0 : 1, o[e] = Sr && n === i ? w : n, this;
        }
        yn.prototype.clear = bc, yn.prototype.delete = Sc, yn.prototype.get = Tc, yn.prototype.has = Ac, yn.prototype.set = Cc;
        function on(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function xc() {
          this.__data__ = [], this.size = 0;
        }
        function Mc(e) {
          var n = this.__data__, o = lt(n, e);
          if (o < 0)
            return !1;
          var a = n.length - 1;
          return o == a ? n.pop() : rt.call(n, o, 1), --this.size, !0;
        }
        function wc(e) {
          var n = this.__data__, o = lt(n, e);
          return o < 0 ? i : n[o][1];
        }
        function Ec(e) {
          return lt(this.__data__, e) > -1;
        }
        function Nc(e, n) {
          var o = this.__data__, a = lt(o, e);
          return a < 0 ? (++this.size, o.push([e, n])) : o[a][1] = n, this;
        }
        on.prototype.clear = xc, on.prototype.delete = Mc, on.prototype.get = wc, on.prototype.has = Ec, on.prototype.set = Nc;
        function an(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function yc() {
          this.size = 0, this.__data__ = {
            hash: new yn(),
            map: new (Ir || on)(),
            string: new yn()
          };
        }
        function kc(e) {
          var n = St(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function Bc(e) {
          return St(this, e).get(e);
        }
        function Pc(e) {
          return St(this, e).has(e);
        }
        function Rc(e, n) {
          var o = St(this, e), a = o.size;
          return o.set(e, n), this.size += o.size == a ? 0 : 1, this;
        }
        an.prototype.clear = yc, an.prototype.delete = kc, an.prototype.get = Bc, an.prototype.has = Pc, an.prototype.set = Rc;
        function kn(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.__data__ = new an(); ++n < o; )
            this.add(e[n]);
        }
        function Lc(e) {
          return this.__data__.set(e, w), this;
        }
        function zc(e) {
          return this.__data__.has(e);
        }
        kn.prototype.add = kn.prototype.push = Lc, kn.prototype.has = zc;
        function qe(e) {
          var n = this.__data__ = new on(e);
          this.size = n.size;
        }
        function Fc() {
          this.__data__ = new on(), this.size = 0;
        }
        function Oc(e) {
          var n = this.__data__, o = n.delete(e);
          return this.size = n.size, o;
        }
        function Gc(e) {
          return this.__data__.get(e);
        }
        function Zc(e) {
          return this.__data__.has(e);
        }
        function Dc(e, n) {
          var o = this.__data__;
          if (o instanceof on) {
            var a = o.__data__;
            if (!Ir || a.length < d - 1)
              return a.push([e, n]), this.size = ++o.size, this;
            o = this.__data__ = new an(a);
          }
          return o.set(e, n), this.size = o.size, this;
        }
        qe.prototype.clear = Fc, qe.prototype.delete = Oc, qe.prototype.get = Gc, qe.prototype.has = Zc, qe.prototype.set = Dc;
        function Ca(e, n) {
          var o = L(e), a = !o && zn(e), u = !o && !a && xn(e), c = !o && !a && !u && nr(e), p = o || a || u || c, f = p ? _o(e.length, Yd) : [], g = f.length;
          for (var b in e)
            (n || K.call(e, b)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
            (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            u && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            c && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
            dn(b, g))) && f.push(b);
          return f;
        }
        function xa(e) {
          var n = e.length;
          return n ? e[Bo(0, n - 1)] : i;
        }
        function Uc(e, n) {
          return Tt(Ae(e), Bn(n, 0, e.length));
        }
        function $c(e) {
          return Tt(Ae(e));
        }
        function To(e, n, o) {
          (o !== i && !Ve(e[n], o) || o === i && !(n in e)) && sn(e, n, o);
        }
        function Ar(e, n, o) {
          var a = e[n];
          (!(K.call(e, n) && Ve(a, o)) || o === i && !(n in e)) && sn(e, n, o);
        }
        function lt(e, n) {
          for (var o = e.length; o--; )
            if (Ve(e[o][0], n))
              return o;
          return -1;
        }
        function Kc(e, n, o, a) {
          return Sn(e, function(u, c, p) {
            n(a, u, o(u), p);
          }), a;
        }
        function Ma(e, n) {
          return e && Xe(n, pe(n), e);
        }
        function Hc(e, n) {
          return e && Xe(n, xe(n), e);
        }
        function sn(e, n, o) {
          n == "__proto__" && tt ? tt(e, n, {
            configurable: !0,
            enumerable: !0,
            value: o,
            writable: !0
          }) : e[n] = o;
        }
        function Ao(e, n) {
          for (var o = -1, a = n.length, u = v(a), c = e == null; ++o < a; )
            u[o] = c ? i : ti(e, n[o]);
          return u;
        }
        function Bn(e, n, o) {
          return e === e && (o !== i && (e = e <= o ? e : o), n !== i && (e = e >= n ? e : n)), e;
        }
        function Ge(e, n, o, a, u, c) {
          var p, f = n & X, g = n & J, b = n & j;
          if (o && (p = u ? o(e, a, u, c) : o(e)), p !== i)
            return p;
          if (!ne(e))
            return e;
          var S = L(e);
          if (S) {
            if (p = Pp(e), !f)
              return Ae(e, p);
          } else {
            var A = ge(e), x = A == Dr || A == Ei;
            if (xn(e))
              return ja(e, f);
            if (A == tn || A == Dn || x && !u) {
              if (p = g || x ? {} : _s(e), !f)
                return g ? Tp(e, Hc(p, e)) : Sp(e, Ma(p, e));
            } else {
              if (!q[A])
                return u ? e : {};
              p = Rp(e, A, f);
            }
          }
          c || (c = new qe());
          var E = c.get(e);
          if (E)
            return E;
          c.set(e, p), Ks(e) ? e.forEach(function(P) {
            p.add(Ge(P, n, o, P, e, c));
          }) : Us(e) && e.forEach(function(P, G) {
            p.set(G, Ge(P, n, o, G, e, c));
          });
          var B = b ? g ? $o : Uo : g ? xe : pe, F = S ? i : B(e);
          return ze(F || e, function(P, G) {
            F && (G = P, P = e[G]), Ar(p, G, Ge(P, n, o, G, e, c));
          }), p;
        }
        function Wc(e) {
          var n = pe(e);
          return function(o) {
            return wa(o, e, n);
          };
        }
        function wa(e, n, o) {
          var a = o.length;
          if (e == null)
            return !a;
          for (e = W(e); a--; ) {
            var u = o[a], c = n[u], p = e[u];
            if (p === i && !(u in e) || !c(p))
              return !1;
          }
          return !0;
        }
        function Ea(e, n, o) {
          if (typeof e != "function")
            throw new Fe(_);
          return yr(function() {
            e.apply(i, o);
          }, n);
        }
        function Cr(e, n, o, a) {
          var u = -1, c = Wr, p = !0, f = e.length, g = [], b = n.length;
          if (!f)
            return g;
          o && (n = Q(n, ye(o))), a ? (c = uo, p = !1) : n.length >= d && (c = gr, p = !1, n = new kn(n));
          e:
            for (; ++u < f; ) {
              var S = e[u], A = o == null ? S : o(S);
              if (S = a || S !== 0 ? S : 0, p && A === A) {
                for (var x = b; x--; )
                  if (n[x] === A)
                    continue e;
                g.push(S);
              } else c(n, A, a) || g.push(S);
            }
          return g;
        }
        var Sn = ns(Ye), Na = ns(xo, !0);
        function qc(e, n) {
          var o = !0;
          return Sn(e, function(a, u, c) {
            return o = !!n(a, u, c), o;
          }), o;
        }
        function dt(e, n, o) {
          for (var a = -1, u = e.length; ++a < u; ) {
            var c = e[a], p = n(c);
            if (p != null && (f === i ? p === p && !Be(p) : o(p, f)))
              var f = p, g = c;
          }
          return g;
        }
        function Vc(e, n, o, a) {
          var u = e.length;
          for (o = z(o), o < 0 && (o = -o > u ? 0 : u + o), a = a === i || a > u ? u : z(a), a < 0 && (a += u), a = o > a ? 0 : Ws(a); o < a; )
            e[o++] = n;
          return e;
        }
        function ya(e, n) {
          var o = [];
          return Sn(e, function(a, u, c) {
            n(a, u, c) && o.push(a);
          }), o;
        }
        function he(e, n, o, a, u) {
          var c = -1, p = e.length;
          for (o || (o = zp), u || (u = []); ++c < p; ) {
            var f = e[c];
            n > 0 && o(f) ? n > 1 ? he(f, n - 1, o, a, u) : vn(u, f) : a || (u[u.length] = f);
          }
          return u;
        }
        var Co = rs(), ka = rs(!0);
        function Ye(e, n) {
          return e && Co(e, n, pe);
        }
        function xo(e, n) {
          return e && ka(e, n, pe);
        }
        function ct(e, n) {
          return gn(n, function(o) {
            return cn(e[o]);
          });
        }
        function Pn(e, n) {
          n = An(n, e);
          for (var o = 0, a = n.length; e != null && o < a; )
            e = e[Qe(n[o++])];
          return o && o == a ? e : i;
        }
        function Ba(e, n, o) {
          var a = n(e);
          return L(e) ? a : vn(a, o(e));
        }
        function Ie(e) {
          return e == null ? e === i ? Al : Sl : Nn && Nn in W(e) ? yp(e) : $p(e);
        }
        function Mo(e, n) {
          return e > n;
        }
        function Jc(e, n) {
          return e != null && K.call(e, n);
        }
        function jc(e, n) {
          return e != null && n in W(e);
        }
        function Yc(e, n, o) {
          return e >= me(n, o) && e < ce(n, o);
        }
        function wo(e, n, o) {
          for (var a = o ? uo : Wr, u = e[0].length, c = e.length, p = c, f = v(c), g = 1 / 0, b = []; p--; ) {
            var S = e[p];
            p && n && (S = Q(S, ye(n))), g = me(S.length, g), f[p] = !o && (n || u >= 120 && S.length >= 120) ? new kn(p && S) : i;
          }
          S = e[0];
          var A = -1, x = f[0];
          e:
            for (; ++A < u && b.length < g; ) {
              var E = S[A], B = n ? n(E) : E;
              if (E = o || E !== 0 ? E : 0, !(x ? gr(x, B) : a(b, B, o))) {
                for (p = c; --p; ) {
                  var F = f[p];
                  if (!(F ? gr(F, B) : a(e[p], B, o)))
                    continue e;
                }
                x && x.push(B), b.push(E);
              }
            }
          return b;
        }
        function Xc(e, n, o, a) {
          return Ye(e, function(u, c, p) {
            n(a, o(u), c, p);
          }), a;
        }
        function xr(e, n, o) {
          n = An(n, e), e = Is(e, n);
          var a = e == null ? e : e[Qe(De(n))];
          return a == null ? i : Ne(a, e, o);
        }
        function Pa(e) {
          return te(e) && Ie(e) == Dn;
        }
        function Qc(e) {
          return te(e) && Ie(e) == mr;
        }
        function ep(e) {
          return te(e) && Ie(e) == cr;
        }
        function Mr(e, n, o, a, u) {
          return e === n ? !0 : e == null || n == null || !te(e) && !te(n) ? e !== e && n !== n : np(e, n, o, a, Mr, u);
        }
        function np(e, n, o, a, u, c) {
          var p = L(e), f = L(n), g = p ? Gr : ge(e), b = f ? Gr : ge(n);
          g = g == Dn ? tn : g, b = b == Dn ? tn : b;
          var S = g == tn, A = b == tn, x = g == b;
          if (x && xn(e)) {
            if (!xn(n))
              return !1;
            p = !0, S = !1;
          }
          if (x && !S)
            return c || (c = new qe()), p || nr(e) ? ps(e, n, o, a, u, c) : Ep(e, n, g, o, a, u, c);
          if (!(o & se)) {
            var E = S && K.call(e, "__wrapped__"), B = A && K.call(n, "__wrapped__");
            if (E || B) {
              var F = E ? e.value() : e, P = B ? n.value() : n;
              return c || (c = new qe()), u(F, P, o, a, c);
            }
          }
          return x ? (c || (c = new qe()), Np(e, n, o, a, u, c)) : !1;
        }
        function rp(e) {
          return te(e) && ge(e) == Ke;
        }
        function Eo(e, n, o, a) {
          var u = o.length, c = u, p = !a;
          if (e == null)
            return !c;
          for (e = W(e); u--; ) {
            var f = o[u];
            if (p && f[2] ? f[1] !== e[f[0]] : !(f[0] in e))
              return !1;
          }
          for (; ++u < c; ) {
            f = o[u];
            var g = f[0], b = e[g], S = f[1];
            if (p && f[2]) {
              if (b === i && !(g in e))
                return !1;
            } else {
              var A = new qe();
              if (a)
                var x = a(b, S, g, e, n, A);
              if (!(x === i ? Mr(S, b, se | hn, a, A) : x))
                return !1;
            }
          }
          return !0;
        }
        function Ra(e) {
          if (!ne(e) || Op(e))
            return !1;
          var n = cn(e) ? rc : Wl;
          return n.test(Ln(e));
        }
        function tp(e) {
          return te(e) && Ie(e) == fr;
        }
        function op(e) {
          return te(e) && ge(e) == He;
        }
        function ip(e) {
          return te(e) && Et(e.length) && !!Y[Ie(e)];
        }
        function La(e) {
          return typeof e == "function" ? e : e == null ? Me : typeof e == "object" ? L(e) ? Oa(e[0], e[1]) : Fa(e) : tu(e);
        }
        function No(e) {
          if (!Nr(e))
            return uc(e);
          var n = [];
          for (var o in W(e))
            K.call(e, o) && o != "constructor" && n.push(o);
          return n;
        }
        function ap(e) {
          if (!ne(e))
            return Up(e);
          var n = Nr(e), o = [];
          for (var a in e)
            a == "constructor" && (n || !K.call(e, a)) || o.push(a);
          return o;
        }
        function yo(e, n) {
          return e < n;
        }
        function za(e, n) {
          var o = -1, a = Ce(e) ? v(e.length) : [];
          return Sn(e, function(u, c, p) {
            a[++o] = n(u, c, p);
          }), a;
        }
        function Fa(e) {
          var n = Ho(e);
          return n.length == 1 && n[0][2] ? gs(n[0][0], n[0][1]) : function(o) {
            return o === e || Eo(o, e, n);
          };
        }
        function Oa(e, n) {
          return qo(e) && ms(n) ? gs(Qe(e), n) : function(o) {
            var a = ti(o, e);
            return a === i && a === n ? oi(o, e) : Mr(n, a, se | hn);
          };
        }
        function pt(e, n, o, a, u) {
          e !== n && Co(n, function(c, p) {
            if (u || (u = new qe()), ne(c))
              sp(e, n, p, o, pt, a, u);
            else {
              var f = a ? a(Jo(e, p), c, p + "", e, n, u) : i;
              f === i && (f = c), To(e, p, f);
            }
          }, xe);
        }
        function sp(e, n, o, a, u, c, p) {
          var f = Jo(e, o), g = Jo(n, o), b = p.get(g);
          if (b) {
            To(e, o, b);
            return;
          }
          var S = c ? c(f, g, o + "", e, n, p) : i, A = S === i;
          if (A) {
            var x = L(g), E = !x && xn(g), B = !x && !E && nr(g);
            S = g, x || E || B ? L(f) ? S = f : oe(f) ? S = Ae(f) : E ? (A = !1, S = ja(g, !0)) : B ? (A = !1, S = Ya(g, !0)) : S = [] : kr(g) || zn(g) ? (S = f, zn(f) ? S = qs(f) : (!ne(f) || cn(f)) && (S = _s(g))) : A = !1;
          }
          A && (p.set(g, S), u(S, g, a, c, p), p.delete(g)), To(e, o, S);
        }
        function Ga(e, n) {
          var o = e.length;
          if (o)
            return n += n < 0 ? o : 0, dn(n, o) ? e[n] : i;
        }
        function Za(e, n, o) {
          n.length ? n = Q(n, function(c) {
            return L(c) ? function(p) {
              return Pn(p, c.length === 1 ? c[0] : c);
            } : c;
          }) : n = [Me];
          var a = -1;
          n = Q(n, ye(k()));
          var u = za(e, function(c, p, f) {
            var g = Q(n, function(b) {
              return b(c);
            });
            return { criteria: g, index: ++a, value: c };
          });
          return Rd(u, function(c, p) {
            return bp(c, p, o);
          });
        }
        function up(e, n) {
          return Da(e, n, function(o, a) {
            return oi(e, a);
          });
        }
        function Da(e, n, o) {
          for (var a = -1, u = n.length, c = {}; ++a < u; ) {
            var p = n[a], f = Pn(e, p);
            o(f, p) && wr(c, An(p, e), f);
          }
          return c;
        }
        function lp(e) {
          return function(n) {
            return Pn(n, e);
          };
        }
        function ko(e, n, o, a) {
          var u = a ? Pd : Kn, c = -1, p = n.length, f = e;
          for (e === n && (n = Ae(n)), o && (f = Q(e, ye(o))); ++c < p; )
            for (var g = 0, b = n[c], S = o ? o(b) : b; (g = u(f, S, g, a)) > -1; )
              f !== e && rt.call(f, g, 1), rt.call(e, g, 1);
          return e;
        }
        function Ua(e, n) {
          for (var o = e ? n.length : 0, a = o - 1; o--; ) {
            var u = n[o];
            if (o == a || u !== c) {
              var c = u;
              dn(u) ? rt.call(e, u, 1) : Lo(e, u);
            }
          }
          return e;
        }
        function Bo(e, n) {
          return e + it(Ta() * (n - e + 1));
        }
        function dp(e, n, o, a) {
          for (var u = -1, c = ce(ot((n - e) / (o || 1)), 0), p = v(c); c--; )
            p[a ? c : ++u] = e, e += o;
          return p;
        }
        function Po(e, n) {
          var o = "";
          if (!e || n < 1 || n > mn)
            return o;
          do
            n % 2 && (o += e), n = it(n / 2), n && (e += e);
          while (n);
          return o;
        }
        function O(e, n) {
          return jo(vs(e, n, Me), e + "");
        }
        function cp(e) {
          return xa(rr(e));
        }
        function pp(e, n) {
          var o = rr(e);
          return Tt(o, Bn(n, 0, o.length));
        }
        function wr(e, n, o, a) {
          if (!ne(e))
            return e;
          n = An(n, e);
          for (var u = -1, c = n.length, p = c - 1, f = e; f != null && ++u < c; ) {
            var g = Qe(n[u]), b = o;
            if (g === "__proto__" || g === "constructor" || g === "prototype")
              return e;
            if (u != p) {
              var S = f[g];
              b = a ? a(S, g, f) : i, b === i && (b = ne(S) ? S : dn(n[u + 1]) ? [] : {});
            }
            Ar(f, g, b), f = f[g];
          }
          return e;
        }
        var $a = at ? function(e, n) {
          return at.set(e, n), e;
        } : Me, fp = tt ? function(e, n) {
          return tt(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: ai(n),
            writable: !0
          });
        } : Me;
        function hp(e) {
          return Tt(rr(e));
        }
        function Ze(e, n, o) {
          var a = -1, u = e.length;
          n < 0 && (n = -n > u ? 0 : u + n), o = o > u ? u : o, o < 0 && (o += u), u = n > o ? 0 : o - n >>> 0, n >>>= 0;
          for (var c = v(u); ++a < u; )
            c[a] = e[a + n];
          return c;
        }
        function _p(e, n) {
          var o;
          return Sn(e, function(a, u, c) {
            return o = n(a, u, c), !o;
          }), !!o;
        }
        function ft(e, n, o) {
          var a = 0, u = e == null ? a : e.length;
          if (typeof n == "number" && n === n && u <= gl) {
            for (; a < u; ) {
              var c = a + u >>> 1, p = e[c];
              p !== null && !Be(p) && (o ? p <= n : p < n) ? a = c + 1 : u = c;
            }
            return u;
          }
          return Ro(e, n, Me, o);
        }
        function Ro(e, n, o, a) {
          var u = 0, c = e == null ? 0 : e.length;
          if (c === 0)
            return 0;
          n = o(n);
          for (var p = n !== n, f = n === null, g = Be(n), b = n === i; u < c; ) {
            var S = it((u + c) / 2), A = o(e[S]), x = A !== i, E = A === null, B = A === A, F = Be(A);
            if (p)
              var P = a || B;
            else b ? P = B && (a || x) : f ? P = B && x && (a || !E) : g ? P = B && x && !E && (a || !F) : E || F ? P = !1 : P = a ? A <= n : A < n;
            P ? u = S + 1 : c = S;
          }
          return me(c, ml);
        }
        function Ka(e, n) {
          for (var o = -1, a = e.length, u = 0, c = []; ++o < a; ) {
            var p = e[o], f = n ? n(p) : p;
            if (!o || !Ve(f, g)) {
              var g = f;
              c[u++] = p === 0 ? 0 : p;
            }
          }
          return c;
        }
        function Ha(e) {
          return typeof e == "number" ? e : Be(e) ? Or : +e;
        }
        function ke(e) {
          if (typeof e == "string")
            return e;
          if (L(e))
            return Q(e, ke) + "";
          if (Be(e))
            return Aa ? Aa.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -wn ? "-0" : n;
        }
        function Tn(e, n, o) {
          var a = -1, u = Wr, c = e.length, p = !0, f = [], g = f;
          if (o)
            p = !1, u = uo;
          else if (c >= d) {
            var b = n ? null : Mp(e);
            if (b)
              return Vr(b);
            p = !1, u = gr, g = new kn();
          } else
            g = n ? [] : f;
          e:
            for (; ++a < c; ) {
              var S = e[a], A = n ? n(S) : S;
              if (S = o || S !== 0 ? S : 0, p && A === A) {
                for (var x = g.length; x--; )
                  if (g[x] === A)
                    continue e;
                n && g.push(A), f.push(S);
              } else u(g, A, o) || (g !== f && g.push(A), f.push(S));
            }
          return f;
        }
        function Lo(e, n) {
          n = An(n, e);
          var o = -1, a = n.length;
          if (!a)
            return !0;
          for (var u = e == null || typeof e != "object" && typeof e != "function"; ++o < a; ) {
            var c = n[o];
            if (typeof c == "string") {
              if (c === "__proto__" && !K.call(e, "__proto__"))
                return !1;
              if (c === "constructor" && o + 1 < a && typeof n[o + 1] == "string" && n[o + 1] === "prototype") {
                if (u && o === 0)
                  continue;
                return !1;
              }
            }
          }
          var p = Is(e, n);
          return p == null || delete p[Qe(De(n))];
        }
        function Wa(e, n, o, a) {
          return wr(e, n, o(Pn(e, n)), a);
        }
        function ht(e, n, o, a) {
          for (var u = e.length, c = a ? u : -1; (a ? c-- : ++c < u) && n(e[c], c, e); )
            ;
          return o ? Ze(e, a ? 0 : c, a ? c + 1 : u) : Ze(e, a ? c + 1 : 0, a ? u : c);
        }
        function qa(e, n) {
          var o = e;
          return o instanceof D && (o = o.value()), lo(n, function(a, u) {
            return u.func.apply(u.thisArg, vn([a], u.args));
          }, o);
        }
        function zo(e, n, o) {
          var a = e.length;
          if (a < 2)
            return a ? Tn(e[0]) : [];
          for (var u = -1, c = v(a); ++u < a; )
            for (var p = e[u], f = -1; ++f < a; )
              f != u && (c[u] = Cr(c[u] || p, e[f], n, o));
          return Tn(he(c, 1), n, o);
        }
        function Va(e, n, o) {
          for (var a = -1, u = e.length, c = n.length, p = {}; ++a < u; ) {
            var f = a < c ? n[a] : i;
            o(p, e[a], f);
          }
          return p;
        }
        function Fo(e) {
          return oe(e) ? e : [];
        }
        function Oo(e) {
          return typeof e == "function" ? e : Me;
        }
        function An(e, n) {
          return L(e) ? e : qo(e, n) ? [e] : As(H(e));
        }
        var mp = O;
        function Cn(e, n, o) {
          var a = e.length;
          return o = o === i ? a : o, !n && o >= a ? e : Ze(e, n, o);
        }
        var Ja = tc || function(e) {
          return fe.clearTimeout(e);
        };
        function ja(e, n) {
          if (n)
            return e.slice();
          var o = e.length, a = ga ? ga(o) : new e.constructor(o);
          return e.copy(a), a;
        }
        function Go(e) {
          var n = new e.constructor(e.byteLength);
          return new et(n).set(new et(e)), n;
        }
        function gp(e, n) {
          var o = n ? Go(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.byteLength);
        }
        function vp(e) {
          var n = new e.constructor(e.source, Pi.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function Ip(e) {
          return Tr ? W(Tr.call(e)) : {};
        }
        function Ya(e, n) {
          var o = n ? Go(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.length);
        }
        function Xa(e, n) {
          if (e !== n) {
            var o = e !== i, a = e === null, u = e === e, c = Be(e), p = n !== i, f = n === null, g = n === n, b = Be(n);
            if (!f && !b && !c && e > n || c && p && g && !f && !b || a && p && g || !o && g || !u)
              return 1;
            if (!a && !c && !b && e < n || b && o && u && !a && !c || f && o && u || !p && u || !g)
              return -1;
          }
          return 0;
        }
        function bp(e, n, o) {
          for (var a = -1, u = e.criteria, c = n.criteria, p = u.length, f = o.length; ++a < p; ) {
            var g = Xa(u[a], c[a]);
            if (g) {
              if (a >= f)
                return g;
              var b = o[a];
              return g * (b == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function Qa(e, n, o, a) {
          for (var u = -1, c = e.length, p = o.length, f = -1, g = n.length, b = ce(c - p, 0), S = v(g + b), A = !a; ++f < g; )
            S[f] = n[f];
          for (; ++u < p; )
            (A || u < c) && (S[o[u]] = e[u]);
          for (; b--; )
            S[f++] = e[u++];
          return S;
        }
        function es(e, n, o, a) {
          for (var u = -1, c = e.length, p = -1, f = o.length, g = -1, b = n.length, S = ce(c - f, 0), A = v(S + b), x = !a; ++u < S; )
            A[u] = e[u];
          for (var E = u; ++g < b; )
            A[E + g] = n[g];
          for (; ++p < f; )
            (x || u < c) && (A[E + o[p]] = e[u++]);
          return A;
        }
        function Ae(e, n) {
          var o = -1, a = e.length;
          for (n || (n = v(a)); ++o < a; )
            n[o] = e[o];
          return n;
        }
        function Xe(e, n, o, a) {
          var u = !o;
          o || (o = {});
          for (var c = -1, p = n.length; ++c < p; ) {
            var f = n[c], g = a ? a(o[f], e[f], f, o, e) : i;
            g === i && (g = e[f]), u ? sn(o, f, g) : Ar(o, f, g);
          }
          return o;
        }
        function Sp(e, n) {
          return Xe(e, Wo(e), n);
        }
        function Tp(e, n) {
          return Xe(e, fs(e), n);
        }
        function _t(e, n) {
          return function(o, a) {
            var u = L(o) ? wd : Kc, c = n ? n() : {};
            return u(o, e, k(a, 2), c);
          };
        }
        function Xn(e) {
          return O(function(n, o) {
            var a = -1, u = o.length, c = u > 1 ? o[u - 1] : i, p = u > 2 ? o[2] : i;
            for (c = e.length > 3 && typeof c == "function" ? (u--, c) : i, p && be(o[0], o[1], p) && (c = u < 3 ? i : c, u = 1), n = W(n); ++a < u; ) {
              var f = o[a];
              f && e(n, f, a, c);
            }
            return n;
          });
        }
        function ns(e, n) {
          return function(o, a) {
            if (o == null)
              return o;
            if (!Ce(o))
              return e(o, a);
            for (var u = o.length, c = n ? u : -1, p = W(o); (n ? c-- : ++c < u) && a(p[c], c, p) !== !1; )
              ;
            return o;
          };
        }
        function rs(e) {
          return function(n, o, a) {
            for (var u = -1, c = W(n), p = a(n), f = p.length; f--; ) {
              var g = p[e ? f : ++u];
              if (o(c[g], g, c) === !1)
                break;
            }
            return n;
          };
        }
        function Ap(e, n, o) {
          var a = n & Te, u = Er(e);
          function c() {
            var p = this && this !== fe && this instanceof c ? u : e;
            return p.apply(a ? o : this, arguments);
          }
          return c;
        }
        function ts(e) {
          return function(n) {
            n = H(n);
            var o = Hn(n) ? We(n) : i, a = o ? o[0] : n.charAt(0), u = o ? Cn(o, 1).join("") : n.slice(1);
            return a[e]() + u;
          };
        }
        function Qn(e) {
          return function(n) {
            return lo(nu(eu(n).replace(fd, "")), e, "");
          };
        }
        function Er(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var o = Yn(e.prototype), a = e.apply(o, n);
            return ne(a) ? a : o;
          };
        }
        function Cp(e, n, o) {
          var a = Er(e);
          function u() {
            for (var c = arguments.length, p = v(c), f = c, g = er(u); f--; )
              p[f] = arguments[f];
            var b = c < 3 && p[0] !== g && p[c - 1] !== g ? [] : In(p, g);
            if (c -= b.length, c < o)
              return us(
                e,
                n,
                mt,
                u.placeholder,
                i,
                p,
                b,
                i,
                i,
                o - c
              );
            var S = this && this !== fe && this instanceof u ? a : e;
            return Ne(S, this, p);
          }
          return u;
        }
        function os(e) {
          return function(n, o, a) {
            var u = W(n);
            if (!Ce(n)) {
              var c = k(o, 3);
              n = pe(n), o = function(f) {
                return c(u[f], f, u);
              };
            }
            var p = e(n, o, a);
            return p > -1 ? u[c ? n[p] : p] : i;
          };
        }
        function is(e) {
          return ln(function(n) {
            var o = n.length, a = o, u = Oe.prototype.thru;
            for (e && n.reverse(); a--; ) {
              var c = n[a];
              if (typeof c != "function")
                throw new Fe(_);
              if (u && !p && bt(c) == "wrapper")
                var p = new Oe([], !0);
            }
            for (a = p ? a : o; ++a < o; ) {
              c = n[a];
              var f = bt(c), g = f == "wrapper" ? Ko(c) : i;
              g && Vo(g[0]) && g[1] == (rn | le | ve | lr) && !g[4].length && g[9] == 1 ? p = p[bt(g[0])].apply(p, g[3]) : p = c.length == 1 && Vo(c) ? p[f]() : p.thru(c);
            }
            return function() {
              var b = arguments, S = b[0];
              if (p && b.length == 1 && L(S))
                return p.plant(S).value();
              for (var A = 0, x = o ? n[A].apply(this, b) : S; ++A < o; )
                x = n[A].call(this, x);
              return x;
            };
          });
        }
        function mt(e, n, o, a, u, c, p, f, g, b) {
          var S = n & rn, A = n & Te, x = n & _n, E = n & (le | _e), B = n & $t, F = x ? i : Er(e);
          function P() {
            for (var G = arguments.length, U = v(G), Pe = G; Pe--; )
              U[Pe] = arguments[Pe];
            if (E)
              var Se = er(P), Re = zd(U, Se);
            if (a && (U = Qa(U, a, u, E)), c && (U = es(U, c, p, E)), G -= Re, E && G < b) {
              var ie = In(U, Se);
              return us(
                e,
                n,
                mt,
                P.placeholder,
                o,
                U,
                ie,
                f,
                g,
                b - G
              );
            }
            var Je = A ? o : this, fn = x ? Je[e] : e;
            return G = U.length, f ? U = Kp(U, f) : B && G > 1 && U.reverse(), S && g < G && (U.length = g), this && this !== fe && this instanceof P && (fn = F || Er(fn)), fn.apply(Je, U);
          }
          return P;
        }
        function as(e, n) {
          return function(o, a) {
            return Xc(o, e, n(a), {});
          };
        }
        function gt(e, n) {
          return function(o, a) {
            var u;
            if (o === i && a === i)
              return n;
            if (o !== i && (u = o), a !== i) {
              if (u === i)
                return a;
              typeof o == "string" || typeof a == "string" ? (o = ke(o), a = ke(a)) : (o = Ha(o), a = Ha(a)), u = e(o, a);
            }
            return u;
          };
        }
        function Zo(e) {
          return ln(function(n) {
            return n = Q(n, ye(k())), O(function(o) {
              var a = this;
              return e(n, function(u) {
                return Ne(u, a, o);
              });
            });
          });
        }
        function vt(e, n) {
          n = n === i ? " " : ke(n);
          var o = n.length;
          if (o < 2)
            return o ? Po(n, e) : n;
          var a = Po(n, ot(e / Wn(n)));
          return Hn(n) ? Cn(We(a), 0, e).join("") : a.slice(0, e);
        }
        function xp(e, n, o, a) {
          var u = n & Te, c = Er(e);
          function p() {
            for (var f = -1, g = arguments.length, b = -1, S = a.length, A = v(S + g), x = this && this !== fe && this instanceof p ? c : e; ++b < S; )
              A[b] = a[b];
            for (; g--; )
              A[b++] = arguments[++f];
            return Ne(x, u ? o : this, A);
          }
          return p;
        }
        function ss(e) {
          return function(n, o, a) {
            return a && typeof a != "number" && be(n, o, a) && (o = a = i), n = pn(n), o === i ? (o = n, n = 0) : o = pn(o), a = a === i ? n < o ? 1 : -1 : pn(a), dp(n, o, a, e);
          };
        }
        function It(e) {
          return function(n, o) {
            return typeof n == "string" && typeof o == "string" || (n = Ue(n), o = Ue(o)), e(n, o);
          };
        }
        function us(e, n, o, a, u, c, p, f, g, b) {
          var S = n & le, A = S ? p : i, x = S ? i : p, E = S ? c : i, B = S ? i : c;
          n |= S ? ve : ur, n &= ~(S ? ur : ve), n & Fr || (n &= -4);
          var F = [
            e,
            n,
            u,
            E,
            A,
            B,
            x,
            f,
            g,
            b
          ], P = o.apply(i, F);
          return Vo(e) && bs(P, F), P.placeholder = a, Ss(P, e, n);
        }
        function Do(e) {
          var n = de[e];
          return function(o, a) {
            if (o = Ue(o), a = a == null ? 0 : me(z(a), 292), a && Sa(o)) {
              var u = (H(o) + "e").split("e"), c = n(u[0] + "e" + (+u[1] + a));
              return u = (H(c) + "e").split("e"), +(u[0] + "e" + (+u[1] - a));
            }
            return n(o);
          };
        }
        var Mp = Jn && 1 / Vr(new Jn([, -0]))[1] == wn ? function(e) {
          return new Jn(e);
        } : li;
        function ls(e) {
          return function(n) {
            var o = ge(n);
            return o == Ke ? go(n) : o == He ? $d(n) : Ld(n, e(n));
          };
        }
        function un(e, n, o, a, u, c, p, f) {
          var g = n & _n;
          if (!g && typeof e != "function")
            throw new Fe(_);
          var b = a ? a.length : 0;
          if (b || (n &= -97, a = u = i), p = p === i ? p : ce(z(p), 0), f = f === i ? f : z(f), b -= u ? u.length : 0, n & ur) {
            var S = a, A = u;
            a = u = i;
          }
          var x = g ? i : Ko(e), E = [
            e,
            n,
            o,
            a,
            u,
            S,
            A,
            c,
            p,
            f
          ];
          if (x && Dp(E, x), e = E[0], n = E[1], o = E[2], a = E[3], u = E[4], f = E[9] = E[9] === i ? g ? 0 : e.length : ce(E[9] - b, 0), !f && n & (le | _e) && (n &= -25), !n || n == Te)
            var B = Ap(e, n, o);
          else n == le || n == _e ? B = Cp(e, n, f) : (n == ve || n == (Te | ve)) && !u.length ? B = xp(e, n, o, a) : B = mt.apply(i, E);
          var F = x ? $a : bs;
          return Ss(F(B, E), e, n);
        }
        function ds(e, n, o, a) {
          return e === i || Ve(e, Vn[o]) && !K.call(a, o) ? n : e;
        }
        function cs(e, n, o, a, u, c) {
          return ne(e) && ne(n) && (c.set(n, e), pt(e, n, i, cs, c), c.delete(n)), e;
        }
        function wp(e) {
          return kr(e) ? i : e;
        }
        function ps(e, n, o, a, u, c) {
          var p = o & se, f = e.length, g = n.length;
          if (f != g && !(p && g > f))
            return !1;
          var b = c.get(e), S = c.get(n);
          if (b && S)
            return b == n && S == e;
          var A = -1, x = !0, E = o & hn ? new kn() : i;
          for (c.set(e, n), c.set(n, e); ++A < f; ) {
            var B = e[A], F = n[A];
            if (a)
              var P = p ? a(F, B, A, n, e, c) : a(B, F, A, e, n, c);
            if (P !== i) {
              if (P)
                continue;
              x = !1;
              break;
            }
            if (E) {
              if (!co(n, function(G, U) {
                if (!gr(E, U) && (B === G || u(B, G, o, a, c)))
                  return E.push(U);
              })) {
                x = !1;
                break;
              }
            } else if (!(B === F || u(B, F, o, a, c))) {
              x = !1;
              break;
            }
          }
          return c.delete(e), c.delete(n), x;
        }
        function Ep(e, n, o, a, u, c, p) {
          switch (o) {
            case Un:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case mr:
              return !(e.byteLength != n.byteLength || !c(new et(e), new et(n)));
            case dr:
            case cr:
            case pr:
              return Ve(+e, +n);
            case Zr:
              return e.name == n.name && e.message == n.message;
            case fr:
            case hr:
              return e == n + "";
            case Ke:
              var f = go;
            case He:
              var g = a & se;
              if (f || (f = Vr), e.size != n.size && !g)
                return !1;
              var b = p.get(e);
              if (b)
                return b == n;
              a |= hn, p.set(e, n);
              var S = ps(f(e), f(n), a, u, c, p);
              return p.delete(e), S;
            case Ur:
              if (Tr)
                return Tr.call(e) == Tr.call(n);
          }
          return !1;
        }
        function Np(e, n, o, a, u, c) {
          var p = o & se, f = Uo(e), g = f.length, b = Uo(n), S = b.length;
          if (g != S && !p)
            return !1;
          for (var A = g; A--; ) {
            var x = f[A];
            if (!(p ? x in n : K.call(n, x)))
              return !1;
          }
          var E = c.get(e), B = c.get(n);
          if (E && B)
            return E == n && B == e;
          var F = !0;
          c.set(e, n), c.set(n, e);
          for (var P = p; ++A < g; ) {
            x = f[A];
            var G = e[x], U = n[x];
            if (a)
              var Pe = p ? a(U, G, x, n, e, c) : a(G, U, x, e, n, c);
            if (!(Pe === i ? G === U || u(G, U, o, a, c) : Pe)) {
              F = !1;
              break;
            }
            P || (P = x == "constructor");
          }
          if (F && !P) {
            var Se = e.constructor, Re = n.constructor;
            Se != Re && "constructor" in e && "constructor" in n && !(typeof Se == "function" && Se instanceof Se && typeof Re == "function" && Re instanceof Re) && (F = !1);
          }
          return c.delete(e), c.delete(n), F;
        }
        function ln(e) {
          return jo(vs(e, i, ws), e + "");
        }
        function Uo(e) {
          return Ba(e, pe, Wo);
        }
        function $o(e) {
          return Ba(e, xe, fs);
        }
        var Ko = at ? function(e) {
          return at.get(e);
        } : li;
        function bt(e) {
          for (var n = e.name + "", o = jn[n], a = K.call(jn, n) ? o.length : 0; a--; ) {
            var u = o[a], c = u.func;
            if (c == null || c == e)
              return u.name;
          }
          return n;
        }
        function er(e) {
          var n = K.call(l, "placeholder") ? l : e;
          return n.placeholder;
        }
        function k() {
          var e = l.iteratee || si;
          return e = e === si ? La : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function St(e, n) {
          var o = e.__data__;
          return Fp(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
        }
        function Ho(e) {
          for (var n = pe(e), o = n.length; o--; ) {
            var a = n[o], u = e[a];
            n[o] = [a, u, ms(u)];
          }
          return n;
        }
        function Rn(e, n) {
          var o = Zd(e, n);
          return Ra(o) ? o : i;
        }
        function yp(e) {
          var n = K.call(e, Nn), o = e[Nn];
          try {
            e[Nn] = i;
            var a = !0;
          } catch {
          }
          var u = Xr.call(e);
          return a && (n ? e[Nn] = o : delete e[Nn]), u;
        }
        var Wo = Io ? function(e) {
          return e == null ? [] : (e = W(e), gn(Io(e), function(n) {
            return Ia.call(e, n);
          }));
        } : di, fs = Io ? function(e) {
          for (var n = []; e; )
            vn(n, Wo(e)), e = nt(e);
          return n;
        } : di, ge = Ie;
        (bo && ge(new bo(new ArrayBuffer(1))) != Un || Ir && ge(new Ir()) != Ke || So && ge(So.resolve()) != Ni || Jn && ge(new Jn()) != He || br && ge(new br()) != _r) && (ge = function(e) {
          var n = Ie(e), o = n == tn ? e.constructor : i, a = o ? Ln(o) : "";
          if (a)
            switch (a) {
              case pc:
                return Un;
              case fc:
                return Ke;
              case hc:
                return Ni;
              case _c:
                return He;
              case mc:
                return _r;
            }
          return n;
        });
        function kp(e, n, o) {
          for (var a = -1, u = o.length; ++a < u; ) {
            var c = o[a], p = c.size;
            switch (c.type) {
              case "drop":
                e += p;
                break;
              case "dropRight":
                n -= p;
                break;
              case "take":
                n = me(n, e + p);
                break;
              case "takeRight":
                e = ce(e, n - p);
                break;
            }
          }
          return { start: e, end: n };
        }
        function Bp(e) {
          var n = e.match(Ol);
          return n ? n[1].split(Gl) : [];
        }
        function hs(e, n, o) {
          n = An(n, e);
          for (var a = -1, u = n.length, c = !1; ++a < u; ) {
            var p = Qe(n[a]);
            if (!(c = e != null && o(e, p)))
              break;
            e = e[p];
          }
          return c || ++a != u ? c : (u = e == null ? 0 : e.length, !!u && Et(u) && dn(p, u) && (L(e) || zn(e)));
        }
        function Pp(e) {
          var n = e.length, o = new e.constructor(n);
          return n && typeof e[0] == "string" && K.call(e, "index") && (o.index = e.index, o.input = e.input), o;
        }
        function _s(e) {
          return typeof e.constructor == "function" && !Nr(e) ? Yn(nt(e)) : {};
        }
        function Rp(e, n, o) {
          var a = e.constructor;
          switch (n) {
            case mr:
              return Go(e);
            case dr:
            case cr:
              return new a(+e);
            case Un:
              return gp(e, o);
            case Kt:
            case Ht:
            case Wt:
            case qt:
            case Vt:
            case Jt:
            case jt:
            case Yt:
            case Xt:
              return Ya(e, o);
            case Ke:
              return new a();
            case pr:
            case hr:
              return new a(e);
            case fr:
              return vp(e);
            case He:
              return new a();
            case Ur:
              return Ip(e);
          }
        }
        function Lp(e, n) {
          var o = n.length;
          if (!o)
            return e;
          var a = o - 1;
          return n[a] = (o > 1 ? "& " : "") + n[a], n = n.join(o > 2 ? ", " : " "), e.replace(Fl, `{
/* [wrapped with ` + n + `] */
`);
        }
        function zp(e) {
          return L(e) || zn(e) || !!(ba && e && e[ba]);
        }
        function dn(e, n) {
          var o = typeof e;
          return n = n ?? mn, !!n && (o == "number" || o != "symbol" && Vl.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function be(e, n, o) {
          if (!ne(o))
            return !1;
          var a = typeof n;
          return (a == "number" ? Ce(o) && dn(n, o.length) : a == "string" && n in o) ? Ve(o[n], e) : !1;
        }
        function qo(e, n) {
          if (L(e))
            return !1;
          var o = typeof e;
          return o == "number" || o == "symbol" || o == "boolean" || e == null || Be(e) ? !0 : Pl.test(e) || !Bl.test(e) || n != null && e in W(n);
        }
        function Fp(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function Vo(e) {
          var n = bt(e), o = l[n];
          if (typeof o != "function" || !(n in D.prototype))
            return !1;
          if (e === o)
            return !0;
          var a = Ko(o);
          return !!a && e === a[0];
        }
        function Op(e) {
          return !!ma && ma in e;
        }
        var Gp = jr ? cn : ci;
        function Nr(e) {
          var n = e && e.constructor, o = typeof n == "function" && n.prototype || Vn;
          return e === o;
        }
        function ms(e) {
          return e === e && !ne(e);
        }
        function gs(e, n) {
          return function(o) {
            return o == null ? !1 : o[e] === n && (n !== i || e in W(o));
          };
        }
        function Zp(e) {
          var n = Mt(e, function(a) {
            return o.size === N && o.clear(), a;
          }), o = n.cache;
          return n;
        }
        function Dp(e, n) {
          var o = e[1], a = n[1], u = o | a, c = u < (Te | _n | rn), p = a == rn && o == le || a == rn && o == lr && e[7].length <= n[8] || a == (rn | lr) && n[7].length <= n[8] && o == le;
          if (!(c || p))
            return e;
          a & Te && (e[2] = n[2], u |= o & Te ? 0 : Fr);
          var f = n[3];
          if (f) {
            var g = e[3];
            e[3] = g ? Qa(g, f, n[4]) : f, e[4] = g ? In(e[3], Z) : n[4];
          }
          return f = n[5], f && (g = e[5], e[5] = g ? es(g, f, n[6]) : f, e[6] = g ? In(e[5], Z) : n[6]), f = n[7], f && (e[7] = f), a & rn && (e[8] = e[8] == null ? n[8] : me(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = u, e;
        }
        function Up(e) {
          var n = [];
          if (e != null)
            for (var o in W(e))
              n.push(o);
          return n;
        }
        function $p(e) {
          return Xr.call(e);
        }
        function vs(e, n, o) {
          return n = ce(n === i ? e.length - 1 : n, 0), function() {
            for (var a = arguments, u = -1, c = ce(a.length - n, 0), p = v(c); ++u < c; )
              p[u] = a[n + u];
            u = -1;
            for (var f = v(n + 1); ++u < n; )
              f[u] = a[u];
            return f[n] = o(p), Ne(e, this, f);
          };
        }
        function Is(e, n) {
          return n.length < 2 ? e : Pn(e, Ze(n, 0, -1));
        }
        function Kp(e, n) {
          for (var o = e.length, a = me(n.length, o), u = Ae(e); a--; ) {
            var c = n[a];
            e[a] = dn(c, o) ? u[c] : i;
          }
          return e;
        }
        function Jo(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var bs = Ts($a), yr = ic || function(e, n) {
          return fe.setTimeout(e, n);
        }, jo = Ts(fp);
        function Ss(e, n, o) {
          var a = n + "";
          return jo(e, Lp(a, Hp(Bp(a), o)));
        }
        function Ts(e) {
          var n = 0, o = 0;
          return function() {
            var a = lc(), u = pl - (a - o);
            if (o = a, u > 0) {
              if (++n >= cl)
                return arguments[0];
            } else
              n = 0;
            return e.apply(i, arguments);
          };
        }
        function Tt(e, n) {
          var o = -1, a = e.length, u = a - 1;
          for (n = n === i ? a : n; ++o < n; ) {
            var c = Bo(o, u), p = e[c];
            e[c] = e[o], e[o] = p;
          }
          return e.length = n, e;
        }
        var As = Zp(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(Rl, function(o, a, u, c) {
            n.push(u ? c.replace(Ul, "$1") : a || o);
          }), n;
        });
        function Qe(e) {
          if (typeof e == "string" || Be(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -wn ? "-0" : n;
        }
        function Ln(e) {
          if (e != null) {
            try {
              return Yr.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function Hp(e, n) {
          return ze(vl, function(o) {
            var a = "_." + o[0];
            n & o[1] && !Wr(e, a) && e.push(a);
          }), e.sort();
        }
        function Cs(e) {
          if (e instanceof D)
            return e.clone();
          var n = new Oe(e.__wrapped__, e.__chain__);
          return n.__actions__ = Ae(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function Wp(e, n, o) {
          (o ? be(e, n, o) : n === i) ? n = 1 : n = ce(z(n), 0);
          var a = e == null ? 0 : e.length;
          if (!a || n < 1)
            return [];
          for (var u = 0, c = 0, p = v(ot(a / n)); u < a; )
            p[c++] = Ze(e, u, u += n);
          return p;
        }
        function qp(e) {
          for (var n = -1, o = e == null ? 0 : e.length, a = 0, u = []; ++n < o; ) {
            var c = e[n];
            c && (u[a++] = c);
          }
          return u;
        }
        function Vp() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = v(e - 1), o = arguments[0], a = e; a--; )
            n[a - 1] = arguments[a];
          return vn(L(o) ? Ae(o) : [o], he(n, 1));
        }
        var Jp = O(function(e, n) {
          return oe(e) ? Cr(e, he(n, 1, oe, !0)) : [];
        }), jp = O(function(e, n) {
          var o = De(n);
          return oe(o) && (o = i), oe(e) ? Cr(e, he(n, 1, oe, !0), k(o, 2)) : [];
        }), Yp = O(function(e, n) {
          var o = De(n);
          return oe(o) && (o = i), oe(e) ? Cr(e, he(n, 1, oe, !0), i, o) : [];
        });
        function Xp(e, n, o) {
          var a = e == null ? 0 : e.length;
          return a ? (n = o || n === i ? 1 : z(n), Ze(e, n < 0 ? 0 : n, a)) : [];
        }
        function Qp(e, n, o) {
          var a = e == null ? 0 : e.length;
          return a ? (n = o || n === i ? 1 : z(n), n = a - n, Ze(e, 0, n < 0 ? 0 : n)) : [];
        }
        function ef(e, n) {
          return e && e.length ? ht(e, k(n, 3), !0, !0) : [];
        }
        function nf(e, n) {
          return e && e.length ? ht(e, k(n, 3), !0) : [];
        }
        function rf(e, n, o, a) {
          var u = e == null ? 0 : e.length;
          return u ? (o && typeof o != "number" && be(e, n, o) && (o = 0, a = u), Vc(e, n, o, a)) : [];
        }
        function xs(e, n, o) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var u = o == null ? 0 : z(o);
          return u < 0 && (u = ce(a + u, 0)), qr(e, k(n, 3), u);
        }
        function Ms(e, n, o) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var u = a - 1;
          return o !== i && (u = z(o), u = o < 0 ? ce(a + u, 0) : me(u, a - 1)), qr(e, k(n, 3), u, !0);
        }
        function ws(e) {
          var n = e == null ? 0 : e.length;
          return n ? he(e, 1) : [];
        }
        function tf(e) {
          var n = e == null ? 0 : e.length;
          return n ? he(e, wn) : [];
        }
        function of(e, n) {
          var o = e == null ? 0 : e.length;
          return o ? (n = n === i ? 1 : z(n), he(e, n)) : [];
        }
        function af(e) {
          for (var n = -1, o = e == null ? 0 : e.length, a = {}; ++n < o; ) {
            var u = e[n];
            a[u[0]] = u[1];
          }
          return a;
        }
        function Es(e) {
          return e && e.length ? e[0] : i;
        }
        function sf(e, n, o) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var u = o == null ? 0 : z(o);
          return u < 0 && (u = ce(a + u, 0)), Kn(e, n, u);
        }
        function uf(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ze(e, 0, -1) : [];
        }
        var lf = O(function(e) {
          var n = Q(e, Fo);
          return n.length && n[0] === e[0] ? wo(n) : [];
        }), df = O(function(e) {
          var n = De(e), o = Q(e, Fo);
          return n === De(o) ? n = i : o.pop(), o.length && o[0] === e[0] ? wo(o, k(n, 2)) : [];
        }), cf = O(function(e) {
          var n = De(e), o = Q(e, Fo);
          return n = typeof n == "function" ? n : i, n && o.pop(), o.length && o[0] === e[0] ? wo(o, i, n) : [];
        });
        function pf(e, n) {
          return e == null ? "" : sc.call(e, n);
        }
        function De(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : i;
        }
        function ff(e, n, o) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var u = a;
          return o !== i && (u = z(o), u = u < 0 ? ce(a + u, 0) : me(u, a - 1)), n === n ? Hd(e, n, u) : qr(e, ua, u, !0);
        }
        function hf(e, n) {
          return e && e.length ? Ga(e, z(n)) : i;
        }
        var _f = O(Ns);
        function Ns(e, n) {
          return e && e.length && n && n.length ? ko(e, n) : e;
        }
        function mf(e, n, o) {
          return e && e.length && n && n.length ? ko(e, n, k(o, 2)) : e;
        }
        function gf(e, n, o) {
          return e && e.length && n && n.length ? ko(e, n, i, o) : e;
        }
        var vf = ln(function(e, n) {
          var o = e == null ? 0 : e.length, a = Ao(e, n);
          return Ua(e, Q(n, function(u) {
            return dn(u, o) ? +u : u;
          }).sort(Xa)), a;
        });
        function If(e, n) {
          var o = [];
          if (!(e && e.length))
            return o;
          var a = -1, u = [], c = e.length;
          for (n = k(n, 3); ++a < c; ) {
            var p = e[a];
            n(p, a, e) && (o.push(p), u.push(a));
          }
          return Ua(e, u), o;
        }
        function Yo(e) {
          return e == null ? e : cc.call(e);
        }
        function bf(e, n, o) {
          var a = e == null ? 0 : e.length;
          return a ? (o && typeof o != "number" && be(e, n, o) ? (n = 0, o = a) : (n = n == null ? 0 : z(n), o = o === i ? a : z(o)), Ze(e, n, o)) : [];
        }
        function Sf(e, n) {
          return ft(e, n);
        }
        function Tf(e, n, o) {
          return Ro(e, n, k(o, 2));
        }
        function Af(e, n) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var a = ft(e, n);
            if (a < o && Ve(e[a], n))
              return a;
          }
          return -1;
        }
        function Cf(e, n) {
          return ft(e, n, !0);
        }
        function xf(e, n, o) {
          return Ro(e, n, k(o, 2), !0);
        }
        function Mf(e, n) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var a = ft(e, n, !0) - 1;
            if (Ve(e[a], n))
              return a;
          }
          return -1;
        }
        function wf(e) {
          return e && e.length ? Ka(e) : [];
        }
        function Ef(e, n) {
          return e && e.length ? Ka(e, k(n, 2)) : [];
        }
        function Nf(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ze(e, 1, n) : [];
        }
        function yf(e, n, o) {
          return e && e.length ? (n = o || n === i ? 1 : z(n), Ze(e, 0, n < 0 ? 0 : n)) : [];
        }
        function kf(e, n, o) {
          var a = e == null ? 0 : e.length;
          return a ? (n = o || n === i ? 1 : z(n), n = a - n, Ze(e, n < 0 ? 0 : n, a)) : [];
        }
        function Bf(e, n) {
          return e && e.length ? ht(e, k(n, 3), !1, !0) : [];
        }
        function Pf(e, n) {
          return e && e.length ? ht(e, k(n, 3)) : [];
        }
        var Rf = O(function(e) {
          return Tn(he(e, 1, oe, !0));
        }), Lf = O(function(e) {
          var n = De(e);
          return oe(n) && (n = i), Tn(he(e, 1, oe, !0), k(n, 2));
        }), zf = O(function(e) {
          var n = De(e);
          return n = typeof n == "function" ? n : i, Tn(he(e, 1, oe, !0), i, n);
        });
        function Ff(e) {
          return e && e.length ? Tn(e) : [];
        }
        function Of(e, n) {
          return e && e.length ? Tn(e, k(n, 2)) : [];
        }
        function Gf(e, n) {
          return n = typeof n == "function" ? n : i, e && e.length ? Tn(e, i, n) : [];
        }
        function Xo(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = gn(e, function(o) {
            if (oe(o))
              return n = ce(o.length, n), !0;
          }), _o(n, function(o) {
            return Q(e, po(o));
          });
        }
        function ys(e, n) {
          if (!(e && e.length))
            return [];
          var o = Xo(e);
          return n == null ? o : Q(o, function(a) {
            return Ne(n, i, a);
          });
        }
        var Zf = O(function(e, n) {
          return oe(e) ? Cr(e, n) : [];
        }), Df = O(function(e) {
          return zo(gn(e, oe));
        }), Uf = O(function(e) {
          var n = De(e);
          return oe(n) && (n = i), zo(gn(e, oe), k(n, 2));
        }), $f = O(function(e) {
          var n = De(e);
          return n = typeof n == "function" ? n : i, zo(gn(e, oe), i, n);
        }), Kf = O(Xo);
        function Hf(e, n) {
          return Va(e || [], n || [], Ar);
        }
        function Wf(e, n) {
          return Va(e || [], n || [], wr);
        }
        var qf = O(function(e) {
          var n = e.length, o = n > 1 ? e[n - 1] : i;
          return o = typeof o == "function" ? (e.pop(), o) : i, ys(e, o);
        });
        function ks(e) {
          var n = l(e);
          return n.__chain__ = !0, n;
        }
        function Vf(e, n) {
          return n(e), e;
        }
        function At(e, n) {
          return n(e);
        }
        var Jf = ln(function(e) {
          var n = e.length, o = n ? e[0] : 0, a = this.__wrapped__, u = function(c) {
            return Ao(c, e);
          };
          return n > 1 || this.__actions__.length || !(a instanceof D) || !dn(o) ? this.thru(u) : (a = a.slice(o, +o + (n ? 1 : 0)), a.__actions__.push({
            func: At,
            args: [u],
            thisArg: i
          }), new Oe(a, this.__chain__).thru(function(c) {
            return n && !c.length && c.push(i), c;
          }));
        });
        function jf() {
          return ks(this);
        }
        function Yf() {
          return new Oe(this.value(), this.__chain__);
        }
        function Xf() {
          this.__values__ === i && (this.__values__ = Hs(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? i : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function Qf() {
          return this;
        }
        function eh(e) {
          for (var n, o = this; o instanceof ut; ) {
            var a = Cs(o);
            a.__index__ = 0, a.__values__ = i, n ? u.__wrapped__ = a : n = a;
            var u = a;
            o = o.__wrapped__;
          }
          return u.__wrapped__ = e, n;
        }
        function nh() {
          var e = this.__wrapped__;
          if (e instanceof D) {
            var n = e;
            return this.__actions__.length && (n = new D(this)), n = n.reverse(), n.__actions__.push({
              func: At,
              args: [Yo],
              thisArg: i
            }), new Oe(n, this.__chain__);
          }
          return this.thru(Yo);
        }
        function rh() {
          return qa(this.__wrapped__, this.__actions__);
        }
        var th = _t(function(e, n, o) {
          K.call(e, o) ? ++e[o] : sn(e, o, 1);
        });
        function oh(e, n, o) {
          var a = L(e) ? aa : qc;
          return o && be(e, n, o) && (n = i), a(e, k(n, 3));
        }
        function ih(e, n) {
          var o = L(e) ? gn : ya;
          return o(e, k(n, 3));
        }
        var ah = os(xs), sh = os(Ms);
        function uh(e, n) {
          return he(Ct(e, n), 1);
        }
        function lh(e, n) {
          return he(Ct(e, n), wn);
        }
        function dh(e, n, o) {
          return o = o === i ? 1 : z(o), he(Ct(e, n), o);
        }
        function Bs(e, n) {
          var o = L(e) ? ze : Sn;
          return o(e, k(n, 3));
        }
        function Ps(e, n) {
          var o = L(e) ? Ed : Na;
          return o(e, k(n, 3));
        }
        var ch = _t(function(e, n, o) {
          K.call(e, o) ? e[o].push(n) : sn(e, o, [n]);
        });
        function ph(e, n, o, a) {
          e = Ce(e) ? e : rr(e), o = o && !a ? z(o) : 0;
          var u = e.length;
          return o < 0 && (o = ce(u + o, 0)), Nt(e) ? o <= u && e.indexOf(n, o) > -1 : !!u && Kn(e, n, o) > -1;
        }
        var fh = O(function(e, n, o) {
          var a = -1, u = typeof n == "function", c = Ce(e) ? v(e.length) : [];
          return Sn(e, function(p) {
            c[++a] = u ? Ne(n, p, o) : xr(p, n, o);
          }), c;
        }), hh = _t(function(e, n, o) {
          sn(e, o, n);
        });
        function Ct(e, n) {
          var o = L(e) ? Q : za;
          return o(e, k(n, 3));
        }
        function _h(e, n, o, a) {
          return e == null ? [] : (L(n) || (n = n == null ? [] : [n]), o = a ? i : o, L(o) || (o = o == null ? [] : [o]), Za(e, n, o));
        }
        var mh = _t(function(e, n, o) {
          e[o ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function gh(e, n, o) {
          var a = L(e) ? lo : da, u = arguments.length < 3;
          return a(e, k(n, 4), o, u, Sn);
        }
        function vh(e, n, o) {
          var a = L(e) ? Nd : da, u = arguments.length < 3;
          return a(e, k(n, 4), o, u, Na);
        }
        function Ih(e, n) {
          var o = L(e) ? gn : ya;
          return o(e, wt(k(n, 3)));
        }
        function bh(e) {
          var n = L(e) ? xa : cp;
          return n(e);
        }
        function Sh(e, n, o) {
          (o ? be(e, n, o) : n === i) ? n = 1 : n = z(n);
          var a = L(e) ? Uc : pp;
          return a(e, n);
        }
        function Th(e) {
          var n = L(e) ? $c : hp;
          return n(e);
        }
        function Ah(e) {
          if (e == null)
            return 0;
          if (Ce(e))
            return Nt(e) ? Wn(e) : e.length;
          var n = ge(e);
          return n == Ke || n == He ? e.size : No(e).length;
        }
        function Ch(e, n, o) {
          var a = L(e) ? co : _p;
          return o && be(e, n, o) && (n = i), a(e, k(n, 3));
        }
        var xh = O(function(e, n) {
          if (e == null)
            return [];
          var o = n.length;
          return o > 1 && be(e, n[0], n[1]) ? n = [] : o > 2 && be(n[0], n[1], n[2]) && (n = [n[0]]), Za(e, he(n, 1), []);
        }), xt = oc || function() {
          return fe.Date.now();
        };
        function Mh(e, n) {
          if (typeof n != "function")
            throw new Fe(_);
          return e = z(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function Rs(e, n, o) {
          return n = o ? i : n, n = e && n == null ? e.length : n, un(e, rn, i, i, i, i, n);
        }
        function Ls(e, n) {
          var o;
          if (typeof n != "function")
            throw new Fe(_);
          return e = z(e), function() {
            return --e > 0 && (o = n.apply(this, arguments)), e <= 1 && (n = i), o;
          };
        }
        var Qo = O(function(e, n, o) {
          var a = Te;
          if (o.length) {
            var u = In(o, er(Qo));
            a |= ve;
          }
          return un(e, a, n, o, u);
        }), zs = O(function(e, n, o) {
          var a = Te | _n;
          if (o.length) {
            var u = In(o, er(zs));
            a |= ve;
          }
          return un(n, a, e, o, u);
        });
        function Fs(e, n, o) {
          n = o ? i : n;
          var a = un(e, le, i, i, i, i, i, n);
          return a.placeholder = Fs.placeholder, a;
        }
        function Os(e, n, o) {
          n = o ? i : n;
          var a = un(e, _e, i, i, i, i, i, n);
          return a.placeholder = Os.placeholder, a;
        }
        function Gs(e, n, o) {
          var a, u, c, p, f, g, b = 0, S = !1, A = !1, x = !0;
          if (typeof e != "function")
            throw new Fe(_);
          n = Ue(n) || 0, ne(o) && (S = !!o.leading, A = "maxWait" in o, c = A ? ce(Ue(o.maxWait) || 0, n) : c, x = "trailing" in o ? !!o.trailing : x);
          function E(ie) {
            var Je = a, fn = u;
            return a = u = i, b = ie, p = e.apply(fn, Je), p;
          }
          function B(ie) {
            return b = ie, f = yr(G, n), S ? E(ie) : p;
          }
          function F(ie) {
            var Je = ie - g, fn = ie - b, ou = n - Je;
            return A ? me(ou, c - fn) : ou;
          }
          function P(ie) {
            var Je = ie - g, fn = ie - b;
            return g === i || Je >= n || Je < 0 || A && fn >= c;
          }
          function G() {
            var ie = xt();
            if (P(ie))
              return U(ie);
            f = yr(G, F(ie));
          }
          function U(ie) {
            return f = i, x && a ? E(ie) : (a = u = i, p);
          }
          function Pe() {
            f !== i && Ja(f), b = 0, a = g = u = f = i;
          }
          function Se() {
            return f === i ? p : U(xt());
          }
          function Re() {
            var ie = xt(), Je = P(ie);
            if (a = arguments, u = this, g = ie, Je) {
              if (f === i)
                return B(g);
              if (A)
                return Ja(f), f = yr(G, n), E(g);
            }
            return f === i && (f = yr(G, n)), p;
          }
          return Re.cancel = Pe, Re.flush = Se, Re;
        }
        var wh = O(function(e, n) {
          return Ea(e, 1, n);
        }), Eh = O(function(e, n, o) {
          return Ea(e, Ue(n) || 0, o);
        });
        function Nh(e) {
          return un(e, $t);
        }
        function Mt(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new Fe(_);
          var o = function() {
            var a = arguments, u = n ? n.apply(this, a) : a[0], c = o.cache;
            if (c.has(u))
              return c.get(u);
            var p = e.apply(this, a);
            return o.cache = c.set(u, p) || c, p;
          };
          return o.cache = new (Mt.Cache || an)(), o;
        }
        Mt.Cache = an;
        function wt(e) {
          if (typeof e != "function")
            throw new Fe(_);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function yh(e) {
          return Ls(2, e);
        }
        var kh = mp(function(e, n) {
          n = n.length == 1 && L(n[0]) ? Q(n[0], ye(k())) : Q(he(n, 1), ye(k()));
          var o = n.length;
          return O(function(a) {
            for (var u = -1, c = me(a.length, o); ++u < c; )
              a[u] = n[u].call(this, a[u]);
            return Ne(e, this, a);
          });
        }), ei = O(function(e, n) {
          var o = In(n, er(ei));
          return un(e, ve, i, n, o);
        }), Zs = O(function(e, n) {
          var o = In(n, er(Zs));
          return un(e, ur, i, n, o);
        }), Bh = ln(function(e, n) {
          return un(e, lr, i, i, i, n);
        });
        function Ph(e, n) {
          if (typeof e != "function")
            throw new Fe(_);
          return n = n === i ? n : z(n), O(e, n);
        }
        function Rh(e, n) {
          if (typeof e != "function")
            throw new Fe(_);
          return n = n == null ? 0 : ce(z(n), 0), O(function(o) {
            var a = o[n], u = Cn(o, 0, n);
            return a && vn(u, a), Ne(e, this, u);
          });
        }
        function Lh(e, n, o) {
          var a = !0, u = !0;
          if (typeof e != "function")
            throw new Fe(_);
          return ne(o) && (a = "leading" in o ? !!o.leading : a, u = "trailing" in o ? !!o.trailing : u), Gs(e, n, {
            leading: a,
            maxWait: n,
            trailing: u
          });
        }
        function zh(e) {
          return Rs(e, 1);
        }
        function Fh(e, n) {
          return ei(Oo(n), e);
        }
        function Oh() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return L(e) ? e : [e];
        }
        function Gh(e) {
          return Ge(e, j);
        }
        function Zh(e, n) {
          return n = typeof n == "function" ? n : i, Ge(e, j, n);
        }
        function Dh(e) {
          return Ge(e, X | j);
        }
        function Uh(e, n) {
          return n = typeof n == "function" ? n : i, Ge(e, X | j, n);
        }
        function $h(e, n) {
          return n == null || wa(e, n, pe(n));
        }
        function Ve(e, n) {
          return e === n || e !== e && n !== n;
        }
        var Kh = It(Mo), Hh = It(function(e, n) {
          return e >= n;
        }), zn = Pa(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Pa : function(e) {
          return te(e) && K.call(e, "callee") && !Ia.call(e, "callee");
        }, L = v.isArray, Wh = ea ? ye(ea) : Qc;
        function Ce(e) {
          return e != null && Et(e.length) && !cn(e);
        }
        function oe(e) {
          return te(e) && Ce(e);
        }
        function qh(e) {
          return e === !0 || e === !1 || te(e) && Ie(e) == dr;
        }
        var xn = ac || ci, Vh = na ? ye(na) : ep;
        function Jh(e) {
          return te(e) && e.nodeType === 1 && !kr(e);
        }
        function jh(e) {
          if (e == null)
            return !0;
          if (Ce(e) && (L(e) || typeof e == "string" || typeof e.splice == "function" || xn(e) || nr(e) || zn(e)))
            return !e.length;
          var n = ge(e);
          if (n == Ke || n == He)
            return !e.size;
          if (Nr(e))
            return !No(e).length;
          for (var o in e)
            if (K.call(e, o))
              return !1;
          return !0;
        }
        function Yh(e, n) {
          return Mr(e, n);
        }
        function Xh(e, n, o) {
          o = typeof o == "function" ? o : i;
          var a = o ? o(e, n) : i;
          return a === i ? Mr(e, n, i, o) : !!a;
        }
        function ni(e) {
          if (!te(e))
            return !1;
          var n = Ie(e);
          return n == Zr || n == bl || typeof e.message == "string" && typeof e.name == "string" && !kr(e);
        }
        function Qh(e) {
          return typeof e == "number" && Sa(e);
        }
        function cn(e) {
          if (!ne(e))
            return !1;
          var n = Ie(e);
          return n == Dr || n == Ei || n == Il || n == Tl;
        }
        function Ds(e) {
          return typeof e == "number" && e == z(e);
        }
        function Et(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= mn;
        }
        function ne(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function te(e) {
          return e != null && typeof e == "object";
        }
        var Us = ra ? ye(ra) : rp;
        function e_(e, n) {
          return e === n || Eo(e, n, Ho(n));
        }
        function n_(e, n, o) {
          return o = typeof o == "function" ? o : i, Eo(e, n, Ho(n), o);
        }
        function r_(e) {
          return $s(e) && e != +e;
        }
        function t_(e) {
          if (Gp(e))
            throw new R(h);
          return Ra(e);
        }
        function o_(e) {
          return e === null;
        }
        function i_(e) {
          return e == null;
        }
        function $s(e) {
          return typeof e == "number" || te(e) && Ie(e) == pr;
        }
        function kr(e) {
          if (!te(e) || Ie(e) != tn)
            return !1;
          var n = nt(e);
          if (n === null)
            return !0;
          var o = K.call(n, "constructor") && n.constructor;
          return typeof o == "function" && o instanceof o && Yr.call(o) == ec;
        }
        var ri = ta ? ye(ta) : tp;
        function a_(e) {
          return Ds(e) && e >= -mn && e <= mn;
        }
        var Ks = oa ? ye(oa) : op;
        function Nt(e) {
          return typeof e == "string" || !L(e) && te(e) && Ie(e) == hr;
        }
        function Be(e) {
          return typeof e == "symbol" || te(e) && Ie(e) == Ur;
        }
        var nr = ia ? ye(ia) : ip;
        function s_(e) {
          return e === i;
        }
        function u_(e) {
          return te(e) && ge(e) == _r;
        }
        function l_(e) {
          return te(e) && Ie(e) == Cl;
        }
        var d_ = It(yo), c_ = It(function(e, n) {
          return e <= n;
        });
        function Hs(e) {
          if (!e)
            return [];
          if (Ce(e))
            return Nt(e) ? We(e) : Ae(e);
          if (vr && e[vr])
            return Ud(e[vr]());
          var n = ge(e), o = n == Ke ? go : n == He ? Vr : rr;
          return o(e);
        }
        function pn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = Ue(e), e === wn || e === -wn) {
            var n = e < 0 ? -1 : 1;
            return n * _l;
          }
          return e === e ? e : 0;
        }
        function z(e) {
          var n = pn(e), o = n % 1;
          return n === n ? o ? n - o : n : 0;
        }
        function Ws(e) {
          return e ? Bn(z(e), 0, je) : 0;
        }
        function Ue(e) {
          if (typeof e == "number")
            return e;
          if (Be(e))
            return Or;
          if (ne(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ne(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = ca(e);
          var o = Hl.test(e);
          return o || ql.test(e) ? xd(e.slice(2), o ? 2 : 8) : Kl.test(e) ? Or : +e;
        }
        function qs(e) {
          return Xe(e, xe(e));
        }
        function p_(e) {
          return e ? Bn(z(e), -mn, mn) : e === 0 ? e : 0;
        }
        function H(e) {
          return e == null ? "" : ke(e);
        }
        var f_ = Xn(function(e, n) {
          if (Nr(n) || Ce(n)) {
            Xe(n, pe(n), e);
            return;
          }
          for (var o in n)
            K.call(n, o) && Ar(e, o, n[o]);
        }), Vs = Xn(function(e, n) {
          Xe(n, xe(n), e);
        }), yt = Xn(function(e, n, o, a) {
          Xe(n, xe(n), e, a);
        }), h_ = Xn(function(e, n, o, a) {
          Xe(n, pe(n), e, a);
        }), __ = ln(Ao);
        function m_(e, n) {
          var o = Yn(e);
          return n == null ? o : Ma(o, n);
        }
        var g_ = O(function(e, n) {
          e = W(e);
          var o = -1, a = n.length, u = a > 2 ? n[2] : i;
          for (u && be(n[0], n[1], u) && (a = 1); ++o < a; )
            for (var c = n[o], p = xe(c), f = -1, g = p.length; ++f < g; ) {
              var b = p[f], S = e[b];
              (S === i || Ve(S, Vn[b]) && !K.call(e, b)) && (e[b] = c[b]);
            }
          return e;
        }), v_ = O(function(e) {
          return e.push(i, cs), Ne(Js, i, e);
        });
        function I_(e, n) {
          return sa(e, k(n, 3), Ye);
        }
        function b_(e, n) {
          return sa(e, k(n, 3), xo);
        }
        function S_(e, n) {
          return e == null ? e : Co(e, k(n, 3), xe);
        }
        function T_(e, n) {
          return e == null ? e : ka(e, k(n, 3), xe);
        }
        function A_(e, n) {
          return e && Ye(e, k(n, 3));
        }
        function C_(e, n) {
          return e && xo(e, k(n, 3));
        }
        function x_(e) {
          return e == null ? [] : ct(e, pe(e));
        }
        function M_(e) {
          return e == null ? [] : ct(e, xe(e));
        }
        function ti(e, n, o) {
          var a = e == null ? i : Pn(e, n);
          return a === i ? o : a;
        }
        function w_(e, n) {
          return e != null && hs(e, n, Jc);
        }
        function oi(e, n) {
          return e != null && hs(e, n, jc);
        }
        var E_ = as(function(e, n, o) {
          n != null && typeof n.toString != "function" && (n = Xr.call(n)), e[n] = o;
        }, ai(Me)), N_ = as(function(e, n, o) {
          n != null && typeof n.toString != "function" && (n = Xr.call(n)), K.call(e, n) ? e[n].push(o) : e[n] = [o];
        }, k), y_ = O(xr);
        function pe(e) {
          return Ce(e) ? Ca(e) : No(e);
        }
        function xe(e) {
          return Ce(e) ? Ca(e, !0) : ap(e);
        }
        function k_(e, n) {
          var o = {};
          return n = k(n, 3), Ye(e, function(a, u, c) {
            sn(o, n(a, u, c), a);
          }), o;
        }
        function B_(e, n) {
          var o = {};
          return n = k(n, 3), Ye(e, function(a, u, c) {
            sn(o, u, n(a, u, c));
          }), o;
        }
        var P_ = Xn(function(e, n, o) {
          pt(e, n, o);
        }), Js = Xn(function(e, n, o, a) {
          pt(e, n, o, a);
        }), R_ = ln(function(e, n) {
          var o = {};
          if (e == null)
            return o;
          var a = !1;
          n = Q(n, function(c) {
            return c = An(c, e), a || (a = c.length > 1), c;
          }), Xe(e, $o(e), o), a && (o = Ge(o, X | J | j, wp));
          for (var u = n.length; u--; )
            Lo(o, n[u]);
          return o;
        });
        function L_(e, n) {
          return js(e, wt(k(n)));
        }
        var z_ = ln(function(e, n) {
          return e == null ? {} : up(e, n);
        });
        function js(e, n) {
          if (e == null)
            return {};
          var o = Q($o(e), function(a) {
            return [a];
          });
          return n = k(n), Da(e, o, function(a, u) {
            return n(a, u[0]);
          });
        }
        function F_(e, n, o) {
          n = An(n, e);
          var a = -1, u = n.length;
          for (u || (u = 1, e = i); ++a < u; ) {
            var c = e == null ? i : e[Qe(n[a])];
            c === i && (a = u, c = o), e = cn(c) ? c.call(e) : c;
          }
          return e;
        }
        function O_(e, n, o) {
          return e == null ? e : wr(e, n, o);
        }
        function G_(e, n, o, a) {
          return a = typeof a == "function" ? a : i, e == null ? e : wr(e, n, o, a);
        }
        var Ys = ls(pe), Xs = ls(xe);
        function Z_(e, n, o) {
          var a = L(e), u = a || xn(e) || nr(e);
          if (n = k(n, 4), o == null) {
            var c = e && e.constructor;
            u ? o = a ? new c() : [] : ne(e) ? o = cn(c) ? Yn(nt(e)) : {} : o = {};
          }
          return (u ? ze : Ye)(e, function(p, f, g) {
            return n(o, p, f, g);
          }), o;
        }
        function D_(e, n) {
          return e == null ? !0 : Lo(e, n);
        }
        function U_(e, n, o) {
          return e == null ? e : Wa(e, n, Oo(o));
        }
        function $_(e, n, o, a) {
          return a = typeof a == "function" ? a : i, e == null ? e : Wa(e, n, Oo(o), a);
        }
        function rr(e) {
          return e == null ? [] : mo(e, pe(e));
        }
        function K_(e) {
          return e == null ? [] : mo(e, xe(e));
        }
        function H_(e, n, o) {
          return o === i && (o = n, n = i), o !== i && (o = Ue(o), o = o === o ? o : 0), n !== i && (n = Ue(n), n = n === n ? n : 0), Bn(Ue(e), n, o);
        }
        function W_(e, n, o) {
          return n = pn(n), o === i ? (o = n, n = 0) : o = pn(o), e = Ue(e), Yc(e, n, o);
        }
        function q_(e, n, o) {
          if (o && typeof o != "boolean" && be(e, n, o) && (n = o = i), o === i && (typeof n == "boolean" ? (o = n, n = i) : typeof e == "boolean" && (o = e, e = i)), e === i && n === i ? (e = 0, n = 1) : (e = pn(e), n === i ? (n = e, e = 0) : n = pn(n)), e > n) {
            var a = e;
            e = n, n = a;
          }
          if (o || e % 1 || n % 1) {
            var u = Ta();
            return me(e + u * (n - e + Cd("1e-" + ((u + "").length - 1))), n);
          }
          return Bo(e, n);
        }
        var V_ = Qn(function(e, n, o) {
          return n = n.toLowerCase(), e + (o ? Qs(n) : n);
        });
        function Qs(e) {
          return ii(H(e).toLowerCase());
        }
        function eu(e) {
          return e = H(e), e && e.replace(Jl, Fd).replace(hd, "");
        }
        function J_(e, n, o) {
          e = H(e), n = ke(n);
          var a = e.length;
          o = o === i ? a : Bn(z(o), 0, a);
          var u = o;
          return o -= n.length, o >= 0 && e.slice(o, u) == n;
        }
        function j_(e) {
          return e = H(e), e && Nl.test(e) ? e.replace(ki, Od) : e;
        }
        function Y_(e) {
          return e = H(e), e && Ll.test(e) ? e.replace(Qt, "\\$&") : e;
        }
        var X_ = Qn(function(e, n, o) {
          return e + (o ? "-" : "") + n.toLowerCase();
        }), Q_ = Qn(function(e, n, o) {
          return e + (o ? " " : "") + n.toLowerCase();
        }), em = ts("toLowerCase");
        function nm(e, n, o) {
          e = H(e), n = z(n);
          var a = n ? Wn(e) : 0;
          if (!n || a >= n)
            return e;
          var u = (n - a) / 2;
          return vt(it(u), o) + e + vt(ot(u), o);
        }
        function rm(e, n, o) {
          e = H(e), n = z(n);
          var a = n ? Wn(e) : 0;
          return n && a < n ? e + vt(n - a, o) : e;
        }
        function tm(e, n, o) {
          e = H(e), n = z(n);
          var a = n ? Wn(e) : 0;
          return n && a < n ? vt(n - a, o) + e : e;
        }
        function om(e, n, o) {
          return o || n == null ? n = 0 : n && (n = +n), dc(H(e).replace(eo, ""), n || 0);
        }
        function im(e, n, o) {
          return (o ? be(e, n, o) : n === i) ? n = 1 : n = z(n), Po(H(e), n);
        }
        function am() {
          var e = arguments, n = H(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var sm = Qn(function(e, n, o) {
          return e + (o ? "_" : "") + n.toLowerCase();
        });
        function um(e, n, o) {
          return o && typeof o != "number" && be(e, n, o) && (n = o = i), o = o === i ? je : o >>> 0, o ? (e = H(e), e && (typeof n == "string" || n != null && !ri(n)) && (n = ke(n), !n && Hn(e)) ? Cn(We(e), 0, o) : e.split(n, o)) : [];
        }
        var lm = Qn(function(e, n, o) {
          return e + (o ? " " : "") + ii(n);
        });
        function dm(e, n, o) {
          return e = H(e), o = o == null ? 0 : Bn(z(o), 0, e.length), n = ke(n), e.slice(o, o + n.length) == n;
        }
        function cm(e, n, o) {
          var a = l.templateSettings;
          o && be(e, n, o) && (n = i), e = H(e), n = yt({}, n, a, ds);
          var u = yt({}, n.imports, a.imports, ds), c = pe(u), p = mo(u, c), f, g, b = 0, S = n.interpolate || $r, A = "__p += '", x = vo(
            (n.escape || $r).source + "|" + S.source + "|" + (S === Bi ? $l : $r).source + "|" + (n.evaluate || $r).source + "|$",
            "g"
          ), E = "//# sourceURL=" + (K.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Id + "]") + `
`;
          e.replace(x, function(P, G, U, Pe, Se, Re) {
            return U || (U = Pe), A += e.slice(b, Re).replace(jl, Gd), G && (f = !0, A += `' +
__e(` + G + `) +
'`), Se && (g = !0, A += `';
` + Se + `;
__p += '`), U && (A += `' +
((__t = (` + U + `)) == null ? '' : __t) +
'`), b = Re + P.length, P;
          }), A += `';
`;
          var B = K.call(n, "variable") && n.variable;
          if (!B)
            A = `with (obj) {
` + A + `
}
`;
          else if (Dl.test(B))
            throw new R(C);
          A = (g ? A.replace(xl, "") : A).replace(Ml, "$1").replace(wl, "$1;"), A = "function(" + (B || "obj") + `) {
` + (B ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (f ? ", __e = _.escape" : "") + (g ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + A + `return __p
}`;
          var F = ru(function() {
            return $(c, E + "return " + A).apply(i, p);
          });
          if (F.source = A, ni(F))
            throw F;
          return F;
        }
        function pm(e) {
          return H(e).toLowerCase();
        }
        function fm(e) {
          return H(e).toUpperCase();
        }
        function hm(e, n, o) {
          if (e = H(e), e && (o || n === i))
            return ca(e);
          if (!e || !(n = ke(n)))
            return e;
          var a = We(e), u = We(n), c = pa(a, u), p = fa(a, u) + 1;
          return Cn(a, c, p).join("");
        }
        function _m(e, n, o) {
          if (e = H(e), e && (o || n === i))
            return e.slice(0, _a(e) + 1);
          if (!e || !(n = ke(n)))
            return e;
          var a = We(e), u = fa(a, We(n)) + 1;
          return Cn(a, 0, u).join("");
        }
        function mm(e, n, o) {
          if (e = H(e), e && (o || n === i))
            return e.replace(eo, "");
          if (!e || !(n = ke(n)))
            return e;
          var a = We(e), u = pa(a, We(n));
          return Cn(a, u).join("");
        }
        function gm(e, n) {
          var o = ll, a = dl;
          if (ne(n)) {
            var u = "separator" in n ? n.separator : u;
            o = "length" in n ? z(n.length) : o, a = "omission" in n ? ke(n.omission) : a;
          }
          e = H(e);
          var c = e.length;
          if (Hn(e)) {
            var p = We(e);
            c = p.length;
          }
          if (o >= c)
            return e;
          var f = o - Wn(a);
          if (f < 1)
            return a;
          var g = p ? Cn(p, 0, f).join("") : e.slice(0, f);
          if (u === i)
            return g + a;
          if (p && (f += g.length - f), ri(u)) {
            if (e.slice(f).search(u)) {
              var b, S = g;
              for (u.global || (u = vo(u.source, H(Pi.exec(u)) + "g")), u.lastIndex = 0; b = u.exec(S); )
                var A = b.index;
              g = g.slice(0, A === i ? f : A);
            }
          } else if (e.indexOf(ke(u), f) != f) {
            var x = g.lastIndexOf(u);
            x > -1 && (g = g.slice(0, x));
          }
          return g + a;
        }
        function vm(e) {
          return e = H(e), e && El.test(e) ? e.replace(yi, Wd) : e;
        }
        var Im = Qn(function(e, n, o) {
          return e + (o ? " " : "") + n.toUpperCase();
        }), ii = ts("toUpperCase");
        function nu(e, n, o) {
          return e = H(e), n = o ? i : n, n === i ? Dd(e) ? Jd(e) : Bd(e) : e.match(n) || [];
        }
        var ru = O(function(e, n) {
          try {
            return Ne(e, i, n);
          } catch (o) {
            return ni(o) ? o : new R(o);
          }
        }), bm = ln(function(e, n) {
          return ze(n, function(o) {
            o = Qe(o), sn(e, o, Qo(e[o], e));
          }), e;
        });
        function Sm(e) {
          var n = e == null ? 0 : e.length, o = k();
          return e = n ? Q(e, function(a) {
            if (typeof a[1] != "function")
              throw new Fe(_);
            return [o(a[0]), a[1]];
          }) : [], O(function(a) {
            for (var u = -1; ++u < n; ) {
              var c = e[u];
              if (Ne(c[0], this, a))
                return Ne(c[1], this, a);
            }
          });
        }
        function Tm(e) {
          return Wc(Ge(e, X));
        }
        function ai(e) {
          return function() {
            return e;
          };
        }
        function Am(e, n) {
          return e == null || e !== e ? n : e;
        }
        var Cm = is(), xm = is(!0);
        function Me(e) {
          return e;
        }
        function si(e) {
          return La(typeof e == "function" ? e : Ge(e, X));
        }
        function Mm(e) {
          return Fa(Ge(e, X));
        }
        function wm(e, n) {
          return Oa(e, Ge(n, X));
        }
        var Em = O(function(e, n) {
          return function(o) {
            return xr(o, e, n);
          };
        }), Nm = O(function(e, n) {
          return function(o) {
            return xr(e, o, n);
          };
        });
        function ui(e, n, o) {
          var a = pe(n), u = ct(n, a);
          o == null && !(ne(n) && (u.length || !a.length)) && (o = n, n = e, e = this, u = ct(n, pe(n)));
          var c = !(ne(o) && "chain" in o) || !!o.chain, p = cn(e);
          return ze(u, function(f) {
            var g = n[f];
            e[f] = g, p && (e.prototype[f] = function() {
              var b = this.__chain__;
              if (c || b) {
                var S = e(this.__wrapped__), A = S.__actions__ = Ae(this.__actions__);
                return A.push({ func: g, args: arguments, thisArg: e }), S.__chain__ = b, S;
              }
              return g.apply(e, vn([this.value()], arguments));
            });
          }), e;
        }
        function ym() {
          return fe._ === this && (fe._ = nc), this;
        }
        function li() {
        }
        function km(e) {
          return e = z(e), O(function(n) {
            return Ga(n, e);
          });
        }
        var Bm = Zo(Q), Pm = Zo(aa), Rm = Zo(co);
        function tu(e) {
          return qo(e) ? po(Qe(e)) : lp(e);
        }
        function Lm(e) {
          return function(n) {
            return e == null ? i : Pn(e, n);
          };
        }
        var zm = ss(), Fm = ss(!0);
        function di() {
          return [];
        }
        function ci() {
          return !1;
        }
        function Om() {
          return {};
        }
        function Gm() {
          return "";
        }
        function Zm() {
          return !0;
        }
        function Dm(e, n) {
          if (e = z(e), e < 1 || e > mn)
            return [];
          var o = je, a = me(e, je);
          n = k(n), e -= je;
          for (var u = _o(a, n); ++o < e; )
            n(o);
          return u;
        }
        function Um(e) {
          return L(e) ? Q(e, Qe) : Be(e) ? [e] : Ae(As(H(e)));
        }
        function $m(e) {
          var n = ++Qd;
          return H(e) + n;
        }
        var Km = gt(function(e, n) {
          return e + n;
        }, 0), Hm = Do("ceil"), Wm = gt(function(e, n) {
          return e / n;
        }, 1), qm = Do("floor");
        function Vm(e) {
          return e && e.length ? dt(e, Me, Mo) : i;
        }
        function Jm(e, n) {
          return e && e.length ? dt(e, k(n, 2), Mo) : i;
        }
        function jm(e) {
          return la(e, Me);
        }
        function Ym(e, n) {
          return la(e, k(n, 2));
        }
        function Xm(e) {
          return e && e.length ? dt(e, Me, yo) : i;
        }
        function Qm(e, n) {
          return e && e.length ? dt(e, k(n, 2), yo) : i;
        }
        var eg = gt(function(e, n) {
          return e * n;
        }, 1), ng = Do("round"), rg = gt(function(e, n) {
          return e - n;
        }, 0);
        function tg(e) {
          return e && e.length ? ho(e, Me) : 0;
        }
        function og(e, n) {
          return e && e.length ? ho(e, k(n, 2)) : 0;
        }
        return l.after = Mh, l.ary = Rs, l.assign = f_, l.assignIn = Vs, l.assignInWith = yt, l.assignWith = h_, l.at = __, l.before = Ls, l.bind = Qo, l.bindAll = bm, l.bindKey = zs, l.castArray = Oh, l.chain = ks, l.chunk = Wp, l.compact = qp, l.concat = Vp, l.cond = Sm, l.conforms = Tm, l.constant = ai, l.countBy = th, l.create = m_, l.curry = Fs, l.curryRight = Os, l.debounce = Gs, l.defaults = g_, l.defaultsDeep = v_, l.defer = wh, l.delay = Eh, l.difference = Jp, l.differenceBy = jp, l.differenceWith = Yp, l.drop = Xp, l.dropRight = Qp, l.dropRightWhile = ef, l.dropWhile = nf, l.fill = rf, l.filter = ih, l.flatMap = uh, l.flatMapDeep = lh, l.flatMapDepth = dh, l.flatten = ws, l.flattenDeep = tf, l.flattenDepth = of, l.flip = Nh, l.flow = Cm, l.flowRight = xm, l.fromPairs = af, l.functions = x_, l.functionsIn = M_, l.groupBy = ch, l.initial = uf, l.intersection = lf, l.intersectionBy = df, l.intersectionWith = cf, l.invert = E_, l.invertBy = N_, l.invokeMap = fh, l.iteratee = si, l.keyBy = hh, l.keys = pe, l.keysIn = xe, l.map = Ct, l.mapKeys = k_, l.mapValues = B_, l.matches = Mm, l.matchesProperty = wm, l.memoize = Mt, l.merge = P_, l.mergeWith = Js, l.method = Em, l.methodOf = Nm, l.mixin = ui, l.negate = wt, l.nthArg = km, l.omit = R_, l.omitBy = L_, l.once = yh, l.orderBy = _h, l.over = Bm, l.overArgs = kh, l.overEvery = Pm, l.overSome = Rm, l.partial = ei, l.partialRight = Zs, l.partition = mh, l.pick = z_, l.pickBy = js, l.property = tu, l.propertyOf = Lm, l.pull = _f, l.pullAll = Ns, l.pullAllBy = mf, l.pullAllWith = gf, l.pullAt = vf, l.range = zm, l.rangeRight = Fm, l.rearg = Bh, l.reject = Ih, l.remove = If, l.rest = Ph, l.reverse = Yo, l.sampleSize = Sh, l.set = O_, l.setWith = G_, l.shuffle = Th, l.slice = bf, l.sortBy = xh, l.sortedUniq = wf, l.sortedUniqBy = Ef, l.split = um, l.spread = Rh, l.tail = Nf, l.take = yf, l.takeRight = kf, l.takeRightWhile = Bf, l.takeWhile = Pf, l.tap = Vf, l.throttle = Lh, l.thru = At, l.toArray = Hs, l.toPairs = Ys, l.toPairsIn = Xs, l.toPath = Um, l.toPlainObject = qs, l.transform = Z_, l.unary = zh, l.union = Rf, l.unionBy = Lf, l.unionWith = zf, l.uniq = Ff, l.uniqBy = Of, l.uniqWith = Gf, l.unset = D_, l.unzip = Xo, l.unzipWith = ys, l.update = U_, l.updateWith = $_, l.values = rr, l.valuesIn = K_, l.without = Zf, l.words = nu, l.wrap = Fh, l.xor = Df, l.xorBy = Uf, l.xorWith = $f, l.zip = Kf, l.zipObject = Hf, l.zipObjectDeep = Wf, l.zipWith = qf, l.entries = Ys, l.entriesIn = Xs, l.extend = Vs, l.extendWith = yt, ui(l, l), l.add = Km, l.attempt = ru, l.camelCase = V_, l.capitalize = Qs, l.ceil = Hm, l.clamp = H_, l.clone = Gh, l.cloneDeep = Dh, l.cloneDeepWith = Uh, l.cloneWith = Zh, l.conformsTo = $h, l.deburr = eu, l.defaultTo = Am, l.divide = Wm, l.endsWith = J_, l.eq = Ve, l.escape = j_, l.escapeRegExp = Y_, l.every = oh, l.find = ah, l.findIndex = xs, l.findKey = I_, l.findLast = sh, l.findLastIndex = Ms, l.findLastKey = b_, l.floor = qm, l.forEach = Bs, l.forEachRight = Ps, l.forIn = S_, l.forInRight = T_, l.forOwn = A_, l.forOwnRight = C_, l.get = ti, l.gt = Kh, l.gte = Hh, l.has = w_, l.hasIn = oi, l.head = Es, l.identity = Me, l.includes = ph, l.indexOf = sf, l.inRange = W_, l.invoke = y_, l.isArguments = zn, l.isArray = L, l.isArrayBuffer = Wh, l.isArrayLike = Ce, l.isArrayLikeObject = oe, l.isBoolean = qh, l.isBuffer = xn, l.isDate = Vh, l.isElement = Jh, l.isEmpty = jh, l.isEqual = Yh, l.isEqualWith = Xh, l.isError = ni, l.isFinite = Qh, l.isFunction = cn, l.isInteger = Ds, l.isLength = Et, l.isMap = Us, l.isMatch = e_, l.isMatchWith = n_, l.isNaN = r_, l.isNative = t_, l.isNil = i_, l.isNull = o_, l.isNumber = $s, l.isObject = ne, l.isObjectLike = te, l.isPlainObject = kr, l.isRegExp = ri, l.isSafeInteger = a_, l.isSet = Ks, l.isString = Nt, l.isSymbol = Be, l.isTypedArray = nr, l.isUndefined = s_, l.isWeakMap = u_, l.isWeakSet = l_, l.join = pf, l.kebabCase = X_, l.last = De, l.lastIndexOf = ff, l.lowerCase = Q_, l.lowerFirst = em, l.lt = d_, l.lte = c_, l.max = Vm, l.maxBy = Jm, l.mean = jm, l.meanBy = Ym, l.min = Xm, l.minBy = Qm, l.stubArray = di, l.stubFalse = ci, l.stubObject = Om, l.stubString = Gm, l.stubTrue = Zm, l.multiply = eg, l.nth = hf, l.noConflict = ym, l.noop = li, l.now = xt, l.pad = nm, l.padEnd = rm, l.padStart = tm, l.parseInt = om, l.random = q_, l.reduce = gh, l.reduceRight = vh, l.repeat = im, l.replace = am, l.result = F_, l.round = ng, l.runInContext = m, l.sample = bh, l.size = Ah, l.snakeCase = sm, l.some = Ch, l.sortedIndex = Sf, l.sortedIndexBy = Tf, l.sortedIndexOf = Af, l.sortedLastIndex = Cf, l.sortedLastIndexBy = xf, l.sortedLastIndexOf = Mf, l.startCase = lm, l.startsWith = dm, l.subtract = rg, l.sum = tg, l.sumBy = og, l.template = cm, l.times = Dm, l.toFinite = pn, l.toInteger = z, l.toLength = Ws, l.toLower = pm, l.toNumber = Ue, l.toSafeInteger = p_, l.toString = H, l.toUpper = fm, l.trim = hm, l.trimEnd = _m, l.trimStart = mm, l.truncate = gm, l.unescape = vm, l.uniqueId = $m, l.upperCase = Im, l.upperFirst = ii, l.each = Bs, l.eachRight = Ps, l.first = Es, ui(l, (function() {
          var e = {};
          return Ye(l, function(n, o) {
            K.call(l.prototype, o) || (e[o] = n);
          }), e;
        })(), { chain: !1 }), l.VERSION = s, ze(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          l[e].placeholder = l;
        }), ze(["drop", "take"], function(e, n) {
          D.prototype[e] = function(o) {
            o = o === i ? 1 : ce(z(o), 0);
            var a = this.__filtered__ && !n ? new D(this) : this.clone();
            return a.__filtered__ ? a.__takeCount__ = me(o, a.__takeCount__) : a.__views__.push({
              size: me(o, je),
              type: e + (a.__dir__ < 0 ? "Right" : "")
            }), a;
          }, D.prototype[e + "Right"] = function(o) {
            return this.reverse()[e](o).reverse();
          };
        }), ze(["filter", "map", "takeWhile"], function(e, n) {
          var o = n + 1, a = o == wi || o == hl;
          D.prototype[e] = function(u) {
            var c = this.clone();
            return c.__iteratees__.push({
              iteratee: k(u, 3),
              type: o
            }), c.__filtered__ = c.__filtered__ || a, c;
          };
        }), ze(["head", "last"], function(e, n) {
          var o = "take" + (n ? "Right" : "");
          D.prototype[e] = function() {
            return this[o](1).value()[0];
          };
        }), ze(["initial", "tail"], function(e, n) {
          var o = "drop" + (n ? "" : "Right");
          D.prototype[e] = function() {
            return this.__filtered__ ? new D(this) : this[o](1);
          };
        }), D.prototype.compact = function() {
          return this.filter(Me);
        }, D.prototype.find = function(e) {
          return this.filter(e).head();
        }, D.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, D.prototype.invokeMap = O(function(e, n) {
          return typeof e == "function" ? new D(this) : this.map(function(o) {
            return xr(o, e, n);
          });
        }), D.prototype.reject = function(e) {
          return this.filter(wt(k(e)));
        }, D.prototype.slice = function(e, n) {
          e = z(e);
          var o = this;
          return o.__filtered__ && (e > 0 || n < 0) ? new D(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), n !== i && (n = z(n), o = n < 0 ? o.dropRight(-n) : o.take(n - e)), o);
        }, D.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, D.prototype.toArray = function() {
          return this.take(je);
        }, Ye(D.prototype, function(e, n) {
          var o = /^(?:filter|find|map|reject)|While$/.test(n), a = /^(?:head|last)$/.test(n), u = l[a ? "take" + (n == "last" ? "Right" : "") : n], c = a || /^find/.test(n);
          u && (l.prototype[n] = function() {
            var p = this.__wrapped__, f = a ? [1] : arguments, g = p instanceof D, b = f[0], S = g || L(p), A = function(G) {
              var U = u.apply(l, vn([G], f));
              return a && x ? U[0] : U;
            };
            S && o && typeof b == "function" && b.length != 1 && (g = S = !1);
            var x = this.__chain__, E = !!this.__actions__.length, B = c && !x, F = g && !E;
            if (!c && S) {
              p = F ? p : new D(this);
              var P = e.apply(p, f);
              return P.__actions__.push({ func: At, args: [A], thisArg: i }), new Oe(P, x);
            }
            return B && F ? e.apply(this, f) : (P = this.thru(A), B ? a ? P.value()[0] : P.value() : P);
          });
        }), ze(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = Jr[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
          l.prototype[e] = function() {
            var u = arguments;
            if (a && !this.__chain__) {
              var c = this.value();
              return n.apply(L(c) ? c : [], u);
            }
            return this[o](function(p) {
              return n.apply(L(p) ? p : [], u);
            });
          };
        }), Ye(D.prototype, function(e, n) {
          var o = l[n];
          if (o) {
            var a = o.name + "";
            K.call(jn, a) || (jn[a] = []), jn[a].push({ name: n, func: o });
          }
        }), jn[mt(i, _n).name] = [{
          name: "wrapper",
          func: i
        }], D.prototype.clone = gc, D.prototype.reverse = vc, D.prototype.value = Ic, l.prototype.at = Jf, l.prototype.chain = jf, l.prototype.commit = Yf, l.prototype.next = Xf, l.prototype.plant = eh, l.prototype.reverse = nh, l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = rh, l.prototype.first = l.prototype.head, vr && (l.prototype[vr] = Qf), l;
      }), qn = jd();
      En ? ((En.exports = qn)._ = qn, ao._ = qn) : fe._ = qn;
    }).call(wb);
  })(Br, Br.exports)), Br.exports;
}
var Pr = Eb();
const o0 = (r, t) => {
  const i = Pr.mapValues(r, (d) => d === "" || d === void 0 ? null : d);
  return Pr.omit(i, t);
}, i0 = (r, t, i) => {
  const s = i ? Pr.omitBy(i, (d) => d === null) : {};
  Pr.assign(r, t, Pr.pick(s, Object.keys(r)));
}, a0 = (r) => {
  const { properties: t } = r, { context: i } = t;
  return {
    addressNumber: i.address?.address_number,
    alternate: i.region?.alternate?.name,
    country: i.country?.name,
    countryCode: i.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: i.place?.name,
    postcode: i.postcode?.name,
    region: i.region?.name,
    streetName: i.street?.name
  };
}, s0 = (r) => /^[+]?[\s0-9]{6,}$/.test(r), u0 = (r) => {
  if (typeof r != "string") return !1;
  const t = r.replace(/-\d{1,2}$/, ""), i = /^\d+$/.test(t), s = /^[a-zA-Z0-9]+$/.test(t), d = t.length;
  return i && d >= 8 && d <= 10 || s && d === 17;
}, l0 = (r, t) => {
  if (typeof r != "number" || !Number.isInteger(r)) return !1;
  const i = -(2 ** (t - 1)), s = 2 ** (t - 1) - 1;
  return r >= i && r <= s;
};
class d0 {
  constructor(t, i, s) {
    this.minBidStepAmount = t, this.maxBidStepAmount = s, this.effectiveThreshold = Math.ceil(i / t) * t;
  }
  validateAmount(t) {
    const [i, s] = t < this.effectiveThreshold ? [t, this.minBidStepAmount] : [t - this.effectiveThreshold, this.maxBidStepAmount];
    return i % s === 0;
  }
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  getDeltaStepsAmount(t, i) {
    if (!this.validateAmount(t))
      throw new Error("Error in AuctionSteppedPrice.getDeltaStepsAmount, base is not a valid amount");
    return this.computeDeltaStepsAmount(t, i);
  }
  /*
   * Implementation of the starting price computation formula defined in
   * https://adorea.atlassian.net/browse/BSD-3693
   */
  getAuctionStartingPriceDefaultValue(t) {
    const s = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(s);
  }
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  getStepRoundedValue(t, i) {
    const [s, d, h] = t < this.effectiveThreshold ? [t, this.minBidStepAmount, 0] : [t - this.effectiveThreshold, this.maxBidStepAmount, this.effectiveThreshold];
    return i(s / d) * d + h;
  }
  computeDeltaStepsAmount(t, i) {
    const s = i / Math.abs(i);
    return i === 0 ? t : this.computeDeltaStepsAmount(
      t + ((i > 0 ? t < this.effectiveThreshold : t <= this.effectiveThreshold) ? this.minBidStepAmount : this.maxBidStepAmount) * s,
      i - s
    );
  }
}
const c0 = ({ reservePrice: r, isToBeScraped: t }) => {
  const i = t || r < 5e3 ? 50 : r < 1e4 ? 100 : r < 5e4 ? 500 : 1e3, s = t ? 50 : r < 5e3 ? 100 : r < 1e4 ? 500 : (r < 5e4, 1e3), d = t ? 1e3 : r < 5e3 ? 5e3 : r < 1e4 ? 1e4 : 5e4, h = t ? 250 : r < 5e4 ? 1e3 : r < 1e5 ? 1500 : 2e3;
  return {
    minStepDefaultValue: i,
    maxStepDefaultValue: s,
    thresholdDefaultValue: d,
    bailDefaultValue: h
  };
};
function sr(r) {
  const t = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && t === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || t === "[object Number]" || typeof r == "string" || t === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function Nb(r, t) {
  const i = sr(r), s = sr(t);
  return i.getTime() > s.getTime();
}
function yb(r, t) {
  const i = sr(r), s = sr(t);
  return +i < +s;
}
function Eu(r, t) {
  const i = sr(r), s = sr(t);
  return +i == +s;
}
function Mi(r) {
  throw new Error("Should not have reached this line");
}
var en = /* @__PURE__ */ ((r) => (r.Seller = "Seller", r.Buyer = "Buyer", r))(en || {}), nn = /* @__PURE__ */ ((r) => (r.FixedPercentage = "FixedPercentage", r.FixedAmount = "FixedAmount", r.Standard = "Standard", r))(nn || {});
const kb = /* @__PURE__ */ new Date("2025-11-24"), Bb = /* @__PURE__ */ new Date("2025-11-28"), or = 250, gi = 0.0875, il = 0.0375, al = 5250, vi = 1e5, sl = 2500, Pb = (r, [t, i]) => (Eu(r, t) || Nb(r, t)) && (yb(r, i) || Eu(r, i)), ul = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: i,
  feeConfiguration: s
}) => {
  const d = {
    [en.Seller]: 1,
    [en.Buyer]: -1
  }[r], h = t / i;
  return (() => {
    if (!s || s.type === nn.Standard) {
      const C = sl - or * d;
      if (h <= C) return h + or * d;
      const w = vi - or * d - gi * vi * d;
      return h <= w ? (h + or * d) / (1 - gi * d) : (h + al * d) / (1 - il * d);
    }
    if (s.type === nn.FixedPercentage)
      return h / (1 - s.feeOverrideValue * d);
    if (s.type === nn.FixedAmount)
      return h + s.feeOverrideValue * d;
    Mi(s.type);
  })() * i;
}, p0 = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: i,
  referenceDate: s,
  feeConfiguration: d
}) => {
  const h = t / i, C = (() => {
    if (!d || d.type === nn.Standard)
      return h <= sl ? or : h <= vi ? or + gi * h : al + il * h;
    if (d.type === nn.FixedPercentage)
      return h * d.feeOverrideValue;
    if (d.type === nn.FixedAmount)
      return d.feeOverrideValue;
    Mi(d.type);
  })() * i, N = r === en.Buyer && s && Pb(s, [kb, Bb]) ? C * 0.5 : C;
  return {
    grossTotal: Math.ceil(r === en.Buyer ? t + C : t),
    grossNet: Math.ceil(r === en.Buyer ? t : t - C),
    grossFees: Math.ceil(C),
    total: Math.ceil(r === en.Buyer ? t + N : t),
    net: Math.ceil(r === en.Buyer ? t : t - N),
    fees: Math.ceil(N)
  };
}, f0 = ({
  sellerReservePrice: r,
  assetsCount: t,
  feeConfiguration: i
}) => {
  const s = Math.ceil(
    ul({
      feeTarget: en.Seller,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: i
    })
  );
  return {
    sellerReservePrice: r,
    fees: s - r,
    reservePrice: s
  };
}, h0 = ({
  buyerBudget: r,
  assetsCount: t,
  feeConfiguration: i
}) => {
  const s = Math.ceil(
    ul({
      feeTarget: en.Buyer,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: i
    })
  );
  return {
    buyerBudget: r,
    fees: r - s,
    buyerMaxOffer: s
  };
}, _0 = ({
  sellerReservePrice: r,
  feeConfiguration: t
}) => {
  const i = (() => {
    if (!t || t.type === nn.Standard)
      return r <= 2250 ? 250 : r <= 91e3 ? (r + 250) / 0.9125 : (r + 5250) / 0.9625;
    if (t.type === nn.FixedPercentage)
      return r / (1 - t.feeOverrideValue);
    if (t.type === nn.FixedAmount)
      return r + t.feeOverrideValue;
    Mi(t.type);
  })();
  return Math.ceil(i);
};
var Rb = /* @__PURE__ */ ((r) => (r.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", r.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", r.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", r.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", r.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", r))(Rb || {});
export {
  Cb as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  Qb as AdminUserPasswordResetTokenPayloadSchema,
  zb as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  Fb as BUS_ASSET_BASE_IMAGES,
  Ob as BUS_ASSET_COVER_IMAGES,
  xb as CUSTOMER_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  e0 as CustomerUserPasswordResetTokenPayloadSchema,
  $b as FILE_UPLOAD_EXTENSIONS,
  Ub as FILE_UPLOAD_PDF_MAX_SIZE,
  en as FeeTarget,
  nn as FeeType,
  bb as LanguageISO6391Schema,
  Jb as MAPBOX_API_CONFIG,
  Rb as PowertrainWarrantyIneligibilityReason,
  Lb as STEP_LOWEST_COMMON_DENOMINATOR,
  d0 as SaleSteppedPrice,
  o0 as adaptFormDataToDto,
  a0 as adaptMapboxFeatureToAddressBody,
  Yb as addressFormFieldSchema,
  h0 as computeBuyerMaxOfferAndFees,
  p0 as computeFees,
  _0 as computeReservePrice,
  c0 as computeSaleDefaultValues,
  f0 as computeSellerReservePriceAndFees,
  lg as countriesConfig,
  Nu as countryIso2List,
  Vb as customerServiceEmail,
  Xb as getAddressFormFieldSchema,
  Gb as getAsCountryISO2,
  Zb as getAsCountryISO3,
  Hb as getAsLanguageISO6391,
  qb as getAsTaxCodeOrigin,
  Mb as getAsTin,
  Db as getCountryISO3FromISO2,
  jb as getLanguage6391FromCountryIso2,
  i0 as initFormData,
  t0 as insertIf,
  dg as isCountryISO2,
  cg as isCountryISO3,
  l0 as isDbIntegerValidator,
  Tb as isTaxCodeOrigin,
  n0 as isTin,
  Wb as languageNames,
  r0 as parseAsTin,
  s0 as phoneValidator,
  Kb as provinces,
  Sb as taxCodeOriginList,
  u0 as vinValidator
};
//# sourceMappingURL=shared.mjs.map
